export const StationData={
    "ListAllBrands": {
        "ABB": 49,
        "ABICOR BINZEL": 4,
        "Adept": 2,
        "Agilebot": 2,
        "Alt-Bionics": 1,
        "API": 3,
        "ATI": 1,
        "AUBO": 4,
        "AUCTECH": 3,
        "autonox Robotics": 1,
        "BORUNTE": 1,
        "Brooks": 1,
        "Comau": 8,
        "Creaform": 1,
        "Delta Electronics": 2,
        "Denso": 3,
        "DIY Robotics": 2,
        "Dobot": 5,
        "Doosan Robotics": 9,
        "Elite Robots": 3,
        "Epson": 4,
        "Estun": 1,
        "FAIRINO": 5,
        "Fanuc": 35,
        "FerRobotics": 5,
        "Flexiv": 1,
        "Foxbot": 1,
        "Franka": 1,
        "Fronius": 8,
        "Gudel": 4,
        "Haas": 1,
        "Han's": 3,
        "Hanwha": 2,
        "HIWIN": 2,
        "Huayan Han's": 1,
        "Hyundai Robotics": 4,
        "igus": 3,
        "IIMT": 2,
        "INOVANCE": 1,
        "JAKA": 4,
        "Kassow Robots": 2,
        "Kawasaki": 5,
        "Kinova": 2,
        "KUKA": 39,
        "Leantec": 5,
        "Leica": 1,
        "Lorch": 2,
        "Lucas": 3,
        "MABI Robotic": 2,
        "Mazak": 4,
        "Mecademic": 5,
        "Mitsubishi": 3,
        "Nachi": 3,
        "Neura": 3,
        "Neuromeka": 1,
        "OBARA": 1,
        "Omron": 9,
        "OnRobot": 3,
        "OTC Daihen": 2,
        "Panasonic": 2,
        "Rainbow Robotics": 3,
        "Renishaw": 1,
        "RoboDK": 48,
        "Robostar": 3,
        "RobotiQ": 71,
        "Rokae": 4,
        "Schneider Electric": 4,
        "Shibaura Machine": 1,
        "Siasun": 2,
        "SICK": 3,
        "Standard Bots": 2,
        "Staubli": 8,
        "Techman Robot": 14,
        "Teknomotor": 13,
        "uFactory": 1,
        "Universal Robots": 32,
        "Yaskawa Motoman": 27,
        "Zimmer": 1,
        "Zivid": 1
    },
    "ListAllTags": {
        "3D Printing Project": 1,
        "API": 182,
        "Add-in": 10,
        "Ballbar Validation": 1,
        "CAM": 23,
        "CAM-Contouring": 1,
        "CAM-Multiaxis": 1,
        "CAM-Surface": 8,
        "CAM-Trimesh": 8,
        "Calibration Project": 7,
        "Camera": 3,
        "Curve Follow Project": 186,
        "Folder": 106,
        "Frame": 321,
        "Machining Project": 51,
        "Mechanism": 366,
        "Notes": 342,
        "Object": 318,
        "Palletizing Project": 10,
        "Point Follow Project": 6,
        "Program": 342,
        "Python": 182,
        "Script": 182,
        "Synchronization": 29,
        "Target": 153,
        "Tool": 358,
        "Template": 11,
        "Tutorial": 25,
        "Success Story": 8
    },
    "ListAllApplications": {
        "Additive Manufacturing": 3,
        "Assembly": 33,
        "Bending": 1,
        "Calibration": 9,
        "Collaborative": 118,
        "Conveying": 31,
        "Curve Following": 196,
        "Cutting": 6,
        "Deburring": 2,
        "Decanting": 1,
        "Dispensing": 80,
        "Drawing": 1,
        "Drilling": 11,
        "Grinding": 2,
        "HMI": 2,
        "Inspection": 14,
        "Machine Tending": 4,
        "Machining": 62,
        "Material Handling": 77,
        "Milling": 69,
        "Packaging": 4,
        "Painting": 9,
        "Palletizing": 18,
        "Polishing": 58,
        "Remote TCP": 6,
        "Sanding": 55,
        "Screwing": 2,
        "Spraying": 1,
        "Stamping": 1,
        "Synchronization": 34,
        "Taping": 2,
        "Tool Changing": 1,
        "Trimming": 2,
        "Washing": 1,
        "Weighing": 1,
        "Welding": 28
    },
    "ListAllRobotsTypes": {
        "6 DOF": 349,
        "7 DOF": 4,
        "AGV/AMR": 4,
        "Delta": 4,
        "Gripper": 52,
        "Mechanism": 122,
        "Palletizing": 3,
        "SCARA": 5
    },
    "robotMin": 0,
    "robotMax": 60,
    "toolsMin": 0,
    "toolsMax": 40,
    "objectsMin": 0,
    "objectsMax": 358,
    "sizeMin": 14.7,
    "sizeMax": 1532.1,
    "DATA_ALL": {
        "Additive-Manufacturing-and-Machining-with-ABB-IRB-120-3-0-6": {
            "N": "Additive Manufacturing and Machining with ABB IRB 120-3/0.6",
            "F": "Additive-Manufacturing-and-Machining-with-ABB-IRB-120-3-0-6.rdk",
            "I": "Additive-Manufacturing-and-Machining-with-ABB-IRB-120-3-0-6.png",
            "IS": "Additive-Manufacturing-and-Machining-with-ABB-IRB-120-3-0-6-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Additive Manufacturing",
                "Machining"
            ],
            "T": [
                "API",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 49.8,
            "RC": 1,
            "TC": 1,
            "OC": 2,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "ABB IRB 120-3/0.6"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Additive-Manufacturing-Machining-and-Synchronization-with-ABB": {
            "N": "Additive Manufacturing, Machining and Synchronization with ABB",
            "F": "Additive-Manufacturing-Machining-and-Synchronization-with-ABB.rdk",
            "I": "Additive-Manufacturing-Machining-and-Synchronization-with-ABB.png",
            "IS": "Additive-Manufacturing-Machining-and-Synchronization-with-ABB-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Additive Manufacturing",
                "Machining",
                "Synchronization"
            ],
            "T": [
                "Machining Project",
                "Mechanism",
                "Notes",
                "Program",
                "Synchronization",
                "Tool"
            ],
            "S": 257.7,
            "RC": 2,
            "TC": 1,
            "OC": 2,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "ABB IRB 6640-185/2.8"
            ],
            "AN": [
                "ABB IRBT 6004 Standard 3.5m"
            ],
            "TN": [
                "CEAD Extruder E40"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Additive-Manufacturing-with-ABB-IRB-120-3-0-6": {
            "N": "Additive Manufacturing with ABB IRB 120-3/0.6",
            "F": "Additive-Manufacturing-with-ABB-IRB-120-3-0-6.rdk",
            "I": "Additive-Manufacturing-with-ABB-IRB-120-3-0-6.png",
            "IS": "Additive-Manufacturing-with-ABB-IRB-120-3-0-6-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Additive Manufacturing"
            ],
            "T": [
                "3D Printing Project",
                "API",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 49.0,
            "RC": 1,
            "TC": 1,
            "OC": 2,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "ABB IRB 120-3/0.6"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-ABB": {
            "N": "Assembly and Material Handling with ABB",
            "F": "Assembly-and-Material-Handling-with-ABB.rdk",
            "I": "Assembly-and-Material-Handling-with-ABB.png",
            "IS": "Assembly-and-Material-Handling-with-ABB-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Assembly",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 239.1,
            "RC": 9,
            "TC": 5,
            "OC": 30,
            "RT": [
                "Delta",
                "Mechanism",
                "SCARA"
            ],
            "RN": [
                "ABB IRB 360-1/800 4D",
                "ABB IRB 910SC-3/0.65"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Assembly-and-Material-Handling-with-ABB-and-Fanuc": {
            "N": "Assembly and Material Handling with ABB and Fanuc",
            "F": "Assembly-and-Material-Handling-with-ABB-and-Fanuc.rdk",
            "I": "Assembly-and-Material-Handling-with-ABB-and-Fanuc.png",
            "IS": "Assembly-and-Material-Handling-with-ABB-and-Fanuc-sm.png",
            "B": [
                "ABB",
                "Fanuc"
            ],
            "AP": [
                "Assembly",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 253.1,
            "RC": 9,
            "TC": 2,
            "OC": 45,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "ABB IRB 2600-12/1.85",
                "Fanuc LR Mate 200iD/4S"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Assembly-and-Material-Handling-with-ABB-IRB-120-3-0-6": {
            "N": "Assembly and Material Handling with ABB IRB 120-3/0.6",
            "F": "Assembly-and-Material-Handling-with-ABB-IRB-120-3-0-6.rdk",
            "I": "Assembly-and-Material-Handling-with-ABB-IRB-120-3-0-6.png",
            "IS": "Assembly-and-Material-Handling-with-ABB-IRB-120-3-0-6-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Assembly",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Mechanism",
                "Notes",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 48.2,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "ABB IRB 120-3/0.6"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-Adept-Viper-s650": {
            "N": "Assembly and Material Handling with Adept Viper s650",
            "F": "Assembly-and-Material-Handling-with-Adept-Viper-s650.rdk",
            "I": "Assembly-and-Material-Handling-with-Adept-Viper-s650.png",
            "IS": "Assembly-and-Material-Handling-with-Adept-Viper-s650-sm.png",
            "B": [
                "Adept"
            ],
            "AP": [
                "Assembly",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 51.3,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "Adept Viper s650"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-AUBO-i3": {
            "N": "Assembly and Material Handling with AUBO-i3",
            "F": "Assembly-and-Material-Handling-with-AUBO-i3.rdk",
            "I": "Assembly-and-Material-Handling-with-AUBO-i3.png",
            "IS": "Assembly-and-Material-Handling-with-AUBO-i3-sm.png",
            "B": [
                "AUBO"
            ],
            "AP": [
                "Assembly",
                "Collaborative",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 46.3,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "AUBO-i3"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-AUCTECH-X3-618": {
            "N": "Assembly and Material Handling with AUCTECH X3-618",
            "F": "Assembly-and-Material-Handling-with-AUCTECH-X3-618.rdk",
            "I": "Assembly-and-Material-Handling-with-AUCTECH-X3-618.png",
            "IS": "Assembly-and-Material-Handling-with-AUCTECH-X3-618-sm.png",
            "B": [
                "AUCTECH"
            ],
            "AP": [
                "Assembly",
                "Collaborative",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 46.3,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "AUCTECH X3-618"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-Comau": {
            "N": "Assembly and Material Handling with Comau",
            "F": "Assembly-and-Material-Handling-with-Comau.rdk",
            "I": "Assembly-and-Material-Handling-with-Comau.png",
            "IS": "Assembly-and-Material-Handling-with-Comau-sm.png",
            "B": [
                "Comau"
            ],
            "AP": [
                "Assembly",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 253.7,
            "RC": 9,
            "TC": 2,
            "OC": 46,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "Comau NS 12-1.85",
                "Comau Racer 5-0.80"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Assembly-and-Material-Handling-with-Denso-Cobotta-PRO-900": {
            "N": "Assembly and Material Handling with Denso Cobotta PRO 900",
            "F": "Assembly-and-Material-Handling-with-Denso-Cobotta-PRO-900.rdk",
            "I": "Assembly-and-Material-Handling-with-Denso-Cobotta-PRO-900.png",
            "IS": "Assembly-and-Material-Handling-with-Denso-Cobotta-PRO-900-sm.png",
            "B": [
                "Denso"
            ],
            "AP": [
                "Assembly",
                "Collaborative",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 51.4,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "Denso Cobotta PRO 900"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-Dobot-CR3": {
            "N": "Assembly and Material Handling with Dobot CR3",
            "F": "Assembly-and-Material-Handling-with-Dobot-CR3.rdk",
            "I": "Assembly-and-Material-Handling-with-Dobot-CR3.png",
            "IS": "Assembly-and-Material-Handling-with-Dobot-CR3-sm.png",
            "B": [
                "Dobot"
            ],
            "AP": [
                "Assembly",
                "Collaborative",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 46.0,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "Dobot CR3"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-Elite-Robots-CS63": {
            "N": "Assembly and Material Handling with Elite Robots CS63",
            "F": "Assembly-and-Material-Handling-with-Elite-Robots-CS63.rdk",
            "I": "Assembly-and-Material-Handling-with-Elite-Robots-CS63.png",
            "IS": "Assembly-and-Material-Handling-with-Elite-Robots-CS63-sm.png",
            "B": [
                "Elite Robots"
            ],
            "AP": [
                "Assembly",
                "Collaborative",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 46.3,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "Elite Robots CS63"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-Epson-C3": {
            "N": "Assembly and Material Handling with Epson C3",
            "F": "Assembly-and-Material-Handling-with-Epson-C3.rdk",
            "I": "Assembly-and-Material-Handling-with-Epson-C3.png",
            "IS": "Assembly-and-Material-Handling-with-Epson-C3-sm.png",
            "B": [
                "Epson"
            ],
            "AP": [
                "Assembly",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 49.3,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "Epson C3"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-FAIRINO-FR3": {
            "N": "Assembly and Material Handling with FAIRINO FR3",
            "F": "Assembly-and-Material-Handling-with-FAIRINO-FR3.rdk",
            "I": "Assembly-and-Material-Handling-with-FAIRINO-FR3.png",
            "IS": "Assembly-and-Material-Handling-with-FAIRINO-FR3-sm.png",
            "B": [
                "FAIRINO"
            ],
            "AP": [
                "Assembly",
                "Collaborative",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 46.2,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "FAIRINO FR3"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-Hyundai-HH4": {
            "N": "Assembly and Material Handling with Hyundai HH4",
            "F": "Assembly-and-Material-Handling-with-Hyundai-HH4.rdk",
            "I": "Assembly-and-Material-Handling-with-Hyundai-HH4.png",
            "IS": "Assembly-and-Material-Handling-with-Hyundai-HH4-sm.png",
            "B": [
                "Hyundai Robotics"
            ],
            "AP": [
                "Assembly",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 49.5,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "Hyundai HH4"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-igus-ReBeL-6DOF": {
            "N": "Assembly and Material Handling with igus ReBeL 6DOF",
            "F": "Assembly-and-Material-Handling-with-igus-ReBeL-6DOF.rdk",
            "I": "Assembly-and-Material-Handling-with-igus-ReBeL-6DOF.png",
            "IS": "Assembly-and-Material-Handling-with-igus-ReBeL-6DOF-sm.png",
            "B": [
                "igus"
            ],
            "AP": [
                "Assembly",
                "Collaborative",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 47.5,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "igus ReBeL 6DOF"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-INOVANCE-IR-R4-56S5": {
            "N": "Assembly and Material Handling with INOVANCE IR-R4-56S5",
            "F": "Assembly-and-Material-Handling-with-INOVANCE-IR-R4-56S5.rdk",
            "I": "Assembly-and-Material-Handling-with-INOVANCE-IR-R4-56S5.png",
            "IS": "Assembly-and-Material-Handling-with-INOVANCE-IR-R4-56S5-sm.png",
            "B": [
                "INOVANCE"
            ],
            "AP": [
                "Assembly",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 49.7,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "INOVANCE IR-R4-56S5"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-JAKA-Zu3": {
            "N": "Assembly and Material Handling with JAKA Zu3",
            "F": "Assembly-and-Material-Handling-with-JAKA-Zu3.rdk",
            "I": "Assembly-and-Material-Handling-with-JAKA-Zu3.png",
            "IS": "Assembly-and-Material-Handling-with-JAKA-Zu3-sm.png",
            "B": [
                "JAKA"
            ],
            "AP": [
                "Assembly",
                "Collaborative",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 46.7,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "JAKA Zu3"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-Kawasaki-RS03N": {
            "N": "Assembly and Material Handling with Kawasaki RS03N",
            "F": "Assembly-and-Material-Handling-with-Kawasaki-RS03N.rdk",
            "I": "Assembly-and-Material-Handling-with-Kawasaki-RS03N.png",
            "IS": "Assembly-and-Material-Handling-with-Kawasaki-RS03N-sm.png",
            "B": [
                "Kawasaki"
            ],
            "AP": [
                "Assembly",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 48.1,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "Kawasaki RS03N"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-KUKA-KR-3-R540": {
            "N": "Assembly and Material Handling with KUKA KR 3 R540",
            "F": "Assembly-and-Material-Handling-with-KUKA-KR-3-R540.rdk",
            "I": "Assembly-and-Material-Handling-with-KUKA-KR-3-R540.png",
            "IS": "Assembly-and-Material-Handling-with-KUKA-KR-3-R540-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Assembly",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 49.9,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "KUKA KR 3 R540"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-KUKA-KR5-scara-R550-Z200": {
            "N": "Assembly and Material Handling with KUKA KR5 scara R550 Z200",
            "F": "Assembly-and-Material-Handling-with-KUKA-KR5-scara-R550-Z200.rdk",
            "I": "Assembly-and-Material-Handling-with-KUKA-KR5-scara-R550-Z200.png",
            "IS": "Assembly-and-Material-Handling-with-KUKA-KR5-scara-R550-Z200-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Assembly",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 50.0,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "Gripper",
                "Mechanism",
                "SCARA"
            ],
            "RN": [
                "KUKA KR5 scara R550 Z200"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-Leantec-LA596-4H-R": {
            "N": "Assembly and Material Handling with Leantec LA596-4H-R",
            "F": "Assembly-and-Material-Handling-with-Leantec-LA596-4H-R.rdk",
            "I": "Assembly-and-Material-Handling-with-Leantec-LA596-4H-R.png",
            "IS": "Assembly-and-Material-Handling-with-Leantec-LA596-4H-R-sm.png",
            "B": [
                "Leantec"
            ],
            "AP": [
                "Assembly",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 50.2,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "Leantec LA596-4H-R"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-Mitsubishi-RV-2F": {
            "N": "Assembly and Material Handling with Mitsubishi RV-2F",
            "F": "Assembly-and-Material-Handling-with-Mitsubishi-RV-2F.rdk",
            "I": "Assembly-and-Material-Handling-with-Mitsubishi-RV-2F.png",
            "IS": "Assembly-and-Material-Handling-with-Mitsubishi-RV-2F-sm.png",
            "B": [
                "Mitsubishi"
            ],
            "AP": [
                "Assembly",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 48.8,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "Mitsubishi RV-2F"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-Nachi-MZ04-01": {
            "N": "Assembly and Material Handling with Nachi MZ04-01",
            "F": "Assembly-and-Material-Handling-with-Nachi-MZ04-01.rdk",
            "I": "Assembly-and-Material-Handling-with-Nachi-MZ04-01.png",
            "IS": "Assembly-and-Material-Handling-with-Nachi-MZ04-01-sm.png",
            "B": [
                "Nachi"
            ],
            "AP": [
                "Assembly",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 50.0,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "Nachi MZ04-01"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-Neura-LARA-3": {
            "N": "Assembly and Material Handling with Neura LARA 3",
            "F": "Assembly-and-Material-Handling-with-Neura-LARA-3.rdk",
            "I": "Assembly-and-Material-Handling-with-Neura-LARA-3.png",
            "IS": "Assembly-and-Material-Handling-with-Neura-LARA-3-sm.png",
            "B": [
                "Neura"
            ],
            "AP": [
                "Assembly",
                "Collaborative",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 46.9,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "Neura LARA 3"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-Neuromeka-INDY7-V2": {
            "N": "Assembly and Material Handling with Neuromeka INDY7 V2",
            "F": "Assembly-and-Material-Handling-with-Neuromeka-INDY7-V2.rdk",
            "I": "Assembly-and-Material-Handling-with-Neuromeka-INDY7-V2.png",
            "IS": "Assembly-and-Material-Handling-with-Neuromeka-INDY7-V2-sm.png",
            "B": [
                "Neuromeka"
            ],
            "AP": [
                "Assembly",
                "Collaborative",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 52.0,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "Neuromeka INDY7 V2"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-Robostar-RA004": {
            "N": "Assembly and Material Handling with Robostar RA004",
            "F": "Assembly-and-Material-Handling-with-Robostar-RA004.rdk",
            "I": "Assembly-and-Material-Handling-with-Robostar-RA004.png",
            "IS": "Assembly-and-Material-Handling-with-Robostar-RA004-sm.png",
            "B": [
                "Robostar"
            ],
            "AP": [
                "Assembly",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 50.0,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "Robostar RA004"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-Rokae-XB4": {
            "N": "Assembly and Material Handling with Rokae XB4",
            "F": "Assembly-and-Material-Handling-with-Rokae-XB4.rdk",
            "I": "Assembly-and-Material-Handling-with-Rokae-XB4.png",
            "IS": "Assembly-and-Material-Handling-with-Rokae-XB4-sm.png",
            "B": [
                "Rokae"
            ],
            "AP": [
                "Assembly",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 49.9,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "Rokae XB4"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-Schneider-Electric-Lexium-Cobot-LXMRL03S0000": {
            "N": "Assembly and Material Handling with Schneider Electric Lexium Cobot LXMRL03S0000",
            "F": "Assembly-and-Material-Handling-with-Schneider-Electric-Lexium-Cobot-LXMRL03S0000.rdk",
            "I": "Assembly-and-Material-Handling-with-Schneider-Electric-Lexium-Cobot-LXMRL03S0000.png",
            "IS": "Assembly-and-Material-Handling-with-Schneider-Electric-Lexium-Cobot-LXMRL03S0000-sm.png",
            "B": [
                "Schneider Electric"
            ],
            "AP": [
                "Assembly",
                "Collaborative",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 46.6,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "Schneider Electric Lexium Cobot LXMRL03S0000"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-Staubli-TX2-40": {
            "N": "Assembly and Material Handling with Staubli TX2-40",
            "F": "Assembly-and-Material-Handling-with-Staubli-TX2-40.rdk",
            "I": "Assembly-and-Material-Handling-with-Staubli-TX2-40.png",
            "IS": "Assembly-and-Material-Handling-with-Staubli-TX2-40-sm.png",
            "B": [
                "Staubli"
            ],
            "AP": [
                "Assembly",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 49.0,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "Staubli TX2-40"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-TM5X-700": {
            "N": "Assembly and Material Handling with TM5X-700",
            "F": "Assembly-and-Material-Handling-with-TM5X-700.rdk",
            "I": "Assembly-and-Material-Handling-with-TM5X-700.png",
            "IS": "Assembly-and-Material-Handling-with-TM5X-700-sm.png",
            "B": [
                "Techman Robot"
            ],
            "AP": [
                "Assembly",
                "Collaborative",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 46.9,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "TM5X-700"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Material-Handling-with-Yaskawa-GP4": {
            "N": "Assembly and Material Handling with Yaskawa GP4",
            "F": "Assembly-and-Material-Handling-with-Yaskawa-GP4.rdk",
            "I": "Assembly-and-Material-Handling-with-Yaskawa-GP4.png",
            "IS": "Assembly-and-Material-Handling-with-Yaskawa-GP4-sm.png",
            "B": [
                "Yaskawa Motoman"
            ],
            "AP": [
                "Assembly",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 49.6,
            "RC": 3,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "Yaskawa GP4"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Assembly-and-Palletizing-with-ABB-and-Fanuc": {
            "N": "Assembly and Palletizing with ABB and Fanuc",
            "F": "Assembly-and-Palletizing-with-ABB-and-Fanuc.rdk",
            "I": "Assembly-and-Palletizing-with-ABB-and-Fanuc.png",
            "IS": "Assembly-and-Palletizing-with-ABB-and-Fanuc-sm.png",
            "B": [
                "ABB",
                "Fanuc"
            ],
            "AP": [
                "Assembly",
                "Palletizing"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 382.4,
            "RC": 23,
            "TC": 14,
            "OC": 160,
            "RT": [
                "6 DOF",
                "Delta",
                "Gripper",
                "Mechanism",
                "SCARA"
            ],
            "RN": [
                "ABB IRB 2400/16",
                "ABB IRB 2600-12/1.85",
                "ABB IRB 360-1/800 4D",
                "ABB IRB 910SC-3/0.65",
                "Fanuc LR Mate 200iD/4S",
                "Fanuc R-1000iA/80F"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Assembly-with-ABB-IRB-2400-16": {
            "N": "Assembly with ABB IRB 2400/16",
            "F": "Assembly-with-ABB-IRB-2400-16.rdk",
            "I": "Assembly-with-ABB-IRB-2400-16.png",
            "IS": "Assembly-with-ABB-IRB-2400-16-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Assembly"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 222.6,
            "RC": 7,
            "TC": 2,
            "OC": 106,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "ABB IRB 2400/16"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Bending-Palletizing-and-Synchronization-with-Yaskawa-MH24": {
            "N": "Bending, Palletizing and Synchronization with Yaskawa MH24",
            "F": "Bending-Palletizing-and-Synchronization-with-Yaskawa-MH24.rdk",
            "I": "Bending-Palletizing-and-Synchronization-with-Yaskawa-MH24.png",
            "IS": "Bending-Palletizing-and-Synchronization-with-Yaskawa-MH24-sm.png",
            "B": [
                "Yaskawa Motoman"
            ],
            "AP": [
                "Bending",
                "Palletizing",
                "Synchronization"
            ],
            "T": [
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Synchronization",
                "Target",
                "Tool"
            ],
            "S": 193.5,
            "RC": 14,
            "TC": 4,
            "OC": 11,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "Yaskawa MH24"
            ],
            "ON": [
                "Floor",
                "Pallet 48x48in",
                "Pedestal H500mm (Type 2)"
            ]
        },
        "Calibration-and-Dispensing-with-KUKA-KR-30-R2100": {
            "N": "Calibration and Dispensing with KUKA KR 30 R2100",
            "F": "Calibration-and-Dispensing-with-KUKA-KR-30-R2100.rdk",
            "I": "Calibration-and-Dispensing-with-KUKA-KR-30-R2100.png",
            "IS": "Calibration-and-Dispensing-with-KUKA-KR-30-R2100-sm.png",
            "B": [
                "KUKA",
                "Leica"
            ],
            "AP": [
                "Calibration",
                "Dispensing"
            ],
            "T": [
                "API",
                "Calibration Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 184.8,
            "RC": 1,
            "TC": 4,
            "OC": 9,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "KUKA KR 30 R2100"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Calibration-and-Inspection-with-UR5e": {
            "N": "Calibration and Inspection with UR5e",
            "F": "Calibration-and-Inspection-with-UR5e.rdk",
            "I": "Calibration-and-Inspection-with-UR5e.png",
            "IS": "Calibration-and-Inspection-with-UR5e-sm.png",
            "B": [
                "Universal Robots",
                "Zivid"
            ],
            "AP": [
                "Calibration",
                "Collaborative",
                "Inspection"
            ],
            "T": [
                "Camera",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 37.6,
            "RC": 1,
            "TC": 10,
            "OC": 1,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "UR5e"
            ],
            "TN": [
                "Zivid On-Arm Extender OA01E",
                "Zivid On-Arm Extender OA02E",
                "Zivid On-Arm Mount OA10",
                "Zivid On-Arm Mount OA111",
                "Zivid On-Arm Mount OA121",
                "Zivid On-Arm Mount OA211",
                "Zivid On-Arm Mount OA221",
                "Zivid Pointed Hand-Eye Verification Tool",
                "Zivid Two Camera",
                "Zivid Two Field-of-view"
            ],
            "ON": [
                "Zivid ZVDA-CB01 Calibration Board"
            ]
        },
        "Calibration-Curve-Following-and-Material-Handling-with-Mecademic-Meca500-R3": {
            "N": "Calibration, Curve Following and Material Handling with Mecademic Meca500 R3",
            "F": "Calibration-Curve-Following-and-Material-Handling-with-Mecademic-Meca500-R3.rdk",
            "I": "Calibration-Curve-Following-and-Material-Handling-with-Mecademic-Meca500-R3.png",
            "IS": "Calibration-Curve-Following-and-Material-Handling-with-Mecademic-Meca500-R3-sm.png",
            "B": [
                "Mecademic"
            ],
            "AP": [
                "Calibration",
                "Curve Following",
                "Material Handling"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 68.7,
            "RC": 3,
            "TC": 6,
            "OC": 22,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "Mecademic Meca500 R3"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Calibration-with-Comau-Smart5-NJ-165-3-4-SH": {
            "N": "Calibration with Comau Smart5 NJ 165-3.4 SH",
            "F": "Calibration-with-Comau-Smart5-NJ-165-3-4-SH.rdk",
            "I": "Calibration-with-Comau-Smart5-NJ-165-3-4-SH.png",
            "IS": "Calibration-with-Comau-Smart5-NJ-165-3-4-SH-sm.png",
            "B": [
                "Comau"
            ],
            "AP": [
                "Calibration"
            ],
            "T": [
                "API",
                "Calibration Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 130.4,
            "RC": 1,
            "TC": 1,
            "OC": 1,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Comau Smart5 NJ 165-3.4 SH"
            ]
        },
        "Calibration-with-KUKA-KR-6-R700-sixx": {
            "N": "Calibration with KUKA KR 6 R700 sixx",
            "F": "Calibration-with-KUKA-KR-6-R700-sixx.rdk",
            "I": "Calibration-with-KUKA-KR-6-R700-sixx.png",
            "IS": "Calibration-with-KUKA-KR-6-R700-sixx-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Calibration"
            ],
            "T": [
                "Calibration Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Tool"
            ],
            "S": 78.3,
            "RC": 1,
            "TC": 4,
            "OC": 2,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "KUKA KR 6 R700 sixx"
            ]
        },
        "Calibration-with-Mecademic-Meca500-R3": {
            "N": "Calibration with Mecademic Meca500 R3",
            "F": "Calibration-with-Mecademic-Meca500-R3.rdk",
            "I": "Calibration-with-Mecademic-Meca500-R3.png",
            "IS": "Calibration-with-Mecademic-Meca500-R3-sm.png",
            "B": [
                "Mecademic"
            ],
            "AP": [
                "Calibration"
            ],
            "T": [
                "API",
                "Calibration Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 32.9,
            "RC": 1,
            "TC": 3,
            "OC": 1,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Mecademic Meca500 R3"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Calibration-with-UR10": {
            "N": "Calibration with UR10",
            "F": "Calibration-with-UR10.rdk",
            "I": "Calibration-with-UR10.png",
            "IS": "Calibration-with-UR10-sm.png",
            "B": [
                "Universal Robots"
            ],
            "AP": [
                "Calibration",
                "Collaborative"
            ],
            "T": [
                "API",
                "Calibration Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 89.5,
            "RC": 1,
            "TC": 5,
            "OC": 2,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "UR10"
            ]
        },
        "Calibration-with-UR10-02": {
            "N": "Calibration with UR10 #02",
            "F": "Calibration-with-UR10-02.rdk",
            "I": "Calibration-with-UR10-02.png",
            "IS": "Calibration-with-UR10-02-sm.png",
            "B": [
                "RoboDK",
                "Universal Robots"
            ],
            "AP": [
                "Calibration",
                "Collaborative"
            ],
            "T": [
                "API",
                "Calibration Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 183.7,
            "RC": 1,
            "TC": 1,
            "OC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "UR10"
            ]
        },
        "CAM-Contouring-Machining": {
            "N": "CAM Contouring Machining",
            "F": "CAM-Contouring-Machining.rdk",
            "I": "CAM-Contouring-Machining.png",
            "IS": "CAM-Contouring-Machining-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "TCM": [
                "Contouring"
            ],
            "T": [
                "CAM",
                "CAM-Contouring",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Program",
                "Tool"
            ],
            "S": 76.2,
            "RC": 1,
            "TC": 2,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-2200"
            ]
        },
        "CAM-Deburring-Machining": {
            "N": "CAM Deburring Machining",
            "F": "CAM-Deburring-Machining.rdk",
            "I": "CAM-Deburring-Machining.png",
            "IS": "CAM-Deburring-Machining-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "TCM": [
                "Deburring"
            ],
            "T": [
                "CAM",
                "Machining Project",
                "Mechanism",
                "Program",
                "Tool"
            ],
            "S": 74.1,
            "RC": 1,
            "TC": 2,
            "OC": 1,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-2200"
            ]
        },
        "CAM-Drilling-Machining": {
            "N": "CAM Drilling Machining",
            "F": "CAM-Drilling-Machining.rdk",
            "I": "CAM-Drilling-Machining.png",
            "IS": "CAM-Drilling-Machining-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "TCM": [
                "Drilling"
            ],
            "T": [
                "CAM",
                "Machining Project",
                "Mechanism",
                "Program",
                "Tool"
            ],
            "S": 73.4,
            "RC": 1,
            "TC": 2,
            "OC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-2200"
            ]
        },
        "CAM-Geodesic-Machining": {
            "N": "CAM Geodesic Machining",
            "F": "CAM-Geodesic-Machining.rdk",
            "I": "CAM-Geodesic-Machining.png",
            "IS": "CAM-Geodesic-Machining-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "TCM": [
                "Geodesic"
            ],
            "T": [
                "CAM",
                "Machining Project",
                "Mechanism",
                "Program",
                "Tool"
            ],
            "S": 73.0,
            "RC": 1,
            "TC": 2,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-2200"
            ]
        },
        "CAM-Geodesic-Machining-02": {
            "N": "CAM Geodesic Machining #02",
            "F": "CAM-Geodesic-Machining-02.rdk",
            "I": "CAM-Geodesic-Machining-02.png",
            "IS": "CAM-Geodesic-Machining-02-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Machining",
                "Milling",
                "Synchronization"
            ],
            "TCM": [
                "Geodesic"
            ],
            "T": [
                "CAM",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Synchronization",
                "Target",
                "Tool"
            ],
            "S": 108.5,
            "RC": 2,
            "TC": 2,
            "OC": 2,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "RoboDK RDK-2200"
            ],
            "ON": [
                "Floor"
            ]
        },
        "CAM-Multiaxis-Machining": {
            "N": "CAM Multiaxis Machining",
            "F": "CAM-Multiaxis-Machining.rdk",
            "I": "CAM-Multiaxis-Machining.png",
            "IS": "CAM-Multiaxis-Machining-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "TCM": [
                "Multiaxis"
            ],
            "T": [
                "CAM",
                "CAM-Multiaxis",
                "Machining Project",
                "Mechanism",
                "Program",
                "Tool"
            ],
            "S": 73.9,
            "RC": 1,
            "TC": 2,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-2200"
            ]
        },
        "CAM-Surface-Between-curves-Machining": {
            "N": "CAM Surface Between curves Machining",
            "F": "CAM-Surface-Between-curves-Machining.rdk",
            "I": "CAM-Surface-Between-curves-Machining.png",
            "IS": "CAM-Surface-Between-curves-Machining-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "TCM": [
                "Surface Between curves"
            ],
            "T": [
                "CAM",
                "CAM-Surface",
                "Machining Project",
                "Mechanism",
                "Program",
                "Tool"
            ],
            "S": 76.3,
            "RC": 1,
            "TC": 2,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-2200"
            ]
        },
        "CAM-Surface-Between-surfaces-Machining": {
            "N": "CAM Surface Between surfaces Machining",
            "F": "CAM-Surface-Between-surfaces-Machining.rdk",
            "I": "CAM-Surface-Between-surfaces-Machining.png",
            "IS": "CAM-Surface-Between-surfaces-Machining-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "TCM": [
                "Surface Between surfaces"
            ],
            "T": [
                "CAM",
                "CAM-Surface",
                "Machining Project",
                "Mechanism",
                "Program",
                "Tool"
            ],
            "S": 75.6,
            "RC": 1,
            "TC": 2,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-2200"
            ]
        },
        "CAM-Surface-Curve-cut-Machining": {
            "N": "CAM Surface Curve cut Machining",
            "F": "CAM-Surface-Curve-cut-Machining.rdk",
            "I": "CAM-Surface-Curve-cut-Machining.png",
            "IS": "CAM-Surface-Curve-cut-Machining-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "TCM": [
                "Surface Curve cut"
            ],
            "T": [
                "CAM",
                "CAM-Surface",
                "Machining Project",
                "Mechanism",
                "Program",
                "Tool"
            ],
            "S": 76.4,
            "RC": 1,
            "TC": 2,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-2200"
            ]
        },
        "CAM-Surface-Flowline-cut-Machining": {
            "N": "CAM Surface Flowline cut Machining",
            "F": "CAM-Surface-Flowline-cut-Machining.rdk",
            "I": "CAM-Surface-Flowline-cut-Machining.png",
            "IS": "CAM-Surface-Flowline-cut-Machining-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "TCM": [
                "Surface Flowline cut"
            ],
            "T": [
                "CAM",
                "CAM-Surface",
                "Machining Project",
                "Mechanism",
                "Program",
                "Tool"
            ],
            "S": 75.8,
            "RC": 1,
            "TC": 2,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-2200"
            ]
        },
        "CAM-Surface-Parallel-curve-Machining": {
            "N": "CAM Surface Parallel curve Machining",
            "F": "CAM-Surface-Parallel-curve-Machining.rdk",
            "I": "CAM-Surface-Parallel-curve-Machining.png",
            "IS": "CAM-Surface-Parallel-curve-Machining-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "TCM": [
                "Surface Parallel curve"
            ],
            "T": [
                "CAM",
                "CAM-Surface",
                "Machining Project",
                "Mechanism",
                "Program",
                "Tool"
            ],
            "S": 76.3,
            "RC": 1,
            "TC": 2,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-2200"
            ]
        },
        "CAM-Surface-Parallel-cut-Machining": {
            "N": "CAM Surface Parallel cut Machining",
            "F": "CAM-Surface-Parallel-cut-Machining.rdk",
            "I": "CAM-Surface-Parallel-cut-Machining.png",
            "IS": "CAM-Surface-Parallel-cut-Machining-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "TCM": [
                "Surface Parallel cut"
            ],
            "T": [
                "CAM",
                "CAM-Surface",
                "Machining Project",
                "Mechanism",
                "Program",
                "Tool"
            ],
            "S": 77.6,
            "RC": 1,
            "TC": 2,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-2200"
            ]
        },
        "CAM-Surface-Parallel-surface-Machining": {
            "N": "CAM Surface Parallel surface Machining",
            "F": "CAM-Surface-Parallel-surface-Machining.rdk",
            "I": "CAM-Surface-Parallel-surface-Machining.png",
            "IS": "CAM-Surface-Parallel-surface-Machining-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "TCM": [
                "Surface Parallel surface"
            ],
            "T": [
                "CAM",
                "CAM-Surface",
                "Machining Project",
                "Mechanism",
                "Program",
                "Tool"
            ],
            "S": 75.6,
            "RC": 1,
            "TC": 2,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-2200"
            ]
        },
        "CAM-Surface-Project-curve-Machining": {
            "N": "CAM Surface Project curve Machining",
            "F": "CAM-Surface-Project-curve-Machining.rdk",
            "I": "CAM-Surface-Project-curve-Machining.png",
            "IS": "CAM-Surface-Project-curve-Machining-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "TCM": [
                "Surface Project curve"
            ],
            "T": [
                "CAM",
                "CAM-Surface",
                "Machining Project",
                "Mechanism",
                "Program",
                "Tool"
            ],
            "S": 76.0,
            "RC": 1,
            "TC": 2,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-2200"
            ]
        },
        "CAM-Trimesh-Constant-cusp-Machining": {
            "N": "CAM Trimesh Constant cusp Machining",
            "F": "CAM-Trimesh-Constant-cusp-Machining.rdk",
            "I": "CAM-Trimesh-Constant-cusp-Machining.png",
            "IS": "CAM-Trimesh-Constant-cusp-Machining-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "TCM": [
                "Trimesh Constant cusp"
            ],
            "T": [
                "CAM",
                "CAM-Trimesh",
                "Machining Project",
                "Mechanism",
                "Program",
                "Tool"
            ],
            "S": 76.2,
            "RC": 1,
            "TC": 2,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-2200"
            ]
        },
        "CAM-Trimesh-Constant-Z-Machining": {
            "N": "CAM Trimesh Constant Z Machining",
            "F": "CAM-Trimesh-Constant-Z-Machining.rdk",
            "I": "CAM-Trimesh-Constant-Z-Machining.png",
            "IS": "CAM-Trimesh-Constant-Z-Machining-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "TCM": [
                "Trimesh Constant Z"
            ],
            "T": [
                "CAM",
                "CAM-Trimesh",
                "Machining Project",
                "Mechanism",
                "Program",
                "Tool"
            ],
            "S": 76.3,
            "RC": 1,
            "TC": 2,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-2200"
            ]
        },
        "CAM-Trimesh-Flatlands-Machining": {
            "N": "CAM Trimesh Flatlands Machining",
            "F": "CAM-Trimesh-Flatlands-Machining.rdk",
            "I": "CAM-Trimesh-Flatlands-Machining.png",
            "IS": "CAM-Trimesh-Flatlands-Machining-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "TCM": [
                "Trimesh Flatlands"
            ],
            "T": [
                "CAM",
                "CAM-Trimesh",
                "Machining Project",
                "Mechanism",
                "Program",
                "Tool"
            ],
            "S": 75.5,
            "RC": 1,
            "TC": 2,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-2200"
            ]
        },
        "CAM-Trimesh-Parallel-cuts-Machining": {
            "N": "CAM Trimesh Parallel cuts Machining",
            "F": "CAM-Trimesh-Parallel-cuts-Machining.rdk",
            "I": "CAM-Trimesh-Parallel-cuts-Machining.png",
            "IS": "CAM-Trimesh-Parallel-cuts-Machining-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "TCM": [
                "Trimesh Parallel cuts"
            ],
            "T": [
                "CAM",
                "CAM-Trimesh",
                "Machining Project",
                "Mechanism",
                "Program",
                "Tool"
            ],
            "S": 77.6,
            "RC": 1,
            "TC": 2,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-2200"
            ]
        },
        "CAM-Trimesh-Pencil-Machining": {
            "N": "CAM Trimesh Pencil Machining",
            "F": "CAM-Trimesh-Pencil-Machining.rdk",
            "I": "CAM-Trimesh-Pencil-Machining.png",
            "IS": "CAM-Trimesh-Pencil-Machining-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "TCM": [
                "Trimesh Pencil"
            ],
            "T": [
                "CAM",
                "CAM-Trimesh",
                "Machining Project",
                "Mechanism",
                "Program",
                "Tool"
            ],
            "S": 76.0,
            "RC": 1,
            "TC": 2,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-2200"
            ]
        },
        "CAM-Trimesh-Project-curves-Machining": {
            "N": "CAM Trimesh Project curves Machining",
            "F": "CAM-Trimesh-Project-curves-Machining.rdk",
            "I": "CAM-Trimesh-Project-curves-Machining.png",
            "IS": "CAM-Trimesh-Project-curves-Machining-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "TCM": [
                "Trimesh Project curves"
            ],
            "T": [
                "CAM",
                "CAM-Trimesh",
                "Machining Project",
                "Mechanism",
                "Program",
                "Tool"
            ],
            "S": 76.2,
            "RC": 1,
            "TC": 2,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-2200"
            ]
        },
        "CAM-Trimesh-Rough-Machining": {
            "N": "CAM Trimesh Rough Machining",
            "F": "CAM-Trimesh-Rough-Machining.rdk",
            "I": "CAM-Trimesh-Rough-Machining.png",
            "IS": "CAM-Trimesh-Rough-Machining-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "TCM": [
                "Trimesh Rough"
            ],
            "T": [
                "CAM",
                "CAM-Trimesh",
                "Machining Project",
                "Mechanism",
                "Program",
                "Tool"
            ],
            "S": 77.6,
            "RC": 1,
            "TC": 2,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-2200"
            ]
        },
        "CAM-Trimesh-Trochoidal-Machining": {
            "N": "CAM Trimesh Trochoidal Machining",
            "F": "CAM-Trimesh-Trochoidal-Machining.rdk",
            "I": "CAM-Trimesh-Trochoidal-Machining.png",
            "IS": "CAM-Trimesh-Trochoidal-Machining-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "TCM": [
                "Trimesh Trochoidal"
            ],
            "T": [
                "CAM",
                "CAM-Trimesh",
                "Machining Project",
                "Mechanism",
                "Program",
                "Tool"
            ],
            "S": 76.5,
            "RC": 1,
            "TC": 2,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-2200"
            ]
        },
        "CAM-Wireframe-Machining": {
            "N": "CAM Wireframe Machining",
            "F": "CAM-Wireframe-Machining.rdk",
            "I": "CAM-Wireframe-Machining.png",
            "IS": "CAM-Wireframe-Machining-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "TCM": [
                "Wireframe"
            ],
            "T": [
                "CAM",
                "Machining Project",
                "Mechanism",
                "Program",
                "Tool"
            ],
            "S": 69.7,
            "RC": 1,
            "TC": 2,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-2200"
            ]
        },
        "Conveying": {
            "N": "Conveying",
            "F": "Conveying.rdk",
            "I": "Conveying.png",
            "IS": "Conveying-sm.png",
            "AP": [
                "Conveying"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script"
            ],
            "S": 112.1,
            "RC": 3,
            "OC": 6,
            "RT": [
                "Mechanism"
            ]
        },
        "Conveying-02": {
            "N": "Conveying #02",
            "F": "Conveying-02.rdk",
            "I": "Conveying-02.png",
            "IS": "Conveying-02-sm.png",
            "B": [
                "SICK"
            ],
            "AP": [
                "Conveying"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script"
            ],
            "S": 63.1,
            "RC": 1,
            "OC": 9,
            "RT": [
                "Mechanism"
            ],
            "MN": [
                "Conveyor Belt Wide (2m)"
            ],
            "ON": [
                "SICK WL4S Laser Sensor"
            ]
        },
        "Conveying-03": {
            "N": "Conveying #03",
            "F": "Conveying-03.rdk",
            "I": "Conveying-03.png",
            "IS": "Conveying-03-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Conveying"
            ],
            "T": [
                "API",
                "Folder",
                "Mechanism",
                "Notes",
                "Program",
                "Python",
                "Script"
            ],
            "S": 69.8,
            "RC": 1,
            "OC": 13,
            "RT": [
                "Mechanism"
            ]
        },
        "Conveying-04": {
            "N": "Conveying #04",
            "F": "Conveying-04.rdk",
            "I": "Conveying-04.png",
            "IS": "Conveying-04-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Conveying"
            ],
            "T": [
                "Mechanism",
                "Notes",
                "Program"
            ],
            "S": 69.8,
            "RC": 1,
            "OC": 13,
            "RT": [
                "Mechanism"
            ]
        },
        "Conveying-and-Material-Handling-with-ABB": {
            "N": "Conveying and Material Handling with ABB",
            "F": "Conveying-and-Material-Handling-with-ABB.rdk",
            "I": "Conveying-and-Material-Handling-with-ABB.png",
            "IS": "Conveying-and-Material-Handling-with-ABB-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Conveying",
                "Material Handling"
            ],
            "T": [
                "API",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 83.3,
            "RC": 2,
            "TC": 2,
            "OC": 22,
            "RT": [
                "Delta"
            ],
            "RN": [
                "ABB IRB 360-1/1130 4D",
                "ABB IRB 360-3/800 3D"
            ]
        },
        "Conveying-and-Material-Handling-with-Fanuc-LR-Mate-200iD-7L": {
            "N": "Conveying and Material Handling with Fanuc LR Mate 200iD/7L",
            "F": "Conveying-and-Material-Handling-with-Fanuc-LR-Mate-200iD-7L.rdk",
            "I": "Conveying-and-Material-Handling-with-Fanuc-LR-Mate-200iD-7L.png",
            "IS": "Conveying-and-Material-Handling-with-Fanuc-LR-Mate-200iD-7L-sm.png",
            "B": [
                "Fanuc",
                "RobotiQ"
            ],
            "AP": [
                "Conveying",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 120.6,
            "RC": 4,
            "TC": 1,
            "OC": 102,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "Fanuc LR Mate 200iD/7L"
            ]
        },
        "Conveying-and-Material-Handling-with-Fanuc-M-410iC-110": {
            "N": "Conveying and Material Handling with Fanuc M-410iC/110",
            "F": "Conveying-and-Material-Handling-with-Fanuc-M-410iC-110.rdk",
            "I": "Conveying-and-Material-Handling-with-Fanuc-M-410iC-110.png",
            "IS": "Conveying-and-Material-Handling-with-Fanuc-M-410iC-110-sm.png",
            "B": [
                "Fanuc"
            ],
            "AP": [
                "Conveying",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 333.8,
            "RC": 3,
            "TC": 1,
            "OC": 7,
            "RT": [
                "Gripper",
                "Mechanism",
                "Palletizing"
            ],
            "RN": [
                "Fanuc M-410iC/110"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Conveying-and-Material-Handling-with-Fanuc-M-410iC-110-02": {
            "N": "Conveying and Material Handling with Fanuc M-410iC/110 #02",
            "F": "Conveying-and-Material-Handling-with-Fanuc-M-410iC-110-02.rdk",
            "I": "Conveying-and-Material-Handling-with-Fanuc-M-410iC-110-02.png",
            "IS": "Conveying-and-Material-Handling-with-Fanuc-M-410iC-110-02-sm.png",
            "B": [
                "Fanuc"
            ],
            "AP": [
                "Conveying",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 329.9,
            "RC": 5,
            "TC": 2,
            "OC": 11,
            "RT": [
                "Gripper",
                "Mechanism",
                "Palletizing"
            ],
            "RN": [
                "Fanuc M-410iC/110"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Conveying-and-Material-Handling-with-Motoman-GP20": {
            "N": "Conveying and Material Handling with Motoman GP20",
            "F": "Conveying-and-Material-Handling-with-Motoman-GP20.rdk",
            "I": "Conveying-and-Material-Handling-with-Motoman-GP20.png",
            "IS": "Conveying-and-Material-Handling-with-Motoman-GP20-sm.png",
            "B": [
                "RobotiQ",
                "Yaskawa Motoman"
            ],
            "AP": [
                "Conveying",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 306.6,
            "RC": 2,
            "TC": 1,
            "OC": 41,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "Motoman GP20"
            ],
            "TN": [
                "RobotiQ EPick Vacuum Gripper (1 Cup)"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Conveying-and-Material-Handling-with-UR10": {
            "N": "Conveying and Material Handling with UR10",
            "F": "Conveying-and-Material-Handling-with-UR10.rdk",
            "I": "Conveying-and-Material-Handling-with-UR10.png",
            "IS": "Conveying-and-Material-Handling-with-UR10-sm.png",
            "B": [
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Conveying",
                "Material Handling"
            ],
            "T": [
                "API",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 86.4,
            "RC": 2,
            "TC": 4,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "UR10"
            ]
        },
        "Conveying-and-Palletizing-with-Doosan-Robotics-H2017": {
            "N": "Conveying and Palletizing with Doosan Robotics H2017",
            "F": "Conveying-and-Palletizing-with-Doosan-Robotics-H2017.rdk",
            "I": "Conveying-and-Palletizing-with-Doosan-Robotics-H2017.png",
            "IS": "Conveying-and-Palletizing-with-Doosan-Robotics-H2017-sm.png",
            "B": [
                "Doosan Robotics",
                "RobotiQ"
            ],
            "AP": [
                "Collaborative",
                "Conveying",
                "Palletizing"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Palletizing Project",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 153.3,
            "RC": 2,
            "TC": 1,
            "OC": 12,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "Doosan Robotics H2017"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Conveying-and-Palletizing-with-TM14X": {
            "N": "Conveying and Palletizing with TM14X",
            "F": "Conveying-and-Palletizing-with-TM14X.rdk",
            "I": "Conveying-and-Palletizing-with-TM14X.png",
            "IS": "Conveying-and-Palletizing-with-TM14X-sm.png",
            "B": [
                "RobotiQ",
                "Techman Robot"
            ],
            "AP": [
                "Collaborative",
                "Conveying",
                "Palletizing"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 190.5,
            "RC": 3,
            "TC": 2,
            "OC": 18,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "TM14X"
            ]
        },
        "Conveying-Decanting-and-Material-Handling-with-Fanuc-R-2000iC-165F": {
            "N": "Conveying, Decanting and Material Handling with Fanuc R-2000iC/165F",
            "F": "Conveying-Decanting-and-Material-Handling-with-Fanuc-R-2000iC-165F.rdk",
            "I": "Conveying-Decanting-and-Material-Handling-with-Fanuc-R-2000iC-165F.png",
            "IS": "Conveying-Decanting-and-Material-Handling-with-Fanuc-R-2000iC-165F-sm.png",
            "B": [
                "Fanuc",
                "RoboDK"
            ],
            "AP": [
                "Conveying",
                "Decanting",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 204.9,
            "RC": 5,
            "TC": 3,
            "OC": 10,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "Fanuc R-2000iC/165F"
            ],
            "ON": [
                "Floor",
                "Pedestal H500mm (Type 2)"
            ]
        },
        "Conveying-Inspection-and-Material-Handling-with-UR10": {
            "N": "Conveying, Inspection and Material Handling with UR10",
            "F": "Conveying-Inspection-and-Material-Handling-with-UR10.rdk",
            "I": "Conveying-Inspection-and-Material-Handling-with-UR10.png",
            "IS": "Conveying-Inspection-and-Material-Handling-with-UR10-sm.png",
            "B": [
                "SICK",
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Conveying",
                "Inspection",
                "Material Handling"
            ],
            "T": [
                "API",
                "Camera",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 117.8,
            "RC": 3,
            "TC": 2,
            "OC": 16,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "UR10"
            ]
        },
        "Conveying-Inspection-and-Material-Handling-with-UR10e": {
            "N": "Conveying, Inspection and Material Handling with UR10e",
            "F": "Conveying-Inspection-and-Material-Handling-with-UR10e.rdk",
            "I": "Conveying-Inspection-and-Material-Handling-with-UR10e.png",
            "IS": "Conveying-Inspection-and-Material-Handling-with-UR10e-sm.png",
            "B": [
                "RobotiQ",
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Conveying",
                "Inspection",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 262.8,
            "RC": 3,
            "TC": 2,
            "OC": 27,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "UR10e"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Conveying-Inspection-and-Material-Handling-with-UR10e-02": {
            "N": "Conveying, Inspection and Material Handling with UR10e #02",
            "F": "Conveying-Inspection-and-Material-Handling-with-UR10e-02.rdk",
            "I": "Conveying-Inspection-and-Material-Handling-with-UR10e-02.png",
            "IS": "Conveying-Inspection-and-Material-Handling-with-UR10e-02-sm.png",
            "B": [
                "RobotiQ",
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Conveying",
                "Inspection",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 262.8,
            "RC": 3,
            "TC": 2,
            "OC": 28,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "UR10e"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Conveying-Material-Handling-and-Palletizing": {
            "N": "Conveying-Material-Handling-and-Palletizing",
            "F": "Conveying-Material-Handling-and-Palletizing.rdk",
            "I": "Conveying-Material-Handling-and-Palletizing.png",
            "IS": "Conveying-Material-Handling-and-Palletizing-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Conveying",
                "Material Handling",
                "Palletizing"
            ],
            "T": [
                "Folder",
                "Mechanism",
                "Notes",
                "Palletizing Project",
                "Program",
                "Target",
                "Tool",
                "Tutorial"
            ],
            "S": 202.9,
            "RC": 3,
            "TC": 1,
            "OC": 17,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "RoboDK RDK-2200"
            ],
            "ON": [
                "Floor",
                "Pallet 48x48in"
            ],
            "link": {
                "docs": [
                    "https://robodk.com/doc/en/Palletizing.html#Palletizing"
                ]
            }
        },
        "Conveying-Material-Handling-and-Palletizing-with-ABB-IRB-2400-L": {
            "N": "Conveying, Material Handling and Palletizing with ABB IRB 2400/L",
            "F": "Conveying-Material-Handling-and-Palletizing-with-ABB-IRB-2400-L.rdk",
            "I": "Conveying-Material-Handling-and-Palletizing-with-ABB-IRB-2400-L.png",
            "IS": "Conveying-Material-Handling-and-Palletizing-with-ABB-IRB-2400-L-sm.png",
            "B": [
                "ABB",
                "RoboDK"
            ],
            "AP": [
                "Conveying",
                "Material Handling",
                "Palletizing"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Palletizing Project",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 203.5,
            "RC": 3,
            "TC": 1,
            "OC": 13,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "ABB IRB 2400/L"
            ],
            "ON": [
                "Floor",
                "Pallet 40x48in"
            ]
        },
        "Conveying-Material-Handling-and-Palletizing-with-Doosan-Robotics-H2017": {
            "N": "Conveying, Material Handling and Palletizing with Doosan Robotics H2017",
            "F": "Conveying-Material-Handling-and-Palletizing-with-Doosan-Robotics-H2017.rdk",
            "I": "Conveying-Material-Handling-and-Palletizing-with-Doosan-Robotics-H2017.png",
            "IS": "Conveying-Material-Handling-and-Palletizing-with-Doosan-Robotics-H2017-sm.png",
            "B": [
                "Doosan Robotics",
                "RoboDK"
            ],
            "AP": [
                "Collaborative",
                "Conveying",
                "Material Handling",
                "Palletizing"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Palletizing Project",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 200.9,
            "RC": 3,
            "TC": 1,
            "OC": 12,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "Doosan Robotics H2017"
            ],
            "ON": [
                "Floor",
                "Pallet 40x48in"
            ]
        },
        "Conveying-Material-Handling-and-Palletizing-with-UR20": {
            "N": "Conveying, Material Handling and Palletizing with UR20",
            "F": "Conveying-Material-Handling-and-Palletizing-with-UR20.rdk",
            "I": "Conveying-Material-Handling-and-Palletizing-with-UR20.png",
            "IS": "Conveying-Material-Handling-and-Palletizing-with-UR20-sm.png",
            "B": [
                "RoboDK",
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Conveying",
                "Material Handling",
                "Palletizing"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Palletizing Project",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 201.1,
            "RC": 3,
            "TC": 1,
            "OC": 12,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "UR20"
            ],
            "ON": [
                "Floor",
                "Pallet 40x48in"
            ]
        },
        "Conveying-Material-Handling-and-Palletizing-with-Yaskawa-GP25": {
            "N": "Conveying, Material Handling and Palletizing with Yaskawa GP25",
            "F": "Conveying-Material-Handling-and-Palletizing-with-Yaskawa-GP25.rdk",
            "I": "Conveying-Material-Handling-and-Palletizing-with-Yaskawa-GP25.png",
            "IS": "Conveying-Material-Handling-and-Palletizing-with-Yaskawa-GP25-sm.png",
            "B": [
                "RoboDK",
                "Yaskawa Motoman"
            ],
            "AP": [
                "Conveying",
                "Material Handling",
                "Palletizing"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Palletizing Project",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 201.8,
            "RC": 3,
            "TC": 1,
            "OC": 13,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "Yaskawa GP25"
            ],
            "ON": [
                "Floor",
                "Pallet 40x48in"
            ]
        },
        "Conveying-with-ABB-CRB-1300-7-1-4": {
            "N": "Conveying with ABB CRB 1300-7/1.4",
            "F": "Conveying-with-ABB-CRB-1300-7-1-4.rdk",
            "I": "Conveying-with-ABB-CRB-1300-7-1-4.png",
            "IS": "Conveying-with-ABB-CRB-1300-7-1-4-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Conveying"
            ],
            "T": [
                "Mechanism",
                "Program",
                "Target"
            ],
            "S": 97.3,
            "RC": 3,
            "OC": 6,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "ABB CRB 1300-7/1.4"
            ]
        },
        "Conveying-with-UR10": {
            "N": "Conveying with UR10",
            "F": "Conveying-with-UR10.rdk",
            "I": "Conveying-with-UR10.png",
            "IS": "Conveying-with-UR10-sm.png",
            "B": [
                "SICK",
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Conveying"
            ],
            "T": [
                "API",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 118.0,
            "RC": 3,
            "TC": 2,
            "OC": 22,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "UR10"
            ]
        },
        "Curve-Following": {
            "N": "Curve Following",
            "F": "Curve-Following.rdk",
            "I": "Curve-Following.png",
            "IS": "Curve-Following-sm.png",
            "B": [
                "Omron"
            ],
            "AP": [
                "Curve Following"
            ],
            "T": [
                "Add-in",
                "Curve Follow Project",
                "Mechanism",
                "Notes",
                "Program",
                "Tool"
            ],
            "S": 206.9,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "AGV/AMR"
            ],
            "MN": [
                "Omron LD-250"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Curve-Following-and-Synchronization-with-Motoman-UP50N": {
            "N": "Curve Following and Synchronization with Motoman UP50N",
            "F": "Curve-Following-and-Synchronization-with-Motoman-UP50N.rdk",
            "I": "Curve-Following-and-Synchronization-with-Motoman-UP50N.png",
            "IS": "Curve-Following-and-Synchronization-with-Motoman-UP50N-sm.png",
            "B": [
                "Teknomotor",
                "Yaskawa Motoman"
            ],
            "AP": [
                "Curve Following",
                "Synchronization"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Synchronization",
                "Target",
                "Tool"
            ],
            "S": 332.0,
            "RC": 2,
            "TC": 2,
            "OC": 7,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "Motoman UP50N"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Curve-Following-and-Synchronization-with-Motoman-UP50N-02": {
            "N": "Curve Following and Synchronization with Motoman UP50N #02",
            "F": "Curve-Following-and-Synchronization-with-Motoman-UP50N-02.rdk",
            "I": "Curve-Following-and-Synchronization-with-Motoman-UP50N-02.png",
            "IS": "Curve-Following-and-Synchronization-with-Motoman-UP50N-02-sm.png",
            "B": [
                "Teknomotor",
                "Yaskawa Motoman"
            ],
            "AP": [
                "Curve Following",
                "Synchronization"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Synchronization",
                "Tool"
            ],
            "S": 345.2,
            "RC": 2,
            "TC": 2,
            "OC": 5,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "Motoman UP50N"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Curve-Following-and-Taping-with-UR10e": {
            "N": "Curve Following and Taping with UR10e",
            "F": "Curve-Following-and-Taping-with-UR10e.rdk",
            "I": "Curve-Following-and-Taping-with-UR10e.png",
            "IS": "Curve-Following-and-Taping-with-UR10e-sm.png",
            "B": [
                "FerRobotics",
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Taping"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 56.2,
            "RC": 2,
            "TC": 1,
            "OC": 3,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "UR10e"
            ],
            "TN": [
                "FerRobotics ATK 201-L-015 Taping Tool"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Curve-Following-Synchronization-and-Taping-with-ABB": {
            "N": "Curve Following, Synchronization and Taping with ABB",
            "F": "Curve-Following-Synchronization-and-Taping-with-ABB.rdk",
            "I": "Curve-Following-Synchronization-and-Taping-with-ABB.png",
            "IS": "Curve-Following-Synchronization-and-Taping-with-ABB-sm.png",
            "B": [
                "ABB",
                "FerRobotics"
            ],
            "AP": [
                "Curve Following",
                "Synchronization",
                "Taping"
            ],
            "T": [
                "API",
                "Add-in",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Synchronization",
                "Target",
                "Tool"
            ],
            "S": 264.9,
            "RC": 3,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "ABB IRB 2600ID-8/2.00"
            ],
            "AN": [
                "ABB IRBP L2000 L3150"
            ],
            "TN": [
                "FerRobotics ATK 201-R-065 Taping Tool"
            ]
        },
        "Curve-Following-with-ABB-IRB-1300-11-0-9": {
            "N": "Curve Following with ABB IRB 1300-11/0.9",
            "F": "Curve-Following-with-ABB-IRB-1300-11-0-9.rdk",
            "I": "Curve-Following-with-ABB-IRB-1300-11-0-9.png",
            "IS": "Curve-Following-with-ABB-IRB-1300-11-0-9-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Curve Following"
            ],
            "T": [
                "Curve Follow Project",
                "Folder",
                "Mechanism",
                "Notes",
                "Program",
                "Tool"
            ],
            "S": 59.9,
            "RC": 1,
            "TC": 1,
            "OC": 12,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "ABB IRB 1300-11/0.9"
            ],
            "TN": [
                "Generic Pencil Tool"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Curve-Following-with-JAKA-Zu5": {
            "N": "Curve Following with JAKA Zu5",
            "F": "Curve-Following-with-JAKA-Zu5.rdk",
            "I": "Curve-Following-with-JAKA-Zu5.png",
            "IS": "Curve-Following-with-JAKA-Zu5-sm.png",
            "B": [
                "JAKA"
            ],
            "AP": [
                "Collaborative",
                "Curve Following"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 80.1,
            "RC": 1,
            "TC": 1,
            "OC": 2,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "JAKA Zu5"
            ]
        },
        "Curve-Following-with-Mecademic-Meca500-R3": {
            "N": "Curve Following with Mecademic Meca500 R3",
            "F": "Curve-Following-with-Mecademic-Meca500-R3.rdk",
            "I": "Curve-Following-with-Mecademic-Meca500-R3.png",
            "IS": "Curve-Following-with-Mecademic-Meca500-R3-sm.png",
            "B": [
                "Mecademic"
            ],
            "AP": [
                "Curve Following"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 21.7,
            "RC": 1,
            "TC": 1,
            "OC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Mecademic Meca500 R3"
            ]
        },
        "Curve-Following-with-Motoman-UP50N": {
            "N": "Curve Following with Motoman UP50N",
            "F": "Curve-Following-with-Motoman-UP50N.rdk",
            "I": "Curve-Following-with-Motoman-UP50N.png",
            "IS": "Curve-Following-with-Motoman-UP50N-sm.png",
            "B": [
                "Yaskawa Motoman"
            ],
            "AP": [
                "Curve Following"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target"
            ],
            "S": 237.7,
            "RC": 2,
            "OC": 1,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "Motoman UP50N"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Curve-Following-with-Omron-TM5-700": {
            "N": "Curve-Following-with-Omron-TM5-700",
            "F": "Curve-Following-with-Omron-TM5-700.rdk",
            "I": "Curve-Following-with-Omron-TM5-700.png",
            "IS": "Curve-Following-with-Omron-TM5-700-sm.png",
            "B": [
                "Omron"
            ],
            "AP": [
                "Collaborative",
                "Curve Following"
            ],
            "T": [
                "Curve Follow Project",
                "Folder",
                "Mechanism",
                "Notes",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 49.0,
            "RC": 1,
            "TC": 2,
            "OC": 7,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Omron TM5-700"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Cutting-and-Machining-with-Motoman-MH50-35": {
            "N": "Cutting and Machining with Motoman MH50-35",
            "F": "Cutting-and-Machining-with-Motoman-MH50-35.rdk",
            "I": "Cutting-and-Machining-with-Motoman-MH50-35.png",
            "IS": "Cutting-and-Machining-with-Motoman-MH50-35-sm.png",
            "B": [
                "Yaskawa Motoman"
            ],
            "AP": [
                "Cutting",
                "Machining"
            ],
            "T": [
                "Frame",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool",
                "Tutorial"
            ],
            "S": 172.9,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Motoman MH50-35"
            ],
            "ON": [
                "Floor"
            ],
            "link": {
                "docs": [
                    "https://robodk.com/doc/en/Robot-Machining.html#ExCNClaser"
                ]
            }
        },
        "Cutting-and-Remote-TCP-with-Fanuc-LR-Mate-200iD-7L": {
            "N": "Cutting and Remote TCP with Fanuc LR Mate 200iD/7L",
            "F": "Cutting-and-Remote-TCP-with-Fanuc-LR-Mate-200iD-7L.rdk",
            "I": "Cutting-and-Remote-TCP-with-Fanuc-LR-Mate-200iD-7L.png",
            "IS": "Cutting-and-Remote-TCP-with-Fanuc-LR-Mate-200iD-7L-sm.png",
            "B": [
                "Fanuc"
            ],
            "AP": [
                "Curve Following",
                "Cutting",
                "Remote TCP"
            ],
            "T": [
                "Curve Follow Project",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 53.4,
            "RC": 1,
            "TC": 2,
            "OC": 7,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Fanuc LR Mate 200iD/7L"
            ]
        },
        "Cutting-and-Remote-TCP-with-Fanuc-LR-Mate-200iD-7L-02": {
            "N": "Cutting and Remote TCP with Fanuc LR Mate 200iD/7L #02",
            "F": "Cutting-and-Remote-TCP-with-Fanuc-LR-Mate-200iD-7L-02.rdk",
            "I": "Cutting-and-Remote-TCP-with-Fanuc-LR-Mate-200iD-7L-02.png",
            "IS": "Cutting-and-Remote-TCP-with-Fanuc-LR-Mate-200iD-7L-02-sm.png",
            "B": [
                "Fanuc"
            ],
            "AP": [
                "Curve Following",
                "Cutting",
                "Remote TCP"
            ],
            "T": [
                "Curve Follow Project",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 56.1,
            "RC": 1,
            "TC": 2,
            "OC": 7,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Fanuc LR Mate 200iD/7L"
            ]
        },
        "Cutting-and-Welding-with-RoboDK-RDK-1440": {
            "N": "Cutting and Welding with RoboDK RDK-1440",
            "F": "Cutting-and-Welding-with-RoboDK-RDK-1440.rdk",
            "I": "Cutting-and-Welding-with-RoboDK-RDK-1440.png",
            "IS": "Cutting-and-Welding-with-RoboDK-RDK-1440-sm.png",
            "B": [
                "Lorch",
                "Omron",
                "RoboDK"
            ],
            "AP": [
                "Curve Following",
                "Cutting",
                "Welding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 212.5,
            "RC": 2,
            "TC": 2,
            "OC": 7,
            "RT": [
                "6 DOF",
                "AGV/AMR"
            ],
            "RN": [
                "RoboDK RDK-1440"
            ],
            "MN": [
                "Omron LD-60"
            ],
            "TN": [
                "Lorch LMR 450 W Welding Gun"
            ],
            "ON": [
                "Floor",
                "Pedestal H12in (Type 1)",
                "Table 1400x800x800mm"
            ]
        },
        "Cutting-Painting-and-Remote-TCP-with-ABB-and-Fanuc": {
            "N": "Cutting, Painting and Remote TCP with ABB and Fanuc",
            "F": "Cutting-Painting-and-Remote-TCP-with-ABB-and-Fanuc.rdk",
            "I": "Cutting-Painting-and-Remote-TCP-with-ABB-and-Fanuc.png",
            "IS": "Cutting-Painting-and-Remote-TCP-with-ABB-and-Fanuc-sm.png",
            "B": [
                "ABB",
                "Fanuc"
            ],
            "AP": [
                "Curve Following",
                "Cutting",
                "Painting",
                "Remote TCP"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 250.7,
            "RC": 4,
            "TC": 6,
            "OC": 9,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "ABB IRB 1200-5/0.9",
                "Fanuc LR Mate 200iD/7L"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Cutting-with-Fanuc-CR-7iA-L": {
            "N": "Cutting with Fanuc CR-7iA/L",
            "F": "Cutting-with-Fanuc-CR-7iA-L.rdk",
            "I": "Cutting-with-Fanuc-CR-7iA-L.png",
            "IS": "Cutting-with-Fanuc-CR-7iA-L-sm.png",
            "B": [
                "Fanuc"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Cutting"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 56.3,
            "RC": 1,
            "TC": 1,
            "OC": 2,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Fanuc CR-7iA/L"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Deburring-and-Machining-with-ABB-IRB-1200-5-0-9": {
            "N": "Deburring and Machining with ABB IRB 1200-5/0.9",
            "F": "Deburring-and-Machining-with-ABB-IRB-1200-5-0-9.rdk",
            "I": "Deburring-and-Machining-with-ABB-IRB-1200-5-0-9.png",
            "IS": "Deburring-and-Machining-with-ABB-IRB-1200-5-0-9-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Curve Following",
                "Deburring",
                "Machining",
                "Milling"
            ],
            "T": [
                "Folder",
                "Frame",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool",
                "Tutorial"
            ],
            "S": 61.5,
            "RC": 1,
            "TC": 2,
            "OC": 10,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "ABB IRB 1200-5/0.9"
            ],
            "link": {
                "docs": [
                    "https://robodk.com/doc/en/Robot-Machining.html#ExDeburring"
                ]
            }
        },
        "Dispensing-and-Remote-TCP-with-Fanuc-M-710iC-45M": {
            "N": "Dispensing and Remote TCP with Fanuc M-710iC/45M",
            "F": "Dispensing-and-Remote-TCP-with-Fanuc-M-710iC-45M.rdk",
            "I": "Dispensing-and-Remote-TCP-with-Fanuc-M-710iC-45M.png",
            "IS": "Dispensing-and-Remote-TCP-with-Fanuc-M-710iC-45M-sm.png",
            "B": [
                "Fanuc"
            ],
            "AP": [
                "Curve Following",
                "Dispensing",
                "Remote TCP"
            ],
            "T": [
                "Curve Follow Project",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool",
                "Tutorial"
            ],
            "S": 186.3,
            "RC": 1,
            "TC": 2,
            "OC": 11,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Fanuc M-710iC/45M"
            ],
            "ON": [
                "Floor"
            ],
            "link": {
                "docs": [
                    "https://robodk.com/doc/en/Robot-Machining.html#RobHoldObj"
                ]
            }
        },
        "Dispensing-with-ABB-CRB-1300-11-0-9": {
            "N": "Dispensing with ABB CRB 1300-11/0.9",
            "F": "Dispensing-with-ABB-CRB-1300-11-0-9.rdk",
            "I": "Dispensing-with-ABB-CRB-1300-11-0-9.png",
            "IS": "Dispensing-with-ABB-CRB-1300-11-0-9-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 57.3,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "ABB CRB 1300-11/0.9"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-ABB-CRB-15000": {
            "N": "Dispensing with ABB CRB 15000",
            "F": "Dispensing-with-ABB-CRB-15000.rdk",
            "I": "Dispensing-with-ABB-CRB-15000.png",
            "IS": "Dispensing-with-ABB-CRB-15000-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 55.2,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "ABB CRB 15000"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-ABB-IRB-1200-5-0-9": {
            "N": "Dispensing with ABB IRB 1200-5/0.9",
            "F": "Dispensing-with-ABB-IRB-1200-5-0-9.rdk",
            "I": "Dispensing-with-ABB-IRB-1200-5-0-9.png",
            "IS": "Dispensing-with-ABB-IRB-1200-5-0-9-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Dispensing"
            ],
            "T": [
                "API",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 53.6,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "ABB IRB 1200-5/0.9"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-ABB-IRB-1200-5-0-9-02": {
            "N": "Dispensing with ABB IRB 1200-5/0.9 #02",
            "F": "Dispensing-with-ABB-IRB-1200-5-0-9-02.rdk",
            "I": "Dispensing-with-ABB-IRB-1200-5-0-9-02.png",
            "IS": "Dispensing-with-ABB-IRB-1200-5-0-9-02-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 53.3,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "ABB IRB 1200-5/0.9"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Agilebot-GBT-P7A": {
            "N": "Dispensing with Agilebot GBT-P7A",
            "F": "Dispensing-with-Agilebot-GBT-P7A.rdk",
            "I": "Dispensing-with-Agilebot-GBT-P7A.png",
            "IS": "Dispensing-with-Agilebot-GBT-P7A-sm.png",
            "B": [
                "Agilebot"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 51.2,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Agilebot GBT-P7A"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-AUBO-i5": {
            "N": "Dispensing with AUBO-i5",
            "F": "Dispensing-with-AUBO-i5.rdk",
            "I": "Dispensing-with-AUBO-i5.png",
            "IS": "Dispensing-with-AUBO-i5-sm.png",
            "B": [
                "AUBO"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 47.6,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "AUBO-i5"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-AUCTECH-ACR-7": {
            "N": "Dispensing with AUCTECH ACR-7",
            "F": "Dispensing-with-AUCTECH-ACR-7.rdk",
            "I": "Dispensing-with-AUCTECH-ACR-7.png",
            "IS": "Dispensing-with-AUCTECH-ACR-7-sm.png",
            "B": [
                "AUCTECH"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 51.6,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "AUCTECH ACR-7"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Comau-Racer-5-0-80": {
            "N": "Dispensing with Comau Racer 5-0.80",
            "F": "Dispensing-with-Comau-Racer-5-0-80.rdk",
            "I": "Dispensing-with-Comau-Racer-5-0-80.png",
            "IS": "Dispensing-with-Comau-Racer-5-0-80-sm.png",
            "B": [
                "Comau"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 51.2,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Comau Racer 5-0.80"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Delta-Electronics-DC06": {
            "N": "Dispensing with Delta Electronics DC06",
            "F": "Dispensing-with-Delta-Electronics-DC06.rdk",
            "I": "Dispensing-with-Delta-Electronics-DC06.png",
            "IS": "Dispensing-with-Delta-Electronics-DC06-sm.png",
            "B": [
                "Delta Electronics"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 49.5,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Delta Electronics DC06"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Denso-VS-068": {
            "N": "Dispensing with Denso VS-068",
            "F": "Dispensing-with-Denso-VS-068.rdk",
            "I": "Dispensing-with-Denso-VS-068.png",
            "IS": "Dispensing-with-Denso-VS-068-sm.png",
            "B": [
                "Denso"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 50.2,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Denso VS-068"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Dobot-CR3L": {
            "N": "Dispensing with Dobot CR3L",
            "F": "Dispensing-with-Dobot-CR3L.rdk",
            "I": "Dispensing-with-Dobot-CR3L.png",
            "IS": "Dispensing-with-Dobot-CR3L-sm.png",
            "B": [
                "Dobot"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 59.1,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Dobot CR3L"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Dobot-CR5": {
            "N": "Dispensing with Dobot CR5",
            "F": "Dispensing-with-Dobot-CR5.rdk",
            "I": "Dispensing-with-Dobot-CR5.png",
            "IS": "Dispensing-with-Dobot-CR5-sm.png",
            "B": [
                "Dobot"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 51.3,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Dobot CR5"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Doosan-Robotics-A0509": {
            "N": "Dispensing with Doosan Robotics A0509",
            "F": "Dispensing-with-Doosan-Robotics-A0509.rdk",
            "I": "Dispensing-with-Doosan-Robotics-A0509.png",
            "IS": "Dispensing-with-Doosan-Robotics-A0509-sm.png",
            "B": [
                "Doosan Robotics"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 49.0,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Doosan Robotics A0509"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Doosan-Robotics-A0912": {
            "N": "Dispensing with Doosan Robotics A0912",
            "F": "Dispensing-with-Doosan-Robotics-A0912.rdk",
            "I": "Dispensing-with-Doosan-Robotics-A0912.png",
            "IS": "Dispensing-with-Doosan-Robotics-A0912-sm.png",
            "B": [
                "Doosan Robotics"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 52.5,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Doosan Robotics A0912"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Doosan-Robotics-M1013": {
            "N": "Dispensing with Doosan Robotics M1013",
            "F": "Dispensing-with-Doosan-Robotics-M1013.rdk",
            "I": "Dispensing-with-Doosan-Robotics-M1013.png",
            "IS": "Dispensing-with-Doosan-Robotics-M1013-sm.png",
            "B": [
                "Doosan Robotics"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 52.5,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Doosan Robotics M1013"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Doosan-Robotics-M1013-02": {
            "N": "Dispensing with Doosan Robotics M1013 #02",
            "F": "Dispensing-with-Doosan-Robotics-M1013-02.rdk",
            "I": "Dispensing-with-Doosan-Robotics-M1013-02.png",
            "IS": "Dispensing-with-Doosan-Robotics-M1013-02-sm.png",
            "B": [
                "Doosan Robotics"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 52.1,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Doosan Robotics M1013"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Elite-Robots-CS66": {
            "N": "Dispensing with Elite Robots CS66",
            "F": "Dispensing-with-Elite-Robots-CS66.rdk",
            "I": "Dispensing-with-Elite-Robots-CS66.png",
            "IS": "Dispensing-with-Elite-Robots-CS66-sm.png",
            "B": [
                "Elite Robots"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 48.7,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Elite Robots CS66"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Epson-C8L": {
            "N": "Dispensing with Epson C8L",
            "F": "Dispensing-with-Epson-C8L.rdk",
            "I": "Dispensing-with-Epson-C8L.png",
            "IS": "Dispensing-with-Epson-C8L-sm.png",
            "B": [
                "Epson"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 54.4,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Epson C8L"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Epson-N6-A1000": {
            "N": "Dispensing with Epson N6-A1000",
            "F": "Dispensing-with-Epson-N6-A1000.rdk",
            "I": "Dispensing-with-Epson-N6-A1000.png",
            "IS": "Dispensing-with-Epson-N6-A1000-sm.png",
            "B": [
                "Epson"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 59.9,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Epson N6-A1000"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-FAIR-Innovation-F16": {
            "N": "Dispensing with FAIR Innovation F16",
            "F": "Dispensing-with-FAIR-Innovation-F16.rdk",
            "I": "Dispensing-with-FAIR-Innovation-F16.png",
            "IS": "Dispensing-with-FAIR-Innovation-F16-sm.png",
            "B": [
                "FAIRINO"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 53.6,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "FAIR Innovation F16"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-FAIR-Innovation-FR5": {
            "N": "Dispensing with FAIR Innovation FR5",
            "F": "Dispensing-with-FAIR-Innovation-FR5.rdk",
            "I": "Dispensing-with-FAIR-Innovation-FR5.png",
            "IS": "Dispensing-with-FAIR-Innovation-FR5-sm.png",
            "B": [
                "FAIRINO"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 51.1,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "FAIR Innovation FR5"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Fanuc-CR-7iA-L": {
            "N": "Dispensing with Fanuc CR-7iA/L",
            "F": "Dispensing-with-Fanuc-CR-7iA-L.rdk",
            "I": "Dispensing-with-Fanuc-CR-7iA-L.png",
            "IS": "Dispensing-with-Fanuc-CR-7iA-L-sm.png",
            "B": [
                "Fanuc"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 51.8,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Fanuc CR-7iA/L"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Fanuc-LR-Mate-200iD-7L": {
            "N": "Dispensing with Fanuc LR Mate 200iD/7L",
            "F": "Dispensing-with-Fanuc-LR-Mate-200iD-7L.rdk",
            "I": "Dispensing-with-Fanuc-LR-Mate-200iD-7L.png",
            "IS": "Dispensing-with-Fanuc-LR-Mate-200iD-7L-sm.png",
            "B": [
                "Fanuc"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 52.0,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Fanuc LR Mate 200iD/7L"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Fanuc-LR-Mate-200iD-7L-02": {
            "N": "Dispensing with Fanuc LR Mate 200iD/7L #02",
            "F": "Dispensing-with-Fanuc-LR-Mate-200iD-7L-02.rdk",
            "I": "Dispensing-with-Fanuc-LR-Mate-200iD-7L-02.png",
            "IS": "Dispensing-with-Fanuc-LR-Mate-200iD-7L-02-sm.png",
            "B": [
                "Fanuc"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 51.8,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Fanuc LR Mate 200iD/7L"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Foxbot-A1200": {
            "N": "Dispensing with Foxbot A1200",
            "F": "Dispensing-with-Foxbot-A1200.rdk",
            "I": "Dispensing-with-Foxbot-A1200.png",
            "IS": "Dispensing-with-Foxbot-A1200-sm.png",
            "B": [
                "Foxbot"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 58.5,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Foxbot A1200"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Han-s-E05-L": {
            "N": "Dispensing with Han's E05-L",
            "F": "Dispensing-with-Han-s-E05-L.rdk",
            "I": "Dispensing-with-Han-s-E05-L.png",
            "IS": "Dispensing-with-Han-s-E05-L-sm.png",
            "B": [
                "Han's"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 49.9,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Han's E05-L"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Han-s-E10": {
            "N": "Dispensing with Han's E10",
            "F": "Dispensing-with-Han-s-E10.rdk",
            "I": "Dispensing-with-Han-s-E10.png",
            "IS": "Dispensing-with-Han-s-E10-sm.png",
            "B": [
                "Han's"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 51.3,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Han's E10"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-HCR-5": {
            "N": "Dispensing with HCR-5",
            "F": "Dispensing-with-HCR-5.rdk",
            "I": "Dispensing-with-HCR-5.png",
            "IS": "Dispensing-with-HCR-5-sm.png",
            "B": [
                "Hanwha"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 48.3,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "HCR-5"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-HIWIN-RA605-710-GB": {
            "N": "Dispensing with HIWIN RA605-710-GB",
            "F": "Dispensing-with-HIWIN-RA605-710-GB.rdk",
            "I": "Dispensing-with-HIWIN-RA605-710-GB.png",
            "IS": "Dispensing-with-HIWIN-RA605-710-GB-sm.png",
            "B": [
                "HIWIN"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 52.5,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "HIWIN RA605-710-GB"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Hyundai-HH7": {
            "N": "Dispensing with Hyundai HH7",
            "F": "Dispensing-with-Hyundai-HH7.rdk",
            "I": "Dispensing-with-Hyundai-HH7.png",
            "IS": "Dispensing-with-Hyundai-HH7-sm.png",
            "B": [
                "Hyundai Robotics"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 53.7,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Hyundai HH7"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Hyundai-HH8": {
            "N": "Dispensing with Hyundai HH8",
            "F": "Dispensing-with-Hyundai-HH8.rdk",
            "I": "Dispensing-with-Hyundai-HH8.png",
            "IS": "Dispensing-with-Hyundai-HH8-sm.png",
            "B": [
                "Hyundai Robotics"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 53.7,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Hyundai HH8"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-igus-ReBeL-6DOF": {
            "N": "Dispensing with igus ReBeL 6DOF",
            "F": "Dispensing-with-igus-ReBeL-6DOF.rdk",
            "I": "Dispensing-with-igus-ReBeL-6DOF.png",
            "IS": "Dispensing-with-igus-ReBeL-6DOF-sm.png",
            "B": [
                "igus"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 46.1,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "igus ReBeL 6DOF"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-IIMT-CA-05": {
            "N": "Dispensing with IIMT-CA-05",
            "F": "Dispensing-with-IIMT-CA-05.rdk",
            "I": "Dispensing-with-IIMT-CA-05.png",
            "IS": "Dispensing-with-IIMT-CA-05-sm.png",
            "B": [
                "IIMT"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 50.6,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "IIMT-CA-05"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-JAKA-Zu5": {
            "N": "Dispensing with JAKA Zu5",
            "F": "Dispensing-with-JAKA-Zu5.rdk",
            "I": "Dispensing-with-JAKA-Zu5.png",
            "IS": "Dispensing-with-JAKA-Zu5-sm.png",
            "B": [
                "JAKA"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 50.8,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "JAKA Zu5"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Kassow-KR0810": {
            "N": "Dispensing with Kassow KR0810",
            "F": "Dispensing-with-Kassow-KR0810.rdk",
            "I": "Dispensing-with-Kassow-KR0810.png",
            "IS": "Dispensing-with-Kassow-KR0810-sm.png",
            "B": [
                "Kassow Robots"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 50.7,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "7 DOF"
            ],
            "RN": [
                "Kassow KR0810"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Kassow-KR0810-02": {
            "N": "Dispensing with Kassow KR0810 #02",
            "F": "Dispensing-with-Kassow-KR0810-02.rdk",
            "I": "Dispensing-with-Kassow-KR0810-02.png",
            "IS": "Dispensing-with-Kassow-KR0810-02-sm.png",
            "B": [
                "Kassow Robots"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 50.5,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "7 DOF"
            ],
            "RN": [
                "Kassow KR0810"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Kawasaki-RS005L": {
            "N": "Dispensing with Kawasaki RS005L",
            "F": "Dispensing-with-Kawasaki-RS005L.rdk",
            "I": "Dispensing-with-Kawasaki-RS005L.png",
            "IS": "Dispensing-with-Kawasaki-RS005L-sm.png",
            "B": [
                "Kawasaki"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 51.3,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Kawasaki RS005L"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Kawasaki-RS007N": {
            "N": "Dispensing with Kawasaki RS007N",
            "F": "Dispensing-with-Kawasaki-RS007N.rdk",
            "I": "Dispensing-with-Kawasaki-RS007N.png",
            "IS": "Dispensing-with-Kawasaki-RS007N-sm.png",
            "B": [
                "Kawasaki"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 49.4,
            "RC": 1,
            "TC": 1,
            "OC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Kawasaki RS007N"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-KUKA-iisy-3-R930": {
            "N": "Dispensing with KUKA iisy 3 R930",
            "F": "Dispensing-with-KUKA-iisy-3-R930.rdk",
            "I": "Dispensing-with-KUKA-iisy-3-R930.png",
            "IS": "Dispensing-with-KUKA-iisy-3-R930-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 51.2,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "KUKA iisy 3 R930"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-KUKA-KR-5-sixx-R850": {
            "N": "Dispensing with KUKA KR 5 sixx R850",
            "F": "Dispensing-with-KUKA-KR-5-sixx-R850.rdk",
            "I": "Dispensing-with-KUKA-KR-5-sixx-R850.png",
            "IS": "Dispensing-with-KUKA-KR-5-sixx-R850-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 50.8,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "KUKA KR 5 sixx R850"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-KUKA-KR-6-R900-sixx": {
            "N": "Dispensing with KUKA KR 6 R900 sixx",
            "F": "Dispensing-with-KUKA-KR-6-R900-sixx.rdk",
            "I": "Dispensing-with-KUKA-KR-6-R900-sixx.png",
            "IS": "Dispensing-with-KUKA-KR-6-R900-sixx-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 53.0,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "KUKA KR 6 R900 sixx"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-KUKA-KR-6-R900-sixx-02": {
            "N": "Dispensing with KUKA KR 6 R900 sixx #02",
            "F": "Dispensing-with-KUKA-KR-6-R900-sixx-02.rdk",
            "I": "Dispensing-with-KUKA-KR-6-R900-sixx-02.png",
            "IS": "Dispensing-with-KUKA-KR-6-R900-sixx-02-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 52.4,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "KUKA KR 6 R900 sixx"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Leantec-LA707-7H-R": {
            "N": "Dispensing with Leantec LA707-7H-R",
            "F": "Dispensing-with-Leantec-LA707-7H-R.rdk",
            "I": "Dispensing-with-Leantec-LA707-7H-R.png",
            "IS": "Dispensing-with-Leantec-LA707-7H-R-sm.png",
            "B": [
                "Leantec"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 52.5,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Leantec LA707-7H-R"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Leantec-LA906-7H-R": {
            "N": "Dispensing with Leantec LA906-7H-R",
            "F": "Dispensing-with-Leantec-LA906-7H-R.rdk",
            "I": "Dispensing-with-Leantec-LA906-7H-R.png",
            "IS": "Dispensing-with-Leantec-LA906-7H-R-sm.png",
            "B": [
                "Leantec"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 54.3,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Leantec LA906-7H-R"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Mitsubishi-RV-5AS-D": {
            "N": "Dispensing with Mitsubishi RV-5AS-D",
            "F": "Dispensing-with-Mitsubishi-RV-5AS-D.rdk",
            "I": "Dispensing-with-Mitsubishi-RV-5AS-D.png",
            "IS": "Dispensing-with-Mitsubishi-RV-5AS-D-sm.png",
            "B": [
                "Mitsubishi"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 50.1,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Mitsubishi RV-5AS-D"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Motoman-MH5": {
            "N": "Dispensing with Motoman MH5",
            "F": "Dispensing-with-Motoman-MH5.rdk",
            "I": "Dispensing-with-Motoman-MH5.png",
            "IS": "Dispensing-with-Motoman-MH5-sm.png",
            "B": [
                "Yaskawa Motoman"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 49.6,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Motoman MH5"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Nachi-MZ07": {
            "N": "Dispensing with Nachi MZ07",
            "F": "Dispensing-with-Nachi-MZ07.rdk",
            "I": "Dispensing-with-Nachi-MZ07.png",
            "IS": "Dispensing-with-Nachi-MZ07-sm.png",
            "B": [
                "Nachi"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 50.4,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Nachi MZ07"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Neura-LARA-10": {
            "N": "Dispensing with Neura LARA 10",
            "F": "Dispensing-with-Neura-LARA-10.rdk",
            "I": "Dispensing-with-Neura-LARA-10.png",
            "IS": "Dispensing-with-Neura-LARA-10-sm.png",
            "B": [
                "Neura"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 51.3,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Neura LARA 10"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-RB10-1300": {
            "N": "Dispensing with RB10-1300",
            "F": "Dispensing-with-RB10-1300.rdk",
            "I": "Dispensing-with-RB10-1300.png",
            "IS": "Dispensing-with-RB10-1300-sm.png",
            "B": [
                "Rainbow Robotics"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 52.5,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RB10-1300"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-RoboDK-RDK-1100": {
            "N": "Dispensing with RoboDK RDK-1100",
            "F": "Dispensing-with-RoboDK-RDK-1100.rdk",
            "I": "Dispensing-with-RoboDK-RDK-1100.png",
            "IS": "Dispensing-with-RoboDK-RDK-1100-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 54.7,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-1100"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-RoboDK-RDK-1100-02": {
            "N": "Dispensing with RoboDK RDK-1100 #02",
            "F": "Dispensing-with-RoboDK-RDK-1100-02.rdk",
            "I": "Dispensing-with-RoboDK-RDK-1100-02.png",
            "IS": "Dispensing-with-RoboDK-RDK-1100-02-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 54.4,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-1100"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-RoboDK-RDK-COBOT-1200": {
            "N": "Dispensing with RoboDK RDK-COBOT-1200",
            "F": "Dispensing-with-RoboDK-RDK-COBOT-1200.rdk",
            "I": "Dispensing-with-RoboDK-RDK-COBOT-1200.png",
            "IS": "Dispensing-with-RoboDK-RDK-COBOT-1200-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 55.8,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-COBOT-1200"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Robostar-RA007": {
            "N": "Dispensing with Robostar RA007",
            "F": "Dispensing-with-Robostar-RA007.rdk",
            "I": "Dispensing-with-Robostar-RA007.png",
            "IS": "Dispensing-with-Robostar-RA007-sm.png",
            "B": [
                "Robostar"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 53.1,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Robostar RA007"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Rokae-CR12": {
            "N": "Dispensing with Rokae CR12",
            "F": "Dispensing-with-Rokae-CR12.rdk",
            "I": "Dispensing-with-Rokae-CR12.png",
            "IS": "Dispensing-with-Rokae-CR12-sm.png",
            "B": [
                "Rokae"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 59.3,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Rokae CR12"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Rokae-XB6": {
            "N": "Dispensing with Rokae XB6",
            "F": "Dispensing-with-Rokae-XB6.rdk",
            "I": "Dispensing-with-Rokae-XB6.png",
            "IS": "Dispensing-with-Rokae-XB6-sm.png",
            "B": [
                "Rokae"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 52.5,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Rokae XB6"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Schneider-Electric-Lexium-Cobot-LXMRL07S0000": {
            "N": "Dispensing with Schneider Electric Lexium Cobot LXMRL07S0000",
            "F": "Dispensing-with-Schneider-Electric-Lexium-Cobot-LXMRL07S0000.rdk",
            "I": "Dispensing-with-Schneider-Electric-Lexium-Cobot-LXMRL07S0000.png",
            "IS": "Dispensing-with-Schneider-Electric-Lexium-Cobot-LXMRL07S0000-sm.png",
            "B": [
                "Schneider Electric"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 47.2,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Schneider Electric Lexium Cobot LXMRL07S0000"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Schneider-Electric-Lexium-Cobot-LXMRL18S0000": {
            "N": "Dispensing with Schneider Electric Lexium Cobot LXMRL18S0000",
            "F": "Dispensing-with-Schneider-Electric-Lexium-Cobot-LXMRL18S0000.rdk",
            "I": "Dispensing-with-Schneider-Electric-Lexium-Cobot-LXMRL18S0000.png",
            "IS": "Dispensing-with-Schneider-Electric-Lexium-Cobot-LXMRL18S0000-sm.png",
            "B": [
                "Schneider Electric"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 49.9,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Schneider Electric Lexium Cobot LXMRL18S0000"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Siasun-GCR5-910": {
            "N": "Dispensing with Siasun GCR5-910",
            "F": "Dispensing-with-Siasun-GCR5-910.rdk",
            "I": "Dispensing-with-Siasun-GCR5-910.png",
            "IS": "Dispensing-with-Siasun-GCR5-910-sm.png",
            "B": [
                "Siasun"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 48.1,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Siasun GCR5-910"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Standard-Bots-RO1": {
            "N": "Dispensing with Standard Bots RO1",
            "F": "Dispensing-with-Standard-Bots-RO1.rdk",
            "I": "Dispensing-with-Standard-Bots-RO1.png",
            "IS": "Dispensing-with-Standard-Bots-RO1-sm.png",
            "B": [
                "Standard Bots"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 52.3,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Standard Bots RO1"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Staubli-RX60BL": {
            "N": "Dispensing with Staubli RX60BL",
            "F": "Dispensing-with-Staubli-RX60BL.rdk",
            "I": "Dispensing-with-Staubli-RX60BL.png",
            "IS": "Dispensing-with-Staubli-RX60BL-sm.png",
            "B": [
                "Staubli"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 53.2,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Staubli RX60BL"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Staubli-RX90B": {
            "N": "Dispensing with Staubli RX90B",
            "F": "Dispensing-with-Staubli-RX90B.rdk",
            "I": "Dispensing-with-Staubli-RX90B.png",
            "IS": "Dispensing-with-Staubli-RX90B-sm.png",
            "B": [
                "Staubli"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 56.1,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Staubli RX90B"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Staubli-TX2-60L": {
            "N": "Dispensing with Staubli TX2-60L",
            "F": "Dispensing-with-Staubli-TX2-60L.rdk",
            "I": "Dispensing-with-Staubli-TX2-60L.png",
            "IS": "Dispensing-with-Staubli-TX2-60L-sm.png",
            "B": [
                "Staubli"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 52.2,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Staubli TX2-60L"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Staubli-TX2-60L-02": {
            "N": "Dispensing with Staubli TX2-60L #02",
            "F": "Dispensing-with-Staubli-TX2-60L-02.rdk",
            "I": "Dispensing-with-Staubli-TX2-60L-02.png",
            "IS": "Dispensing-with-Staubli-TX2-60L-02-sm.png",
            "B": [
                "Staubli"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 50.0,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Staubli TX2-60L"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-TM5-900": {
            "N": "Dispensing with TM5-900",
            "F": "Dispensing-with-TM5-900.rdk",
            "I": "Dispensing-with-TM5-900.png",
            "IS": "Dispensing-with-TM5-900-sm.png",
            "B": [
                "Techman Robot"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 50.9,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "TM5-900"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-TM5S": {
            "N": "Dispensing with TM5S",
            "F": "Dispensing-with-TM5S.rdk",
            "I": "Dispensing-with-TM5S.png",
            "IS": "Dispensing-with-TM5S-sm.png",
            "B": [
                "Techman Robot"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 51.5,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "TM5S"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-TM12": {
            "N": "Dispensing with TM12",
            "F": "Dispensing-with-TM12.rdk",
            "I": "Dispensing-with-TM12.png",
            "IS": "Dispensing-with-TM12-sm.png",
            "B": [
                "Techman Robot"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 53.1,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "TM12"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-TM14X": {
            "N": "Dispensing with TM14X",
            "F": "Dispensing-with-TM14X.rdk",
            "I": "Dispensing-with-TM14X.png",
            "IS": "Dispensing-with-TM14X-sm.png",
            "B": [
                "Techman Robot"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 50.6,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "TM14X"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-TM14X-02": {
            "N": "Dispensing with TM14X #02",
            "F": "Dispensing-with-TM14X-02.rdk",
            "I": "Dispensing-with-TM14X-02.png",
            "IS": "Dispensing-with-TM14X-02-sm.png",
            "B": [
                "Techman Robot"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 53.4,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "TM14X"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-UR5e": {
            "N": "Dispensing with UR5e",
            "F": "Dispensing-with-UR5e.rdk",
            "I": "Dispensing-with-UR5e.png",
            "IS": "Dispensing-with-UR5e-sm.png",
            "B": [
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 51.2,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "UR5e"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-UR10": {
            "N": "Dispensing with UR10",
            "F": "Dispensing-with-UR10.rdk",
            "I": "Dispensing-with-UR10.png",
            "IS": "Dispensing-with-UR10-sm.png",
            "B": [
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 68.0,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "UR10"
            ],
            "ON": [
                "Table 2000x1200x800mm"
            ]
        },
        "Dispensing-with-UR10e": {
            "N": "Dispensing with UR10e",
            "F": "Dispensing-with-UR10e.rdk",
            "I": "Dispensing-with-UR10e.png",
            "IS": "Dispensing-with-UR10e-sm.png",
            "B": [
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 52.2,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "UR10e"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-UR10e-02": {
            "N": "Dispensing with UR10e #02",
            "F": "Dispensing-with-UR10e-02.rdk",
            "I": "Dispensing-with-UR10e-02.png",
            "IS": "Dispensing-with-UR10e-02-sm.png",
            "B": [
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 52.2,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "UR10e"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-UR10e-03": {
            "N": "Dispensing with UR10e #03",
            "F": "Dispensing-with-UR10e-03.rdk",
            "I": "Dispensing-with-UR10e-03.png",
            "IS": "Dispensing-with-UR10e-03-sm.png",
            "B": [
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 58.7,
            "RC": 1,
            "TC": 1,
            "OC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "UR10e"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Yaskawa-GP8": {
            "N": "Dispensing with Yaskawa GP8",
            "F": "Dispensing-with-Yaskawa-GP8.rdk",
            "I": "Dispensing-with-Yaskawa-GP8.png",
            "IS": "Dispensing-with-Yaskawa-GP8-sm.png",
            "B": [
                "Yaskawa Motoman"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 50.4,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Yaskawa GP8"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Yaskawa-GP8-02": {
            "N": "Dispensing with Yaskawa GP8 #02",
            "F": "Dispensing-with-Yaskawa-GP8-02.rdk",
            "I": "Dispensing-with-Yaskawa-GP8-02.png",
            "IS": "Dispensing-with-Yaskawa-GP8-02-sm.png",
            "B": [
                "Yaskawa Motoman"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 50.2,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Yaskawa GP8"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Yaskawa-GP8-03": {
            "N": "Dispensing with Yaskawa GP8 #03",
            "F": "Dispensing-with-Yaskawa-GP8-03.rdk",
            "I": "Dispensing-with-Yaskawa-GP8-03.png",
            "IS": "Dispensing-with-Yaskawa-GP8-03-sm.png",
            "B": [
                "Yaskawa Motoman"
            ],
            "AP": [
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 54.1,
            "RC": 1,
            "TC": 1,
            "OC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Yaskawa GP8"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Dispensing-with-Yaskawa-HC10": {
            "N": "Dispensing with Yaskawa HC10",
            "F": "Dispensing-with-Yaskawa-HC10.rdk",
            "I": "Dispensing-with-Yaskawa-HC10.png",
            "IS": "Dispensing-with-Yaskawa-HC10-sm.png",
            "B": [
                "Yaskawa Motoman"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Dispensing"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 55.8,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Yaskawa HC10"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Drawing-with-ABB-IRB-4600-20-2-50": {
            "N": "Drawing with ABB IRB 4600-20/2.50",
            "F": "Drawing-with-ABB-IRB-4600-20-2-50.rdk",
            "I": "Drawing-with-ABB-IRB-4600-20-2-50.png",
            "IS": "Drawing-with-ABB-IRB-4600-20-2-50-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Drawing"
            ],
            "T": [
                "API",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 93.0,
            "RC": 1,
            "TC": 1,
            "OC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "ABB IRB 4600-20/2.50"
            ]
        },
        "Drilling-and-Machining-with-ABB-IRB-4400-45-M94A": {
            "N": "Drilling and Machining with ABB IRB 4400/45 M94A",
            "F": "Drilling-and-Machining-with-ABB-IRB-4400-45-M94A.rdk",
            "I": "Drilling-and-Machining-with-ABB-IRB-4400-45-M94A.png",
            "IS": "Drilling-and-Machining-with-ABB-IRB-4400-45-M94A-sm.png",
            "B": [
                "ABB",
                "Teknomotor"
            ],
            "AP": [
                "Drilling",
                "Machining",
                "Milling"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Template",
                "Tool"
            ],
            "S": 212.2,
            "RC": 2,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "ABB IRB 4400/45 M94A"
            ],
            "TN": [
                "Teknomotor ATC71-C-LN Spindle"
            ],
            "ON": [
                "Floor",
                "Pedestal H750mm (Type 2)"
            ]
        },
        "Drilling-and-Machining-with-Fanuc-S-430iW": {
            "N": "Drilling and Machining with Fanuc S-430iW",
            "F": "Drilling-and-Machining-with-Fanuc-S-430iW.rdk",
            "I": "Drilling-and-Machining-with-Fanuc-S-430iW.png",
            "IS": "Drilling-and-Machining-with-Fanuc-S-430iW-sm.png",
            "B": [
                "Fanuc",
                "Teknomotor"
            ],
            "AP": [
                "Drilling",
                "Machining",
                "Milling"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Template",
                "Tool"
            ],
            "S": 211.8,
            "RC": 2,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "Fanuc S-430iW"
            ],
            "TN": [
                "Teknomotor ATC71-C-LN Spindle"
            ],
            "ON": [
                "Floor",
                "Pedestal H750mm (Type 2)"
            ]
        },
        "Drilling-and-Machining-with-KUKA-KR-150-R3100-prime": {
            "N": "Drilling and Machining with KUKA KR 150 R3100 prime",
            "F": "Drilling-and-Machining-with-KUKA-KR-150-R3100-prime.rdk",
            "I": "Drilling-and-Machining-with-KUKA-KR-150-R3100-prime.png",
            "IS": "Drilling-and-Machining-with-KUKA-KR-150-R3100-prime-sm.png",
            "B": [
                "KUKA",
                "Teknomotor"
            ],
            "AP": [
                "Drilling",
                "Machining",
                "Milling"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Template",
                "Tool"
            ],
            "S": 214.9,
            "RC": 2,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "KUKA KR 150 R3100 prime"
            ],
            "TN": [
                "Teknomotor ATC71-C-LN Spindle"
            ],
            "ON": [
                "Floor",
                "Pedestal H750mm (Type 2)"
            ]
        },
        "Drilling-and-Machining-with-Leantec-LA2100-60-C": {
            "N": "Drilling and Machining with Leantec LA2100-60-C",
            "F": "Drilling-and-Machining-with-Leantec-LA2100-60-C.rdk",
            "I": "Drilling-and-Machining-with-Leantec-LA2100-60-C.png",
            "IS": "Drilling-and-Machining-with-Leantec-LA2100-60-C-sm.png",
            "B": [
                "Leantec",
                "Teknomotor"
            ],
            "AP": [
                "Drilling",
                "Machining",
                "Milling"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Template",
                "Tool"
            ],
            "S": 212.4,
            "RC": 2,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "Leantec LA2100-60-C"
            ],
            "TN": [
                "Teknomotor ATC71-C-LN Spindle"
            ],
            "ON": [
                "Floor",
                "Pedestal H500mm (Type 2)"
            ]
        },
        "Drilling-and-Milling-with-Fanuc-M-10iA-10S": {
            "N": "Drilling and Milling with Fanuc M-10iA/10S",
            "F": "Drilling-and-Milling-with-Fanuc-M-10iA-10S.rdk",
            "I": "Drilling-and-Milling-with-Fanuc-M-10iA-10S.png",
            "IS": "Drilling-and-Milling-with-Fanuc-M-10iA-10S-sm.png",
            "B": [
                "Fanuc"
            ],
            "AP": [
                "Drilling",
                "Milling"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Template",
                "Tool"
            ],
            "S": 77.3,
            "RC": 1,
            "TC": 1,
            "OC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Fanuc M-10iA/10S"
            ],
            "ON": [
                "Floor",
                "Table 1400x800x800mm"
            ]
        },
        "Drilling-and-Milling-with-KUKA-KR-10-R900-sixx": {
            "N": "Drilling and Milling with KUKA KR 10 R900 sixx",
            "F": "Drilling-and-Milling-with-KUKA-KR-10-R900-sixx.rdk",
            "I": "Drilling-and-Milling-with-KUKA-KR-10-R900-sixx.png",
            "IS": "Drilling-and-Milling-with-KUKA-KR-10-R900-sixx-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Drilling",
                "Milling"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 51.6,
            "RC": 1,
            "TC": 1,
            "OC": 2,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "KUKA KR 10 R900 sixx"
            ]
        },
        "Drilling-and-Milling-with-KUKA-KR-10-R900-sixx-02": {
            "N": "Drilling and Milling with KUKA KR 10 R900 sixx #02",
            "F": "Drilling-and-Milling-with-KUKA-KR-10-R900-sixx-02.rdk",
            "I": "Drilling-and-Milling-with-KUKA-KR-10-R900-sixx-02.png",
            "IS": "Drilling-and-Milling-with-KUKA-KR-10-R900-sixx-02-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Drilling",
                "Milling"
            ],
            "T": [
                "API",
                "Mechanism",
                "Notes",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 55.7,
            "RC": 1,
            "TC": 1,
            "OC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "KUKA KR 10 R900 sixx"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Drilling-and-Milling-with-KUKA-KR-10-R900-sixx-03": {
            "N": "Drilling and Milling with KUKA KR 10 R900 sixx #03",
            "F": "Drilling-and-Milling-with-KUKA-KR-10-R900-sixx-03.rdk",
            "I": "Drilling-and-Milling-with-KUKA-KR-10-R900-sixx-03.png",
            "IS": "Drilling-and-Milling-with-KUKA-KR-10-R900-sixx-03-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Drilling",
                "Milling"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Template",
                "Tool"
            ],
            "S": 57.9,
            "RC": 1,
            "TC": 1,
            "OC": 1,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "KUKA KR 10 R900 sixx"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Drilling-and-Milling-with-KUKA-KR-22-R1610": {
            "N": "Drilling and Milling with KUKA KR 22 R1610",
            "F": "Drilling-and-Milling-with-KUKA-KR-22-R1610.rdk",
            "I": "Drilling-and-Milling-with-KUKA-KR-22-R1610.png",
            "IS": "Drilling-and-Milling-with-KUKA-KR-22-R1610-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Curve Following",
                "Drilling",
                "Milling"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Point Follow Project",
                "Program",
                "Tool"
            ],
            "S": 170.4,
            "RC": 1,
            "TC": 1,
            "OC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "KUKA KR 22 R1610"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Drilling-Milling-and-Trimming-with-Comau-Smart5-NJ-370-2-7": {
            "N": "Drilling, Milling and Trimming with Comau Smart5 NJ 370-2.7",
            "F": "Drilling-Milling-and-Trimming-with-Comau-Smart5-NJ-370-2-7.rdk",
            "I": "Drilling-Milling-and-Trimming-with-Comau-Smart5-NJ-370-2-7.png",
            "IS": "Drilling-Milling-and-Trimming-with-Comau-Smart5-NJ-370-2-7-sm.png",
            "B": [
                "Comau",
                "Teknomotor"
            ],
            "AP": [
                "Drilling",
                "Milling",
                "Trimming"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Template",
                "Tool"
            ],
            "S": 221.1,
            "RC": 2,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "Comau Smart5 NJ 370-2.7"
            ],
            "TN": [
                "Teknomotor ATC71-C-LN Spindle"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Drilling-with-UR10e": {
            "N": "Drilling with UR10e",
            "F": "Drilling-with-UR10e.rdk",
            "I": "Drilling-with-UR10e.png",
            "IS": "Drilling-with-UR10e-sm.png",
            "B": [
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Drilling"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Point Follow Project",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 98.9,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "UR10e"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Grinding-with-Omron-TM14X": {
            "N": "Grinding with Omron TM14X",
            "F": "Grinding-with-Omron-TM14X.rdk",
            "I": "Grinding-with-Omron-TM14X.png",
            "IS": "Grinding-with-Omron-TM14X-sm.png",
            "B": [
                "FerRobotics",
                "Omron",
                "Techman Robot"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Grinding"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 54.4,
            "RC": 2,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "Omron TM14X"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Grinding-with-UR10e": {
            "N": "Grinding with UR10e",
            "F": "Grinding-with-UR10e.rdk",
            "I": "Grinding-with-UR10e.png",
            "IS": "Grinding-with-UR10e-sm.png",
            "B": [
                "FerRobotics",
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Grinding"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 55.7,
            "RC": 2,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "UR10e"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "HMI": {
            "N": "HMI",
            "F": "HMI.rdk",
            "I": "HMI.png",
            "IS": "HMI-sm.png",
            "AP": [
                "HMI"
            ],
            "T": [
                "API",
                "Add-in",
                "Frame",
                "Notes",
                "Object",
                "Python",
                "Script"
            ],
            "S": 14.7,
            "OC": 1,
            "ON": [
                "Display Panel 24in"
            ]
        },
        "Inspection-and-Painting-with-RoboDK-RDK-COBOT-1200": {
            "N": "Inspection and Painting with RoboDK RDK-COBOT-1200",
            "F": "Inspection-and-Painting-with-RoboDK-RDK-COBOT-1200.rdk",
            "I": "Inspection-and-Painting-with-RoboDK-RDK-COBOT-1200.png",
            "IS": "Inspection-and-Painting-with-RoboDK-RDK-COBOT-1200-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Inspection",
                "Painting"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 114.6,
            "RC": 2,
            "TC": 2,
            "OC": 6,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "RoboDK RDK-COBOT-1200"
            ],
            "ON": [
                "Floor",
                "RoboDK Nametag Plate 500x200mm"
            ]
        },
        "Inspection-and-Synchronization-with-Lucas-and-Yaskawa-Motoman": {
            "N": "Inspection and Synchronization with Lucas and Yaskawa Motoman",
            "F": "Inspection-and-Synchronization-with-Lucas-and-Yaskawa-Motoman.rdk",
            "I": "Inspection-and-Synchronization-with-Lucas-and-Yaskawa-Motoman.png",
            "IS": "Inspection-and-Synchronization-with-Lucas-and-Yaskawa-Motoman-sm.png",
            "B": [
                "Lucas",
                "Yaskawa Motoman"
            ],
            "AP": [
                "Curve Following",
                "Inspection",
                "Synchronization"
            ],
            "T": [
                "Curve Follow Project",
                "Mechanism",
                "Program",
                "Synchronization",
                "Target",
                "Tool"
            ],
            "S": 428.4,
            "RC": 2,
            "TC": 2,
            "OC": 7,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "Motoman UP50N"
            ],
            "AN": [
                "Lucas RC2-YZ-1R"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Inspection-with-KUKA-KR-22-R1610": {
            "N": "Inspection with KUKA KR 22 R1610",
            "F": "Inspection-with-KUKA-KR-22-R1610.rdk",
            "I": "Inspection-with-KUKA-KR-22-R1610.png",
            "IS": "Inspection-with-KUKA-KR-22-R1610-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Inspection"
            ],
            "T": [
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 166.2,
            "RC": 1,
            "TC": 2,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "KUKA KR 22 R1610"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Inspection-with-KUKA-KR-22-R1610-02": {
            "N": "Inspection with KUKA KR 22 R1610 #02",
            "F": "Inspection-with-KUKA-KR-22-R1610-02.rdk",
            "I": "Inspection-with-KUKA-KR-22-R1610-02.png",
            "IS": "Inspection-with-KUKA-KR-22-R1610-02-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Inspection"
            ],
            "T": [
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 165.7,
            "RC": 1,
            "TC": 2,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "KUKA KR 22 R1610"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Inspection-with-TM12X": {
            "N": "Inspection with TM12X",
            "F": "Inspection-with-TM12X.rdk",
            "I": "Inspection-with-TM12X.png",
            "IS": "Inspection-with-TM12X-sm.png",
            "B": [
                "Techman Robot"
            ],
            "AP": [
                "Collaborative",
                "Inspection"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool",
                "Tutorial"
            ],
            "S": 78.6,
            "RC": 2,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "TM12X"
            ],
            "ON": [
                "Floor"
            ],
            "link": {
                "docs": [
                    "https://robodk.com/doc/en/General.html#Model1x"
                ]
            }
        },
        "Inspection-with-UR10": {
            "N": "Inspection with UR10",
            "F": "Inspection-with-UR10.rdk",
            "I": "Inspection-with-UR10.png",
            "IS": "Inspection-with-UR10-sm.png",
            "B": [
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Inspection"
            ],
            "T": [
                "API",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Point Follow Project",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool",
                "Success Story"
            ],
            "S": 218.5,
            "RC": 1,
            "TC": 1,
            "OC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "UR10"
            ],
            "ON": [
                "Pedestal H24in (Type 1)"
            ],
            "link": {
                "blogs": [
                    "https://robodk.com/blog/automated-inspection/"
                ]
            }
        },
        "Inspection-with-UR10e": {
            "N": "Inspection-with-UR10e",
            "F": "Inspection-with-UR10e.rdk",
            "I": "Inspection-with-UR10e.png",
            "IS": "Inspection-with-UR10e-sm.png",
            "B": [
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Inspection"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Folder",
                "Mechanism",
                "Notes",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool",
                "Success Story"
            ],
            "S": 211.0,
            "RC": 3,
            "TC": 6,
            "OC": 7,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "UR10e"
            ],
            "ON": [
                "Floor"
            ],
            "link": {
                "blogs": [
                    "https://robodk.com/blog/multi-robot-inspection/"
                ]
            }
        },
        "Inspection-with-UR10e-02": {
            "N": "Inspection with UR10e #02",
            "F": "Inspection-with-UR10e-02.rdk",
            "I": "Inspection-with-UR10e-02.png",
            "IS": "Inspection-with-UR10e-02-sm.png",
            "B": [
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Inspection"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 78.8,
            "RC": 2,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "UR10e"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Machine-Tending-Machining-and-Material-Handling-with-AUBO-i10": {
            "N": "Machine Tending, Machining and Material Handling with AUBO-i10",
            "F": "Machine-Tending-Machining-and-Material-Handling-with-AUBO-i10.rdk",
            "I": "Machine-Tending-Machining-and-Material-Handling-with-AUBO-i10.png",
            "IS": "Machine-Tending-Machining-and-Material-Handling-with-AUBO-i10-sm.png",
            "B": [
                "AUBO",
                "Mazak",
                "RobotiQ"
            ],
            "AP": [
                "Collaborative",
                "Machine Tending",
                "Machining",
                "Material Handling"
            ],
            "T": [
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 171.7,
            "RC": 4,
            "TC": 2,
            "OC": 38,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "AUBO-i10"
            ],
            "ON": [
                "Floor",
                "Pedestal H12in (Type 1)",
                "Table 1400x800x800mm"
            ]
        },
        "Machine-Tending-Machining-and-Material-Handling-with-TM12X": {
            "N": "Machine Tending, Machining and Material Handling with TM12X",
            "F": "Machine-Tending-Machining-and-Material-Handling-with-TM12X.rdk",
            "I": "Machine-Tending-Machining-and-Material-Handling-with-TM12X.png",
            "IS": "Machine-Tending-Machining-and-Material-Handling-with-TM12X-sm.png",
            "B": [
                "Mazak",
                "RobotiQ",
                "Techman Robot"
            ],
            "AP": [
                "Collaborative",
                "Machine Tending",
                "Machining",
                "Material Handling"
            ],
            "T": [
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 152.3,
            "RC": 4,
            "TC": 2,
            "OC": 38,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "TM12X"
            ],
            "ON": [
                "Floor",
                "Pedestal H12in (Type 1)",
                "Table 1400x800x800mm"
            ]
        },
        "Machine-Tending-Machining-and-Material-Handling-with-UR10": {
            "N": "Machine Tending, Machining and Material Handling with UR10",
            "F": "Machine-Tending-Machining-and-Material-Handling-with-UR10.rdk",
            "I": "Machine-Tending-Machining-and-Material-Handling-with-UR10.png",
            "IS": "Machine-Tending-Machining-and-Material-Handling-with-UR10-sm.png",
            "B": [
                "Mazak",
                "RobotiQ",
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Machine Tending",
                "Machining",
                "Material Handling"
            ],
            "T": [
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 152.3,
            "RC": 4,
            "TC": 2,
            "OC": 38,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "UR10"
            ],
            "ON": [
                "Floor",
                "Pedestal H12in (Type 1)",
                "Table 1400x800x800mm"
            ]
        },
        "Machining-and-Material-Handling-with-FAIRINO-and-Gudel": {
            "N": "Machining and Material Handling with FAIRINO and Gudel",
            "F": "Machining-and-Material-Handling-with-FAIRINO-and-Gudel.rdk",
            "I": "Machining-and-Material-Handling-with-FAIRINO-and-Gudel.png",
            "IS": "Machining-and-Material-Handling-with-FAIRINO-and-Gudel-sm.png",
            "B": [
                "FAIRINO",
                "Gudel",
                "RobotiQ"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Machining",
                "Material Handling",
                "Milling"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Folder",
                "Mechanism",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 312.7,
            "RC": 12,
            "TC": 4,
            "OC": 18,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "FAIRINO FR20"
            ],
            "AN": [
                "Gudel TMF-1 6m"
            ],
            "TN": [
                "RobotiQ Hand-E Gripper"
            ],
            "ON": [
                "Floor",
                "Pedestal H12in (Type 1)",
                "Table 1400x800x800mm"
            ]
        },
        "Machining-and-Painting-with-KUKA-and-Yaskawa-Motoman": {
            "N": "Machining and Painting with KUKA and Yaskawa Motoman",
            "F": "Machining-and-Painting-with-KUKA-and-Yaskawa-Motoman.rdk",
            "I": "Machining-and-Painting-with-KUKA-and-Yaskawa-Motoman.png",
            "IS": "Machining-and-Painting-with-KUKA-and-Yaskawa-Motoman-sm.png",
            "B": [
                "KUKA",
                "Yaskawa Motoman"
            ],
            "AP": [
                "Curve Following",
                "Machining",
                "Milling",
                "Painting"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Object",
                "Point Follow Project",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 156.3,
            "RC": 2,
            "TC": 3,
            "OC": 2,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "KUKA KR 90 R3100 extra",
                "Motoman ES200D"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Machining-and-Remote-TCP-with-Motoman-ES200D": {
            "N": "Machining and Remote TCP with Motoman ES200D",
            "F": "Machining-and-Remote-TCP-with-Motoman-ES200D.rdk",
            "I": "Machining-and-Remote-TCP-with-Motoman-ES200D.png",
            "IS": "Machining-and-Remote-TCP-with-Motoman-ES200D-sm.png",
            "B": [
                "Yaskawa Motoman"
            ],
            "AP": [
                "Machining",
                "Milling",
                "Remote TCP"
            ],
            "T": [
                "Folder",
                "Frame",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 169.6,
            "RC": 1,
            "TC": 4,
            "OC": 22,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Motoman ES200D"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Machining-and-Remote-TCP-with-Motoman-ES200D-02": {
            "N": "Machining and Remote TCP with Motoman ES200D #02",
            "F": "Machining-and-Remote-TCP-with-Motoman-ES200D-02.rdk",
            "I": "Machining-and-Remote-TCP-with-Motoman-ES200D-02.png",
            "IS": "Machining-and-Remote-TCP-with-Motoman-ES200D-02-sm.png",
            "B": [
                "Yaskawa Motoman"
            ],
            "AP": [
                "Machining",
                "Milling",
                "Remote TCP"
            ],
            "T": [
                "Machining Project",
                "Mechanism",
                "Notes",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 176.5,
            "RC": 1,
            "TC": 2,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Motoman ES200D"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Machining-and-Synchronization": {
            "N": "Machining and Synchronization",
            "F": "Machining-and-Synchronization.rdk",
            "I": "Machining-and-Synchronization.png",
            "IS": "Machining-and-Synchronization-sm.png",
            "AP": [
                "Curve Following",
                "Machining",
                "Milling",
                "Synchronization"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Synchronization",
                "Target",
                "Tool"
            ],
            "S": 107.7,
            "RC": 4,
            "TC": 1,
            "OC": 3,
            "RT": [
                "Mechanism"
            ]
        },
        "Machining-and-Synchronization-with-ABB": {
            "N": "Machining and Synchronization with ABB",
            "F": "Machining-and-Synchronization-with-ABB.rdk",
            "I": "Machining-and-Synchronization-with-ABB.png",
            "IS": "Machining-and-Synchronization-with-ABB-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Machining",
                "Milling",
                "Synchronization"
            ],
            "T": [
                "Frame",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Synchronization",
                "Target",
                "Tool"
            ],
            "S": 173.7,
            "RC": 2,
            "TC": 2,
            "OC": 4,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "ABB IRB 2600-20/1.65"
            ],
            "AN": [
                "ABB IRBP A250 D1000"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Machining-and-Synchronization-with-ABB-02": {
            "N": "Machining and Synchronization with ABB #02",
            "F": "Machining-and-Synchronization-with-ABB-02.rdk",
            "I": "Machining-and-Synchronization-with-ABB-02.png",
            "IS": "Machining-and-Synchronization-with-ABB-02-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Machining",
                "Milling",
                "Synchronization"
            ],
            "T": [
                "Frame",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Synchronization",
                "Tool"
            ],
            "S": 151.7,
            "RC": 2,
            "TC": 1,
            "OC": 2,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "ABB IRB 6640-130/3.2"
            ],
            "AN": [
                "ABB IRBP A750 D1000 H900"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Machining-and-Synchronization-with-ABB-03": {
            "N": "Machining and Synchronization with ABB #03",
            "F": "Machining-and-Synchronization-with-ABB-03.rdk",
            "I": "Machining-and-Synchronization-with-ABB-03.png",
            "IS": "Machining-and-Synchronization-with-ABB-03-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Machining",
                "Milling",
                "Synchronization"
            ],
            "T": [
                "Frame",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Synchronization",
                "Tool"
            ],
            "S": 201.0,
            "RC": 3,
            "TC": 1,
            "OC": 2,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "ABB IRB 6640-130/3.2"
            ],
            "AN": [
                "ABB IRBP L2000 L4000",
                "ABB IRBT 6004 Standard 3.5m"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Machining-and-Synchronization-with-KUKA": {
            "N": "Machining and Synchronization with KUKA",
            "F": "Machining-and-Synchronization-with-KUKA.rdk",
            "I": "Machining-and-Synchronization-with-KUKA.png",
            "IS": "Machining-and-Synchronization-with-KUKA-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Machining",
                "Milling",
                "Synchronization"
            ],
            "T": [
                "Frame",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Synchronization",
                "Tool",
                "Tutorial"
            ],
            "S": 223.2,
            "RC": 3,
            "TC": 3,
            "OC": 3,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "KUKA KR 500 3"
            ],
            "AN": [
                "KUKA DKP 400"
            ],
            "ON": [
                "Floor"
            ],
            "link": {
                "videos": [
                    "https://youtu.be/G0ncoALOaqM"
                ],
                "docs": [
                    "https://robodk.com/doc/en/Plugin-Mecsoft.html#RhinoCAMExample5x"
                ]
            }
        },
        "Machining-and-Synchronization-with-MABI-Robotic": {
            "N": "Machining and Synchronization with MABI Robotic",
            "F": "Machining-and-Synchronization-with-MABI-Robotic.rdk",
            "I": "Machining-and-Synchronization-with-MABI-Robotic.png",
            "IS": "Machining-and-Synchronization-with-MABI-Robotic-sm.png",
            "B": [
                "MABI Robotic",
                "Teknomotor"
            ],
            "AP": [
                "Machining",
                "Milling",
                "Synchronization"
            ],
            "T": [
                "Frame",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Synchronization",
                "Tool"
            ],
            "S": 210.7,
            "RC": 3,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "MABI Robotic MAX-200-2.5-P"
            ],
            "AN": [
                "MABI Robotic MLR-2500-P",
                "MABI Robotic MMT-650-500-DD"
            ],
            "TN": [
                "Teknomotor ATC710039 Spindle"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Machining-and-Trimming-with-KUKA-KR-150-R3100-prime": {
            "N": "Machining and Trimming with KUKA KR 150 R3100 prime",
            "F": "Machining-and-Trimming-with-KUKA-KR-150-R3100-prime.rdk",
            "I": "Machining-and-Trimming-with-KUKA-KR-150-R3100-prime.png",
            "IS": "Machining-and-Trimming-with-KUKA-KR-150-R3100-prime-sm.png",
            "B": [
                "KUKA",
                "RoboDK",
                "Teknomotor"
            ],
            "AP": [
                "Machining",
                "Milling",
                "Trimming"
            ],
            "T": [
                "Frame",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 210.0,
            "RC": 1,
            "TC": 2,
            "OC": 7,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "KUKA KR 150 R3100 prime"
            ],
            "ON": [
                "Floor",
                "Grid"
            ]
        },
        "Machining-with-ABB-IRB-120-3-0-6": {
            "N": "Machining with ABB IRB 120-3/0.6",
            "F": "Machining-with-ABB-IRB-120-3-0-6.rdk",
            "I": "Machining-with-ABB-IRB-120-3-0-6.png",
            "IS": "Machining-with-ABB-IRB-120-3-0-6-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Curve Following",
                "Machining",
                "Milling"
            ],
            "T": [
                "Machining Project",
                "Mechanism",
                "Notes",
                "Program",
                "Tool"
            ],
            "S": 51.1,
            "RC": 1,
            "TC": 1,
            "OC": 2,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "ABB IRB 120-3/0.6"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Machining-with-ABB-IRB-120-3-0-6-02": {
            "N": "Machining with ABB IRB 120-3/0.6 #02",
            "F": "Machining-with-ABB-IRB-120-3-0-6-02.rdk",
            "I": "Machining-with-ABB-IRB-120-3-0-6-02.png",
            "IS": "Machining-with-ABB-IRB-120-3-0-6-02-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Curve Following",
                "Machining",
                "Milling"
            ],
            "T": [
                "Machining Project",
                "Mechanism",
                "Notes",
                "Program",
                "Tool"
            ],
            "S": 51.1,
            "RC": 1,
            "TC": 1,
            "OC": 2,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "ABB IRB 120-3/0.6"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Machining-with-ABB-IRB-2600-20-1-65": {
            "N": "Machining with ABB IRB 2600-20/1.65",
            "F": "Machining-with-ABB-IRB-2600-20-1-65.rdk",
            "I": "Machining-with-ABB-IRB-2600-20-1-65.png",
            "IS": "Machining-with-ABB-IRB-2600-20-1-65-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "T": [
                "Frame",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 56.4,
            "RC": 1,
            "TC": 1,
            "OC": 1,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "ABB IRB 2600-20/1.65"
            ]
        },
        "Machining-with-ABB-IRB-4600-20-2-50": {
            "N": "Machining with ABB IRB 4600-20/2.50",
            "F": "Machining-with-ABB-IRB-4600-20-2-50.rdk",
            "I": "Machining-with-ABB-IRB-4600-20-2-50.png",
            "IS": "Machining-with-ABB-IRB-4600-20-2-50-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "T": [
                "Frame",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool",
                "Tutorial"
            ],
            "S": 168.8,
            "RC": 1,
            "TC": 3,
            "OC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "ABB IRB 4600-20/2.50"
            ],
            "ON": [
                "Floor"
            ],
            "link": {
                "docs": [
                    "https://robodk.com/doc/en/Robot-Machining.html#Ex5x"
                ]
            }
        },
        "Machining-with-Fanuc-M-10iA-10S": {
            "N": "Machining with Fanuc M-10iA/10S",
            "F": "Machining-with-Fanuc-M-10iA-10S.rdk",
            "I": "Machining-with-Fanuc-M-10iA-10S.png",
            "IS": "Machining-with-Fanuc-M-10iA-10S-sm.png",
            "B": [
                "Fanuc"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "T": [
                "Frame",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 77.3,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Fanuc M-10iA/10S"
            ],
            "ON": [
                "Floor",
                "Table 1400x800x800mm"
            ]
        },
        "Machining-with-Fanuc-M-710iC-45M": {
            "N": "Machining with Fanuc M-710iC/45M",
            "F": "Machining-with-Fanuc-M-710iC-45M.rdk",
            "I": "Machining-with-Fanuc-M-710iC-45M.png",
            "IS": "Machining-with-Fanuc-M-710iC-45M-sm.png",
            "B": [
                "Fanuc"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "T": [
                "Frame",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 174.8,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Fanuc M-710iC/45M"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Machining-with-KUKA-KR-16-2": {
            "N": "Machining with KUKA KR 16 2",
            "F": "Machining-with-KUKA-KR-16-2.rdk",
            "I": "Machining-with-KUKA-KR-16-2.png",
            "IS": "Machining-with-KUKA-KR-16-2-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "T": [
                "Frame",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool",
                "Tutorial"
            ],
            "S": 168.4,
            "RC": 1,
            "TC": 2,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "KUKA KR 16 2"
            ],
            "ON": [
                "Floor"
            ],
            "link": {
                "videos": [
                    "https://youtu.be/C7v_F7vF0Lw"
                ],
                "docs": [
                    "https://robodk.com/doc/en/Plugin-FeatureCAM.html#FCAMExample5x"
                ]
            }
        },
        "Machining-with-KUKA-KR-210-R2700-extra": {
            "N": "Machining with KUKA KR 210 R2700 extra",
            "F": "Machining-with-KUKA-KR-210-R2700-extra.rdk",
            "I": "Machining-with-KUKA-KR-210-R2700-extra.png",
            "IS": "Machining-with-KUKA-KR-210-R2700-extra-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "T": [
                "Frame",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool",
                "Tutorial"
            ],
            "S": 115.3,
            "RC": 1,
            "TC": 3,
            "OC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "KUKA KR 210 R2700 extra"
            ],
            "ON": [
                "Floor",
                "Table 1400x800x800mm"
            ],
            "link": {
                "docs": [
                    "https://robodk.com/doc/en/Robot-Machining.html#Ex3x"
                ]
            }
        },
        "Machining-with-MABI-Robotic-MAX-200-2-5-P": {
            "N": "Machining with MABI Robotic MAX-200-2.5-P",
            "F": "Machining-with-MABI-Robotic-MAX-200-2-5-P.rdk",
            "I": "Machining-with-MABI-Robotic-MAX-200-2-5-P.png",
            "IS": "Machining-with-MABI-Robotic-MAX-200-2-5-P-sm.png",
            "B": [
                "MABI Robotic",
                "Teknomotor"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "T": [
                "Frame",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 174.8,
            "RC": 1,
            "TC": 1,
            "OC": 7,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "MABI Robotic MAX-200-2.5-P"
            ],
            "TN": [
                "Teknomotor ATC710039 Spindle"
            ],
            "ON": [
                "Floor",
                "Pedestal H24in (Type 1)"
            ]
        },
        "Machining-with-Motoman-MH6S-10": {
            "N": "Machining with Motoman MH6S-10",
            "F": "Machining-with-Motoman-MH6S-10.rdk",
            "I": "Machining-with-Motoman-MH6S-10.png",
            "IS": "Machining-with-Motoman-MH6S-10-sm.png",
            "B": [
                "Yaskawa Motoman"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "T": [
                "Frame",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool",
                "Tutorial"
            ],
            "S": 92.6,
            "RC": 1,
            "TC": 4,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Motoman MH6S-10"
            ],
            "ON": [
                "Floor"
            ],
            "link": {
                "videos": [
                    "https://youtu.be/rwL_z3WYMkY"
                ],
                "docs": [
                    "https://robodk.com/doc/en/Plugin-FeatureCAM.html#FeatureCAM"
                ]
            }
        },
        "Machining-with-Staubli-TX90L": {
            "N": "Machining with Staubli TX90L",
            "F": "Machining-with-Staubli-TX90L.rdk",
            "I": "Machining-with-Staubli-TX90L.png",
            "IS": "Machining-with-Staubli-TX90L-sm.png",
            "B": [
                "Staubli"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "T": [
                "Frame",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 55.0,
            "RC": 1,
            "TC": 1,
            "OC": 2,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Staubli TX90L"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Machining-with-Yaskawa-GP180": {
            "N": "Machining with Yaskawa GP180",
            "F": "Machining-with-Yaskawa-GP180.rdk",
            "I": "Machining-with-Yaskawa-GP180.png",
            "IS": "Machining-with-Yaskawa-GP180-sm.png",
            "B": [
                "Yaskawa Motoman"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "T": [
                "Frame",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool",
                "Tutorial"
            ],
            "S": 171.5,
            "RC": 1,
            "TC": 1,
            "OC": 2,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Yaskawa GP180"
            ],
            "ON": [
                "Floor"
            ],
            "link": {
                "docs": [
                    "https://robodk.com/doc/en/Robot-Machining.html#MachiningSetup"
                ]
            }
        },
        "Machining-with-Yaskawa-GP180-02": {
            "N": "Machining with Yaskawa GP180 #02",
            "F": "Machining-with-Yaskawa-GP180-02.rdk",
            "I": "Machining-with-Yaskawa-GP180-02.png",
            "IS": "Machining-with-Yaskawa-GP180-02-sm.png",
            "B": [
                "Yaskawa Motoman"
            ],
            "AP": [
                "Machining",
                "Milling"
            ],
            "T": [
                "Frame",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool",
                "Tutorial"
            ],
            "S": 177.4,
            "RC": 1,
            "TC": 1,
            "OC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Yaskawa GP180"
            ],
            "ON": [
                "Floor"
            ],
            "link": {
                "docs": [
                    "https://robodk.com/doc/en/Robot-Machining.html#ExCNC3x"
                ]
            }
        },
        "Material-Handling-and-Palletizing-with-ABB-IRB-260": {
            "N": "Material Handling and Palletizing with ABB IRB 260",
            "F": "Material-Handling-and-Palletizing-with-ABB-IRB-260.rdk",
            "I": "Material-Handling-and-Palletizing-with-ABB-IRB-260.png",
            "IS": "Material-Handling-and-Palletizing-with-ABB-IRB-260-sm.png",
            "B": [
                "ABB",
                "OnRobot"
            ],
            "AP": [
                "Material Handling",
                "Palletizing"
            ],
            "T": [
                "Add-in",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool",
                "Tutorial"
            ],
            "S": 104.7,
            "RC": 1,
            "TC": 1,
            "OC": 13,
            "RT": [
                "Palletizing"
            ],
            "RN": [
                "ABB IRB 260"
            ],
            "TN": [
                "OnRobot VGP20 Vacuum Gripper"
            ],
            "ON": [
                "Box 12x10in (Closed)",
                "Floor",
                "Pallet 1200x800mm (Transverse)"
            ]
        },
        "Material-Handling-and-Stamping-with-Fanuc-LR-Mate-200iD-7L": {
            "N": "Material Handling and Stamping with Fanuc LR Mate 200iD/7L",
            "F": "Material-Handling-and-Stamping-with-Fanuc-LR-Mate-200iD-7L.rdk",
            "I": "Material-Handling-and-Stamping-with-Fanuc-LR-Mate-200iD-7L.png",
            "IS": "Material-Handling-and-Stamping-with-Fanuc-LR-Mate-200iD-7L-sm.png",
            "B": [
                "Fanuc"
            ],
            "AP": [
                "Material Handling",
                "Stamping"
            ],
            "T": [
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 132.4,
            "RC": 4,
            "TC": 2,
            "OC": 34,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "Fanuc LR Mate 200iD/7L"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Material-Handling-and-Synchronization-with-Brooks": {
            "N": "Material Handling and Synchronization with Brooks",
            "F": "Material-Handling-and-Synchronization-with-Brooks.rdk",
            "I": "Material-Handling-and-Synchronization-with-Brooks.png",
            "IS": "Material-Handling-and-Synchronization-with-Brooks-sm.png",
            "B": [
                "Brooks"
            ],
            "AP": [
                "Material Handling",
                "Synchronization"
            ],
            "T": [
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Synchronization",
                "Target",
                "Tool"
            ],
            "S": 56.0,
            "RC": 8,
            "TC": 3,
            "OC": 14,
            "RT": [
                "Gripper",
                "Mechanism",
                "SCARA"
            ],
            "RN": [
                "Brooks PreciseFlex 400-400"
            ],
            "AN": [
                "Brooks PreciseFlex Linear Rail 1000 -90"
            ],
            "TN": [
                "Brooks PreciseFlex Gripper 23N"
            ]
        },
        "Material-Handling-and-Weighing-with-UR5e": {
            "N": "Material Handling and Weighing with UR5e",
            "F": "Material-Handling-and-Weighing-with-UR5e.rdk",
            "I": "Material-Handling-and-Weighing-with-UR5e.png",
            "IS": "Material-Handling-and-Weighing-with-UR5e-sm.png",
            "B": [
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Material Handling",
                "Weighing"
            ],
            "T": [
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 57.5,
            "RC": 1,
            "TC": 1,
            "OC": 14,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "UR5e"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Material-Handling-and-Welding-with-Fanuc-and-KUKA": {
            "N": "Material Handling and Welding with Fanuc and KUKA",
            "F": "Material-Handling-and-Welding-with-Fanuc-and-KUKA.rdk",
            "I": "Material-Handling-and-Welding-with-Fanuc-and-KUKA.png",
            "IS": "Material-Handling-and-Welding-with-Fanuc-and-KUKA-sm.png",
            "B": [
                "Fanuc",
                "KUKA"
            ],
            "AP": [
                "Curve Following",
                "Material Handling",
                "Welding"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 214.7,
            "RC": 14,
            "TC": 3,
            "OC": 84,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "Fanuc R-2000iB/125L",
                "KUKA KR 30 L16"
            ]
        },
        "Material-Handling-and-Welding-with-KUKA": {
            "N": "Material Handling and Welding with KUKA",
            "F": "Material-Handling-and-Welding-with-KUKA.rdk",
            "I": "Material-Handling-and-Welding-with-KUKA.png",
            "IS": "Material-Handling-and-Welding-with-KUKA-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Curve Following",
                "Material Handling",
                "Welding"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 172.8,
            "RC": 25,
            "TC": 2,
            "OC": 34,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "KUKA KR 16 R1610",
                "KUKA KR 8 R1420 arc HW"
            ],
            "AN": [
                "KUKA KP1 H250 EH980"
            ]
        },
        "Material-Handling-with-ABB-IRB-1600-8-1-45": {
            "N": "Material Handling with ABB IRB 1600-8/1.45",
            "F": "Material-Handling-with-ABB-IRB-1600-8-1-45.rdk",
            "I": "Material-Handling-with-ABB-IRB-1600-8-1-45.png",
            "IS": "Material-Handling-with-ABB-IRB-1600-8-1-45-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Material Handling"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 83.2,
            "RC": 1,
            "TC": 1,
            "OC": 10,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "ABB IRB 1600-8/1.45"
            ],
            "ON": [
                "Floor",
                "Table 1400x800x800mm"
            ]
        },
        "Material-Handling-with-Doosan-Robotics-M1013": {
            "N": "Material Handling with Doosan Robotics M1013",
            "F": "Material-Handling-with-Doosan-Robotics-M1013.rdk",
            "I": "Material-Handling-with-Doosan-Robotics-M1013.png",
            "IS": "Material-Handling-with-Doosan-Robotics-M1013-sm.png",
            "B": [
                "Doosan Robotics"
            ],
            "AP": [
                "Collaborative",
                "Material Handling"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 51.8,
            "RC": 1,
            "TC": 1,
            "OC": 2,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Doosan Robotics M1013"
            ]
        },
        "Material-Handling-with-Fanuc-ARC-Mate-120iC": {
            "N": "Material Handling with Fanuc ARC Mate 120iC",
            "F": "Material-Handling-with-Fanuc-ARC-Mate-120iC.rdk",
            "I": "Material-Handling-with-Fanuc-ARC-Mate-120iC.png",
            "IS": "Material-Handling-with-Fanuc-ARC-Mate-120iC-sm.png",
            "B": [
                "Fanuc",
                "Haas",
                "RobotiQ"
            ],
            "AP": [
                "Material Handling"
            ],
            "T": [
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 201.5,
            "RC": 3,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "Fanuc ARC Mate 120iC"
            ],
            "MN": [
                "Haas UMC-500"
            ],
            "ON": [
                "Floor",
                "Table 1400x800x800mm"
            ]
        },
        "Material-Handling-with-Fanuc-R-2000iB-125L": {
            "N": "Material Handling with Fanuc R-2000iB/125L",
            "F": "Material-Handling-with-Fanuc-R-2000iB-125L.rdk",
            "I": "Material-Handling-with-Fanuc-R-2000iB-125L.png",
            "IS": "Material-Handling-with-Fanuc-R-2000iB-125L-sm.png",
            "B": [
                "Fanuc"
            ],
            "AP": [
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 307.6,
            "RC": 2,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "Fanuc R-2000iB/125L"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Material-Handling-with-Mecademic-and-RoboDK": {
            "N": "Material Handling with Mecademic and RoboDK",
            "F": "Material-Handling-with-Mecademic-and-RoboDK.rdk",
            "I": "Material-Handling-with-Mecademic-and-RoboDK.png",
            "IS": "Material-Handling-with-Mecademic-and-RoboDK-sm.png",
            "B": [
                "Kinova",
                "Mecademic",
                "RoboDK",
                "RobotiQ"
            ],
            "AP": [
                "Material Handling"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool",
                "Tutorial"
            ],
            "S": 431.6,
            "RC": 3,
            "TC": 1,
            "OC": 20,
            "RT": [
                "6 DOF",
                "Gripper"
            ],
            "RN": [
                "Mecademic Meca500 R3",
                "RoboDK RDK-1440"
            ],
            "TN": [
                "Kinova Gen3 Lite Gripper",
                "RobotiQ EPick Vacuum Gripper (4 Cups)"
            ],
            "ON": [
                "Bottle (Label)",
                "Box 215x215mm (Fold 3)",
                "Cell Frame",
                "Floor",
                "Pedestal H36in (Type 1)",
                "Pedestal H650mm (Type 2)",
                "RoboDK Logo Plate 100x100mm",
                "Sphere D100mm",
                "Table 1400x800x800mm"
            ],
            "link": {
                "docs": [
                    "https://robodk.com/doc/en/Virtual-Reality.html"
                ]
            }
        },
        "Material-Handling-with-Mecademic-Meca500-R3": {
            "N": "Material Handling with Mecademic Meca500 R3",
            "F": "Material-Handling-with-Mecademic-Meca500-R3.rdk",
            "I": "Material-Handling-with-Mecademic-Meca500-R3.png",
            "IS": "Material-Handling-with-Mecademic-Meca500-R3-sm.png",
            "B": [
                "Mecademic"
            ],
            "AP": [
                "Material Handling"
            ],
            "T": [
                "API",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 21.5,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Mecademic Meca500 R3"
            ],
            "ON": [
                "Floor",
                "Pedestal H500mm (Type 2)"
            ]
        },
        "Material-Handling-with-Motoman-HP20D": {
            "N": "Material Handling with Motoman HP20D",
            "F": "Material-Handling-with-Motoman-HP20D.rdk",
            "I": "Material-Handling-with-Motoman-HP20D.png",
            "IS": "Material-Handling-with-Motoman-HP20D-sm.png",
            "B": [
                "RobotiQ",
                "Yaskawa Motoman"
            ],
            "AP": [
                "Material Handling"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 101.3,
            "RC": 1,
            "TC": 2,
            "OC": 19,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Motoman HP20D"
            ],
            "ON": [
                "Bin Blue",
                "Bin Pink",
                "Floor"
            ]
        },
        "Material-Handling-with-Motoman-HP20D-02": {
            "N": "Material Handling with Motoman HP20D #02",
            "F": "Material-Handling-with-Motoman-HP20D-02.rdk",
            "I": "Material-Handling-with-Motoman-HP20D-02.png",
            "IS": "Material-Handling-with-Motoman-HP20D-02-sm.png",
            "B": [
                "RobotiQ",
                "Yaskawa Motoman"
            ],
            "AP": [
                "Material Handling"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 101.3,
            "RC": 2,
            "TC": 1,
            "OC": 49,
            "RT": [
                "6 DOF",
                "Gripper"
            ],
            "RN": [
                "Motoman HP20D"
            ],
            "ON": [
                "Bin Blue",
                "Bin Pink",
                "Floor"
            ]
        },
        "Material-Handling-with-TM12": {
            "N": "Material Handling with TM12",
            "F": "Material-Handling-with-TM12.rdk",
            "I": "Material-Handling-with-TM12.png",
            "IS": "Material-Handling-with-TM12-sm.png",
            "B": [
                "Omron",
                "Techman Robot"
            ],
            "AP": [
                "Collaborative",
                "Material Handling"
            ],
            "T": [
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 199.9,
            "RC": 2,
            "TC": 1,
            "OC": 8,
            "RT": [
                "6 DOF",
                "AGV/AMR"
            ],
            "RN": [
                "TM12"
            ],
            "MN": [
                "Omron LD-60"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Material-Handling-with-UR5e": {
            "N": "Material Handling with UR5e",
            "F": "Material-Handling-with-UR5e.rdk",
            "I": "Material-Handling-with-UR5e.png",
            "IS": "Material-Handling-with-UR5e-sm.png",
            "B": [
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Material Handling"
            ],
            "T": [
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 112.5,
            "RC": 3,
            "TC": 1,
            "OC": 17,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "UR5e"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Material-Handling-with-UR10e": {
            "N": "Material Handling with UR10e",
            "F": "Material-Handling-with-UR10e.rdk",
            "I": "Material-Handling-with-UR10e.png",
            "IS": "Material-Handling-with-UR10e-sm.png",
            "B": [
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Material Handling"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 51.5,
            "RC": 1,
            "TC": 1,
            "OC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "UR10e"
            ]
        },
        "Milling-and-Synchronization-with-Comau-and-Gudel": {
            "N": "Milling and Synchronization with Comau and Gudel",
            "F": "Milling-and-Synchronization-with-Comau-and-Gudel.rdk",
            "I": "Milling-and-Synchronization-with-Comau-and-Gudel.png",
            "IS": "Milling-and-Synchronization-with-Comau-and-Gudel-sm.png",
            "B": [
                "Comau",
                "Gudel"
            ],
            "AP": [
                "Curve Following",
                "Milling",
                "Synchronization"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Synchronization",
                "Target",
                "Tool"
            ],
            "S": 584.3,
            "RC": 2,
            "TC": 1,
            "OC": 1,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "Comau Smart NM 45-2.0"
            ],
            "AN": [
                "Gudel FP-6-300"
            ],
            "MN": [
                "Gudel FP-6-300"
            ]
        },
        "Milling-and-Synchronization-with-KUKA": {
            "N": "Milling and Synchronization with KUKA",
            "F": "Milling-and-Synchronization-with-KUKA.rdk",
            "I": "Milling-and-Synchronization-with-KUKA.png",
            "IS": "Milling-and-Synchronization-with-KUKA-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Curve Following",
                "Milling",
                "Synchronization"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Synchronization",
                "Target",
                "Tool"
            ],
            "S": 250.2,
            "RC": 4,
            "TC": 1,
            "OC": 12,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "KUKA KR 150 R2700 extra"
            ],
            "AN": [
                "KUKA KL 1000 2"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Milling-and-Synchronization-with-KUKA-02": {
            "N": "Milling and Synchronization with KUKA #02",
            "F": "Milling-and-Synchronization-with-KUKA-02.rdk",
            "I": "Milling-and-Synchronization-with-KUKA-02.png",
            "IS": "Milling-and-Synchronization-with-KUKA-02-sm.png",
            "B": [
                "KUKA",
                "Teknomotor"
            ],
            "AP": [
                "Curve Following",
                "Milling",
                "Synchronization"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Synchronization",
                "Target",
                "Tool"
            ],
            "S": 219.8,
            "RC": 3,
            "TC": 2,
            "OC": 4,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "KUKA KR 500 3"
            ],
            "AN": [
                "KUKA DKP 400"
            ],
            "TN": [
                "Teknomotor ATC710039 Spindle"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Milling-with-ABB-IRB-120-3-0-6": {
            "N": "Milling with ABB IRB 120-3/0.6",
            "F": "Milling-with-ABB-IRB-120-3-0-6.rdk",
            "I": "Milling-with-ABB-IRB-120-3-0-6.png",
            "IS": "Milling-with-ABB-IRB-120-3-0-6-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Curve Following",
                "Milling"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 51.8,
            "RC": 1,
            "TC": 1,
            "OC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "ABB IRB 120-3/0.6"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Milling-with-ABB-IRB-1200-5-0-9": {
            "N": "Milling with ABB IRB 1200-5/0.9",
            "F": "Milling-with-ABB-IRB-1200-5-0-9.rdk",
            "I": "Milling-with-ABB-IRB-1200-5-0-9.png",
            "IS": "Milling-with-ABB-IRB-1200-5-0-9-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Curve Following",
                "Milling"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 54.5,
            "RC": 1,
            "TC": 1,
            "OC": 2,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "ABB IRB 1200-5/0.9"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Milling-with-autonox-Robotics-articc6-2257-30kg-AT-00006": {
            "N": "Milling with autonox Robotics articc6-2257-30kg (AT_00006)",
            "F": "Milling-with-autonox-Robotics-articc6-2257-30kg-AT-00006.rdk",
            "I": "Milling-with-autonox-Robotics-articc6-2257-30kg-AT-00006.png",
            "IS": "Milling-with-autonox-Robotics-articc6-2257-30kg-AT-00006-sm.png",
            "B": [
                "Teknomotor",
                "autonox Robotics"
            ],
            "AP": [
                "Curve Following",
                "Milling"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 77.4,
            "RC": 1,
            "TC": 1,
            "OC": 2,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "autonox Robotics articc6-2257-30kg (AT_00006)"
            ],
            "TN": [
                "Teknomotor ATC71-C-LN Spindle"
            ]
        },
        "Milling-with-Kawasaki-RS006L": {
            "N": "Milling with Kawasaki RS006L",
            "F": "Milling-with-Kawasaki-RS006L.rdk",
            "I": "Milling-with-Kawasaki-RS006L.png",
            "IS": "Milling-with-Kawasaki-RS006L-sm.png",
            "B": [
                "Kawasaki"
            ],
            "AP": [
                "Curve Following",
                "Milling"
            ],
            "T": [
                "Curve Follow Project",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 100.9,
            "RC": 2,
            "TC": 1,
            "OC": 3,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "Kawasaki RS006L"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Milling-with-Motoman-HP20D": {
            "N": "Milling with Motoman HP20D",
            "F": "Milling-with-Motoman-HP20D.rdk",
            "I": "Milling-with-Motoman-HP20D.png",
            "IS": "Milling-with-Motoman-HP20D-sm.png",
            "B": [
                "Yaskawa Motoman"
            ],
            "AP": [
                "Curve Following",
                "Milling"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 101.5,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Motoman HP20D"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Mixed-Applications-with-ABB-IRB-1300-7-1-4": {
            "N": "Mixed Applications with ABB IRB 1300-7/1.4",
            "F": "Mixed-Applications-with-ABB-IRB-1300-7-1-4.rdk",
            "I": "Mixed-Applications-with-ABB-IRB-1300-7-1-4.png",
            "IS": "Mixed-Applications-with-ABB-IRB-1300-7-1-4-sm.png",
            "B": [
                "ABB",
                "OnRobot",
                "RobotiQ",
                "Zimmer"
            ],
            "AP": [
                "Curve Following",
                "Deburring",
                "Material Handling",
                "Polishing",
                "Sanding",
                "Tool Changing"
            ],
            "T": [
                "Curve Follow Project",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 95.8,
            "RC": 1,
            "TC": 5,
            "OC": 20,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "ABB IRB 1300-7/1.4"
            ],
            "TN": [
                "Zimmer FWR50F Tool Changer (Master)"
            ],
            "ON": [
                "Table 108x114x32in"
            ]
        },
        "Mixed-Applications-with-Fanuc-M-10iD-12": {
            "N": "Mixed Applications with Fanuc M-10iD/12",
            "F": "Mixed-Applications-with-Fanuc-M-10iD-12.rdk",
            "I": "Mixed-Applications-with-Fanuc-M-10iD-12.png",
            "IS": "Mixed-Applications-with-Fanuc-M-10iD-12-sm.png",
            "B": [
                "DIY Robotics",
                "Fanuc"
            ],
            "AP": [
                "Assembly",
                "Conveying",
                "Material Handling",
                "Screwing"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 204.7,
            "RC": 10,
            "TC": 4,
            "OC": 37,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "Fanuc M-10iD/12"
            ],
            "ON": [
                "DIY Robotics Satellite-66",
                "Floor"
            ]
        },
        "Mixed-Applications-with-KUKA": {
            "N": "Mixed Applications with KUKA",
            "F": "Mixed-Applications-with-KUKA.rdk",
            "I": "Mixed-Applications-with-KUKA.png",
            "IS": "Mixed-Applications-with-KUKA-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Calibration",
                "Inspection",
                "Machining",
                "Milling",
                "Synchronization"
            ],
            "T": [
                "API",
                "Calibration Project",
                "Folder",
                "Frame",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Synchronization",
                "Target",
                "Tool"
            ],
            "S": 171.6,
            "RC": 4,
            "TC": 14,
            "OC": 11,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "KUKA KR 500 3"
            ],
            "AN": [
                "KUKA DKP 400"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Mixed-Applications-with-Multiple-Robots": {
            "N": "Mixed Applications with Multiple Robots",
            "F": "Mixed-Applications-with-Multiple-Robots.rdk",
            "I": "Mixed-Applications-with-Multiple-Robots.png",
            "IS": "Mixed-Applications-with-Multiple-Robots-sm.png",
            "B": [
                "ABB",
                "Comau",
                "Doosan Robotics",
                "Fanuc",
                "Gudel",
                "KUKA",
                "Omron",
                "RoboDK",
                "RobotiQ",
                "Teknomotor",
                "Universal Robots",
                "Yaskawa Motoman"
            ],
            "AP": [
                "Collaborative",
                "Conveying",
                "Curve Following",
                "Dispensing",
                "Machining",
                "Material Handling",
                "Milling",
                "Palletizing",
                "Screwing",
                "Synchronization"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Folder",
                "Frame",
                "Machining Project",
                "Mechanism",
                "Notes",
                "Object",
                "Palletizing Project",
                "Point Follow Project",
                "Program",
                "Python",
                "Script",
                "Synchronization",
                "Target",
                "Tool"
            ],
            "S": 1532.1,
            "RC": 60,
            "TC": 40,
            "OC": 358,
            "RT": [
                "6 DOF",
                "AGV/AMR",
                "Delta",
                "Gripper",
                "Mechanism",
                "SCARA"
            ],
            "RN": [
                "ABB IRB 2400/16",
                "ABB IRB 2600-12/1.85",
                "ABB IRB 360-1/800 4D",
                "ABB IRB 910SC-3/0.65",
                "Comau Smart NM 45-2.0",
                "Doosan Robotics H2017",
                "Fanuc LR Mate 200iD/4S",
                "Fanuc M-10iD/12",
                "Fanuc M-710iC/45M",
                "Fanuc R-1000iA/80F",
                "KUKA KR 120 R2900 extra",
                "KUKA KR 500 3",
                "Motoman ES200N",
                "Omron TM12",
                "RoboDK RDK-1100",
                "UR10"
            ],
            "AN": [
                "Gudel FP-6-300",
                "KUKA DKP 400"
            ],
            "MN": [
                "Omron LD-60"
            ],
            "TN": [
                "Teknomotor ATC710039 Spindle"
            ],
            "ON": [
                "Floor",
                "Pedestal H24in (Type 1)"
            ]
        },
        "Mixed-Applications-with-Omron": {
            "N": "Mixed Applications with Omron",
            "F": "Mixed-Applications-with-Omron.rdk",
            "I": "Mixed-Applications-with-Omron.png",
            "IS": "Mixed-Applications-with-Omron-sm.png",
            "B": [
                "Omron"
            ],
            "AP": [
                "Collaborative",
                "Conveying",
                "Material Handling",
                "Packaging",
                "Palletizing"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Palletizing Project",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 279.6,
            "RC": 6,
            "TC": 6,
            "OC": 105,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "Omron TM12",
                "Omron TM12X"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Mixed-Applications-with-Omron-TM12X": {
            "N": "Mixed Applications with Omron TM12X",
            "F": "Mixed-Applications-with-Omron-TM12X.rdk",
            "I": "Mixed-Applications-with-Omron-TM12X.png",
            "IS": "Mixed-Applications-with-Omron-TM12X-sm.png",
            "B": [
                "API",
                "Omron"
            ],
            "AP": [
                "Collaborative",
                "Conveying",
                "Material Handling",
                "Packaging",
                "Palletizing"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 269.9,
            "RC": 6,
            "TC": 6,
            "OC": 215,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "Omron TM12X"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Mixed-Applications-with-RoboDK-RDK-1100": {
            "N": "Mixed Applications with RoboDK RDK-1100",
            "F": "Mixed-Applications-with-RoboDK-RDK-1100.rdk",
            "I": "Mixed-Applications-with-RoboDK-RDK-1100.png",
            "IS": "Mixed-Applications-with-RoboDK-RDK-1100-sm.png",
            "B": [
                "RoboDK",
                "RobotiQ"
            ],
            "AP": [
                "Curve Following",
                "Machining",
                "Material Handling",
                "Milling",
                "Palletizing",
                "Synchronization"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Palletizing Project",
                "Program",
                "Python",
                "Script",
                "Synchronization",
                "Target",
                "Tool"
            ],
            "S": 168.9,
            "RC": 7,
            "TC": 3,
            "OC": 76,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "RoboDK RDK-1100"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Mixed-Applications-with-RoboDK-RDK-1440": {
            "N": "Mixed Applications with RoboDK RDK-1440",
            "F": "Mixed-Applications-with-RoboDK-RDK-1440.rdk",
            "I": "Mixed-Applications-with-RoboDK-RDK-1440.png",
            "IS": "Mixed-Applications-with-RoboDK-RDK-1440-sm.png",
            "B": [
                "RoboDK"
            ],
            "AP": [
                "Conveying",
                "Material Handling",
                "Packaging",
                "Palletizing"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Palletizing Project",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 196.9,
            "RC": 3,
            "TC": 1,
            "OC": 21,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "RoboDK RDK-1440"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Mixed-Applications-with-RoboDK-RDK-1440-02": {
            "N": "Mixed Applications with RoboDK RDK-1440 #02",
            "F": "Mixed-Applications-with-RoboDK-RDK-1440-02.rdk",
            "I": "Mixed-Applications-with-RoboDK-RDK-1440-02.png",
            "IS": "Mixed-Applications-with-RoboDK-RDK-1440-02-sm.png",
            "B": [
                "OnRobot",
                "RoboDK"
            ],
            "AP": [
                "Conveying",
                "HMI",
                "Inspection",
                "Material Handling",
                "Palletizing"
            ],
            "T": [
                "API",
                "Add-in",
                "Camera",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool",
                "Tutorial"
            ],
            "S": 168.7,
            "RC": 2,
            "TC": 1,
            "OC": 9,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "RoboDK RDK-1440"
            ],
            "TN": [
                "OnRobot VGC10 Vacuum Gripper"
            ],
            "ON": [
                "Floor",
                "Pallet 1200x800mm (Transverse)",
                "Pedestal H500mm (Type 2)"
            ],
            "link": {
                "docs": [
                    "https://robodk.com/doc/en/Display-Panel.html#DispPanel"
                ]
            }
        },
        "Mixed-Applications-with-TM12X": {
            "N": "Mixed Applications with TM12X",
            "F": "Mixed-Applications-with-TM12X.rdk",
            "I": "Mixed-Applications-with-TM12X.png",
            "IS": "Mixed-Applications-with-TM12X-sm.png",
            "B": [
                "API",
                "Mazak",
                "RobotiQ",
                "Techman Robot"
            ],
            "AP": [
                "Collaborative",
                "Conveying",
                "Machine Tending",
                "Machining",
                "Material Handling"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 293.5,
            "RC": 6,
            "TC": 2,
            "OC": 56,
            "RT": [
                "6 DOF",
                "Gripper",
                "Mechanism"
            ],
            "RN": [
                "TM12X"
            ]
        },
        "Mixed-Applications-with-UR10e": {
            "N": "Mixed Applications with UR10e",
            "F": "Mixed-Applications-with-UR10e.rdk",
            "I": "Mixed-Applications-with-UR10e.png",
            "IS": "Mixed-Applications-with-UR10e-sm.png",
            "B": [
                "API",
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Conveying",
                "Material Handling",
                "Packaging",
                "Palletizing"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 268.4,
            "RC": 6,
            "TC": 6,
            "OC": 215,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "UR10e"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Painting-and-Spraying-with-ABB-IRB-2600-12-1-85": {
            "N": "Painting and Spraying with ABB IRB 2600-12/1.85",
            "F": "Painting-and-Spraying-with-ABB-IRB-2600-12-1-85.rdk",
            "I": "Painting-and-Spraying-with-ABB-IRB-2600-12-1-85.png",
            "IS": "Painting-and-Spraying-with-ABB-IRB-2600-12-1-85-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Painting",
                "Spraying"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 125.4,
            "RC": 2,
            "TC": 3,
            "OC": 3,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "ABB IRB 2600-12/1.85"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Painting-with-Fanuc-M-710iC-45M": {
            "N": "Painting with Fanuc M-710iC/45M",
            "F": "Painting-with-Fanuc-M-710iC-45M.rdk",
            "I": "Painting-with-Fanuc-M-710iC-45M.png",
            "IS": "Painting-with-Fanuc-M-710iC-45M-sm.png",
            "B": [
                "Fanuc"
            ],
            "AP": [
                "Painting"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 173.4,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Fanuc M-710iC/45M"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Painting-with-igus-ReBeL-6DOF": {
            "N": "Painting with igus ReBeL 6DOF",
            "F": "Painting-with-igus-ReBeL-6DOF.rdk",
            "I": "Painting-with-igus-ReBeL-6DOF.png",
            "IS": "Painting-with-igus-ReBeL-6DOF-sm.png",
            "B": [
                "igus"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Painting"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 51.8,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "igus ReBeL 6DOF"
            ],
            "ON": [
                "Floor",
                "Pedestal H12in (Type 1)"
            ]
        },
        "Painting-with-KUKA-KR-5-arc": {
            "N": "Painting with KUKA KR 5 arc",
            "F": "Painting-with-KUKA-KR-5-arc.rdk",
            "I": "Painting-with-KUKA-KR-5-arc.png",
            "IS": "Painting-with-KUKA-KR-5-arc-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Curve Following",
                "Painting"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Tool"
            ],
            "S": 82.4,
            "RC": 1,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "KUKA KR 5 arc"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Painting-with-KUKA-KR-10-R1100-sixx": {
            "N": "Painting with KUKA KR 10 R1100 sixx",
            "F": "Painting-with-KUKA-KR-10-R1100-sixx.rdk",
            "I": "Painting-with-KUKA-KR-10-R1100-sixx.png",
            "IS": "Painting-with-KUKA-KR-10-R1100-sixx-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Curve Following",
                "Painting"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 99.9,
            "RC": 1,
            "TC": 1,
            "OC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "KUKA KR 10 R1100 sixx"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Painting-with-UR10": {
            "N": "Painting with UR10",
            "F": "Painting-with-UR10.rdk",
            "I": "Painting-with-UR10.png",
            "IS": "Painting-with-UR10-sm.png",
            "B": [
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Painting"
            ],
            "T": [
                "API",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool",
                "Tutorial"
            ],
            "S": 115.7,
            "RC": 1,
            "TC": 1,
            "OC": 2,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "UR10"
            ],
            "ON": [
                "Floor"
            ],
            "link": {
                "docs": [
                    "https://robodk.com/doc/en/Getting-Started.html"
                ]
            }
        },
        "Palletizing-with-Fanuc-R-1000iA-80F": {
            "N": "Palletizing with Fanuc R-1000iA/80F",
            "F": "Palletizing-with-Fanuc-R-1000iA-80F.rdk",
            "I": "Palletizing-with-Fanuc-R-1000iA-80F.png",
            "IS": "Palletizing-with-Fanuc-R-1000iA-80F-sm.png",
            "B": [
                "Fanuc"
            ],
            "AP": [
                "Palletizing"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 195.5,
            "RC": 2,
            "TC": 2,
            "OC": 17,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "Fanuc R-1000iA/80F"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Polishing-and-Sanding-with-ABB-CRB-15000": {
            "N": "Polishing and Sanding with ABB CRB 15000",
            "F": "Polishing-and-Sanding-with-ABB-CRB-15000.rdk",
            "I": "Polishing-and-Sanding-with-ABB-CRB-15000.png",
            "IS": "Polishing-and-Sanding-with-ABB-CRB-15000-sm.png",
            "B": [
                "ABB",
                "RobotiQ"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Mechanism",
                "Notes",
                "Program",
                "Tool"
            ],
            "S": 53.7,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "ABB CRB 15000"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-ABB-IRB-1200-5-0-9": {
            "N": "Polishing and Sanding with ABB IRB 1200-5/0.9",
            "F": "Polishing-and-Sanding-with-ABB-IRB-1200-5-0-9.rdk",
            "I": "Polishing-and-Sanding-with-ABB-IRB-1200-5-0-9.png",
            "IS": "Polishing-and-Sanding-with-ABB-IRB-1200-5-0-9-sm.png",
            "B": [
                "ABB",
                "RobotiQ"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 54.6,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "ABB IRB 1200-5/0.9"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Adept-Viper-s850": {
            "N": "Polishing and Sanding with Adept Viper s850",
            "F": "Polishing-and-Sanding-with-Adept-Viper-s850.rdk",
            "I": "Polishing-and-Sanding-with-Adept-Viper-s850.png",
            "IS": "Polishing-and-Sanding-with-Adept-Viper-s850-sm.png",
            "B": [
                "Adept",
                "RobotiQ"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 53.3,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Adept Viper s850"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Agilebot-GBT-P7A": {
            "N": "Polishing and Sanding with Agilebot GBT-P7A",
            "F": "Polishing-and-Sanding-with-Agilebot-GBT-P7A.rdk",
            "I": "Polishing-and-Sanding-with-Agilebot-GBT-P7A.png",
            "IS": "Polishing-and-Sanding-with-Agilebot-GBT-P7A-sm.png",
            "B": [
                "Agilebot",
                "RobotiQ"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 53.6,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Agilebot GBT-P7A"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-AUBO-i12": {
            "N": "Polishing and Sanding with AUBO-i12",
            "F": "Polishing-and-Sanding-with-AUBO-i12.rdk",
            "I": "Polishing-and-Sanding-with-AUBO-i12.png",
            "IS": "Polishing-and-Sanding-with-AUBO-i12-sm.png",
            "B": [
                "AUBO",
                "RobotiQ"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 53.7,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "AUBO-i12"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-AUCTECH-AX-7L": {
            "N": "Polishing and Sanding with AUCTECH AX-7L",
            "F": "Polishing-and-Sanding-with-AUCTECH-AX-7L.rdk",
            "I": "Polishing-and-Sanding-with-AUCTECH-AX-7L.png",
            "IS": "Polishing-and-Sanding-with-AUCTECH-AX-7L-sm.png",
            "B": [
                "AUCTECH",
                "RobotiQ"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 55.0,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "AUCTECH AX-7L"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-BORUNTE-BRTIRUS-0707A-v21": {
            "N": "Polishing and Sanding with BORUNTE BRTIRUS 0707A-v21",
            "F": "Polishing-and-Sanding-with-BORUNTE-BRTIRUS-0707A-v21.rdk",
            "I": "Polishing-and-Sanding-with-BORUNTE-BRTIRUS-0707A-v21.png",
            "IS": "Polishing-and-Sanding-with-BORUNTE-BRTIRUS-0707A-v21-sm.png",
            "B": [
                "BORUNTE",
                "RobotiQ"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 53.9,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "BORUNTE BRTIRUS 0707A-v21"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Comau-MyCo-3-5-0-95": {
            "N": "Polishing and Sanding with Comau MyCo-3.5-0.95",
            "F": "Polishing-and-Sanding-with-Comau-MyCo-3-5-0-95.rdk",
            "I": "Polishing-and-Sanding-with-Comau-MyCo-3-5-0-95.png",
            "IS": "Polishing-and-Sanding-with-Comau-MyCo-3-5-0-95-sm.png",
            "B": [
                "Comau",
                "RobotiQ"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 51.9,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Comau MyCo-3.5-0.95"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Delta-Electronics-DC06": {
            "N": "Polishing and Sanding with Delta Electronics DC06",
            "F": "Polishing-and-Sanding-with-Delta-Electronics-DC06.rdk",
            "I": "Polishing-and-Sanding-with-Delta-Electronics-DC06.png",
            "IS": "Polishing-and-Sanding-with-Delta-Electronics-DC06-sm.png",
            "B": [
                "Delta Electronics",
                "RobotiQ"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 50.4,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Delta Electronics DC06"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Denso-Cobotta-PRO-900": {
            "N": "Polishing and Sanding with Denso Cobotta PRO 900",
            "F": "Polishing-and-Sanding-with-Denso-Cobotta-PRO-900.rdk",
            "I": "Polishing-and-Sanding-with-Denso-Cobotta-PRO-900.png",
            "IS": "Polishing-and-Sanding-with-Denso-Cobotta-PRO-900-sm.png",
            "B": [
                "Denso",
                "RobotiQ"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 52.4,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Denso Cobotta PRO 900"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Dobot-CR10": {
            "N": "Polishing and Sanding with Dobot CR10",
            "F": "Polishing-and-Sanding-with-Dobot-CR10.rdk",
            "I": "Polishing-and-Sanding-with-Dobot-CR10.png",
            "IS": "Polishing-and-Sanding-with-Dobot-CR10-sm.png",
            "B": [
                "Dobot",
                "RobotiQ"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 56.8,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Dobot CR10"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Doosan-Robotics-A0912": {
            "N": "Polishing and Sanding with Doosan Robotics A0912",
            "F": "Polishing-and-Sanding-with-Doosan-Robotics-A0912.rdk",
            "I": "Polishing-and-Sanding-with-Doosan-Robotics-A0912.png",
            "IS": "Polishing-and-Sanding-with-Doosan-Robotics-A0912-sm.png",
            "B": [
                "Doosan Robotics",
                "RobotiQ"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 53.4,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Doosan Robotics A0912"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Elite-Robots-CS612": {
            "N": "Polishing and Sanding with Elite Robots CS612",
            "F": "Polishing-and-Sanding-with-Elite-Robots-CS612.rdk",
            "I": "Polishing-and-Sanding-with-Elite-Robots-CS612.png",
            "IS": "Polishing-and-Sanding-with-Elite-Robots-CS612-sm.png",
            "B": [
                "Elite Robots",
                "RobotiQ"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 54.8,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Elite Robots CS612"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Epson-VT6": {
            "N": "Polishing and Sanding with Epson VT6",
            "F": "Polishing-and-Sanding-with-Epson-VT6.rdk",
            "I": "Polishing-and-Sanding-with-Epson-VT6.png",
            "IS": "Polishing-and-Sanding-with-Epson-VT6-sm.png",
            "B": [
                "Epson",
                "RobotiQ"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 54.0,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Epson VT6"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-FAIR-Innovation-F16": {
            "N": "Polishing and Sanding with FAIR Innovation F16",
            "F": "Polishing-and-Sanding-with-FAIR-Innovation-F16.rdk",
            "I": "Polishing-and-Sanding-with-FAIR-Innovation-F16.png",
            "IS": "Polishing-and-Sanding-with-FAIR-Innovation-F16-sm.png",
            "B": [
                "FAIRINO",
                "RobotiQ"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 55.0,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "FAIR Innovation F16"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Fanuc-CR-7iA-L": {
            "N": "Polishing and Sanding with Fanuc CR-7iA/L",
            "F": "Polishing-and-Sanding-with-Fanuc-CR-7iA-L.rdk",
            "I": "Polishing-and-Sanding-with-Fanuc-CR-7iA-L.png",
            "IS": "Polishing-and-Sanding-with-Fanuc-CR-7iA-L-sm.png",
            "B": [
                "Fanuc",
                "RobotiQ"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 54.8,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Fanuc CR-7iA/L"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Fanuc-LR-Mate-200iD-7L": {
            "N": "Polishing and Sanding with Fanuc LR Mate 200iD/7L",
            "F": "Polishing-and-Sanding-with-Fanuc-LR-Mate-200iD-7L.rdk",
            "I": "Polishing-and-Sanding-with-Fanuc-LR-Mate-200iD-7L.png",
            "IS": "Polishing-and-Sanding-with-Fanuc-LR-Mate-200iD-7L-sm.png",
            "B": [
                "Fanuc",
                "RobotiQ"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 53.3,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Fanuc LR Mate 200iD/7L"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Flexiv-Rizon-4": {
            "N": "Polishing and Sanding with Flexiv Rizon 4",
            "F": "Polishing-and-Sanding-with-Flexiv-Rizon-4.rdk",
            "I": "Polishing-and-Sanding-with-Flexiv-Rizon-4.png",
            "IS": "Polishing-and-Sanding-with-Flexiv-Rizon-4-sm.png",
            "B": [
                "Flexiv",
                "RobotiQ"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 50.7,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "7 DOF"
            ],
            "RN": [
                "Flexiv Rizon 4"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Franka-Emika-Panda": {
            "N": "Polishing and Sanding with Franka Emika Panda",
            "F": "Polishing-and-Sanding-with-Franka-Emika-Panda.rdk",
            "I": "Polishing-and-Sanding-with-Franka-Emika-Panda.png",
            "IS": "Polishing-and-Sanding-with-Franka-Emika-Panda-sm.png",
            "B": [
                "Franka",
                "RobotiQ"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 52.4,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "7 DOF"
            ],
            "RN": [
                "Franka Emika Panda"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Han-s-E10": {
            "N": "Polishing and Sanding with Han's E10",
            "F": "Polishing-and-Sanding-with-Han-s-E10.rdk",
            "I": "Polishing-and-Sanding-with-Han-s-E10.png",
            "IS": "Polishing-and-Sanding-with-Han-s-E10-sm.png",
            "B": [
                "Han's",
                "RobotiQ"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 53.7,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Han's E10"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-HCR-12": {
            "N": "Polishing and Sanding with HCR-12",
            "F": "Polishing-and-Sanding-with-HCR-12.rdk",
            "I": "Polishing-and-Sanding-with-HCR-12.png",
            "IS": "Polishing-and-Sanding-with-HCR-12-sm.png",
            "B": [
                "Hanwha",
                "RobotiQ"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 58.6,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "HCR-12"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-HIWIN-RT605-909-GB": {
            "N": "Polishing and Sanding with HIWIN RT605-909-GB",
            "F": "Polishing-and-Sanding-with-HIWIN-RT605-909-GB.rdk",
            "I": "Polishing-and-Sanding-with-HIWIN-RT605-909-GB.png",
            "IS": "Polishing-and-Sanding-with-HIWIN-RT605-909-GB-sm.png",
            "B": [
                "HIWIN",
                "RobotiQ"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 55.8,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "HIWIN RT605-909-GB"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Huayan-E05": {
            "N": "Polishing and Sanding with Huayan E05",
            "F": "Polishing-and-Sanding-with-Huayan-E05.rdk",
            "I": "Polishing-and-Sanding-with-Huayan-E05.png",
            "IS": "Polishing-and-Sanding-with-Huayan-E05-sm.png",
            "B": [
                "Huayan Han's",
                "RobotiQ"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 50.9,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Huayan E05"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Hyundai-YL012": {
            "N": "Polishing and Sanding with Hyundai YL012",
            "F": "Polishing-and-Sanding-with-Hyundai-YL012.rdk",
            "I": "Polishing-and-Sanding-with-Hyundai-YL012.png",
            "IS": "Polishing-and-Sanding-with-Hyundai-YL012-sm.png",
            "B": [
                "Hyundai Robotics",
                "RobotiQ"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 58.2,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Hyundai YL012"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-IIMT-CA-05": {
            "N": "Polishing and Sanding with IIMT-CA-05",
            "F": "Polishing-and-Sanding-with-IIMT-CA-05.rdk",
            "I": "Polishing-and-Sanding-with-IIMT-CA-05.png",
            "IS": "Polishing-and-Sanding-with-IIMT-CA-05-sm.png",
            "B": [
                "IIMT",
                "RobotiQ"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 50.1,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "IIMT-CA-05"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-JAKA-Zu18": {
            "N": "Polishing and Sanding with JAKA Zu18",
            "F": "Polishing-and-Sanding-with-JAKA-Zu18.rdk",
            "I": "Polishing-and-Sanding-with-JAKA-Zu18.png",
            "IS": "Polishing-and-Sanding-with-JAKA-Zu18-sm.png",
            "B": [
                "JAKA",
                "RobotiQ"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 51.4,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "JAKA Zu18"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Kawasaki-RS005L": {
            "N": "Polishing and Sanding with Kawasaki RS005L",
            "F": "Polishing-and-Sanding-with-Kawasaki-RS005L.rdk",
            "I": "Polishing-and-Sanding-with-Kawasaki-RS005L.png",
            "IS": "Polishing-and-Sanding-with-Kawasaki-RS005L-sm.png",
            "B": [
                "Kawasaki",
                "RobotiQ"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 53.6,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Kawasaki RS005L"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-KUKA-iisy-3-R1300": {
            "N": "Polishing and Sanding with KUKA iisy 3 R1300",
            "F": "Polishing-and-Sanding-with-KUKA-iisy-3-R1300.rdk",
            "I": "Polishing-and-Sanding-with-KUKA-iisy-3-R1300.png",
            "IS": "Polishing-and-Sanding-with-KUKA-iisy-3-R1300-sm.png",
            "B": [
                "KUKA",
                "RobotiQ"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 56.8,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "KUKA iisy 3 R1300"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-KUKA-KR-6-R900-sixx": {
            "N": "Polishing and Sanding with KUKA KR 6 R900 sixx",
            "F": "Polishing-and-Sanding-with-KUKA-KR-6-R900-sixx.rdk",
            "I": "Polishing-and-Sanding-with-KUKA-KR-6-R900-sixx.png",
            "IS": "Polishing-and-Sanding-with-KUKA-KR-6-R900-sixx-sm.png",
            "B": [
                "KUKA",
                "RobotiQ"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 54.0,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "KUKA KR 6 R900 sixx"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-KUKA-KR-10-R900-sixx": {
            "N": "Polishing and Sanding with KUKA KR 10 R900 sixx",
            "F": "Polishing-and-Sanding-with-KUKA-KR-10-R900-sixx.rdk",
            "I": "Polishing-and-Sanding-with-KUKA-KR-10-R900-sixx.png",
            "IS": "Polishing-and-Sanding-with-KUKA-KR-10-R900-sixx-sm.png",
            "B": [
                "KUKA",
                "RobotiQ"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 52.6,
            "RC": 1,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "KUKA KR 10 R900 sixx"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-KUKA-KR-100-R3500-press": {
            "N": "Polishing and Sanding with KUKA KR 100 R3500 press",
            "F": "Polishing-and-Sanding-with-KUKA-KR-100-R3500-press.rdk",
            "I": "Polishing-and-Sanding-with-KUKA-KR-100-R3500-press.png",
            "IS": "Polishing-and-Sanding-with-KUKA-KR-100-R3500-press-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool",
                "Tutorial"
            ],
            "S": 199.6,
            "RC": 1,
            "TC": 2,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "KUKA KR 100 R3500 press"
            ],
            "ON": [
                "Floor"
            ],
            "link": {
                "docs": [
                    "https://robodk.com/doc/en/Robot-Machining.html#ExPolishing"
                ]
            }
        },
        "Polishing-and-Sanding-with-Leantec-LA906-7H-R": {
            "N": "Polishing and Sanding with Leantec LA906-7H-R",
            "F": "Polishing-and-Sanding-with-Leantec-LA906-7H-R.rdk",
            "I": "Polishing-and-Sanding-with-Leantec-LA906-7H-R.png",
            "IS": "Polishing-and-Sanding-with-Leantec-LA906-7H-R-sm.png",
            "B": [
                "Leantec",
                "RobotiQ"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 55.8,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Leantec LA906-7H-R"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Mitsubishi-RV-5AS-D": {
            "N": "Polishing and Sanding with Mitsubishi RV-5AS-D",
            "F": "Polishing-and-Sanding-with-Mitsubishi-RV-5AS-D.rdk",
            "I": "Polishing-and-Sanding-with-Mitsubishi-RV-5AS-D.png",
            "IS": "Polishing-and-Sanding-with-Mitsubishi-RV-5AS-D-sm.png",
            "B": [
                "Mitsubishi",
                "RobotiQ"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 52.5,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Mitsubishi RV-5AS-D"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Motoman-MH5LF": {
            "N": "Polishing and Sanding with Motoman MH5LF",
            "F": "Polishing-and-Sanding-with-Motoman-MH5LF.rdk",
            "I": "Polishing-and-Sanding-with-Motoman-MH5LF.png",
            "IS": "Polishing-and-Sanding-with-Motoman-MH5LF-sm.png",
            "B": [
                "RobotiQ",
                "Yaskawa Motoman"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 54.2,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Motoman MH5LF"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Nachi-MZ07L": {
            "N": "Polishing and Sanding with Nachi MZ07L",
            "F": "Polishing-and-Sanding-with-Nachi-MZ07L.rdk",
            "I": "Polishing-and-Sanding-with-Nachi-MZ07L.png",
            "IS": "Polishing-and-Sanding-with-Nachi-MZ07L-sm.png",
            "B": [
                "Nachi",
                "RobotiQ"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 54.9,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Nachi MZ07L"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Neura-LARA-8": {
            "N": "Polishing and Sanding with Neura LARA 8",
            "F": "Polishing-and-Sanding-with-Neura-LARA-8.rdk",
            "I": "Polishing-and-Sanding-with-Neura-LARA-8.png",
            "IS": "Polishing-and-Sanding-with-Neura-LARA-8-sm.png",
            "B": [
                "Neura",
                "RobotiQ"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 55.9,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Neura LARA 8"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Omron-TM5X-900": {
            "N": "Polishing and Sanding with Omron TM5X-900",
            "F": "Polishing-and-Sanding-with-Omron-TM5X-900.rdk",
            "I": "Polishing-and-Sanding-with-Omron-TM5X-900.png",
            "IS": "Polishing-and-Sanding-with-Omron-TM5X-900-sm.png",
            "B": [
                "Omron",
                "RobotiQ"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 50.3,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Omron TM5X-900"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Panasonic-TA-1000": {
            "N": "Polishing and Sanding with Panasonic TA-1000",
            "F": "Polishing-and-Sanding-with-Panasonic-TA-1000.rdk",
            "I": "Polishing-and-Sanding-with-Panasonic-TA-1000.png",
            "IS": "Polishing-and-Sanding-with-Panasonic-TA-1000-sm.png",
            "B": [
                "Panasonic",
                "RobotiQ"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 58.3,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Panasonic TA-1000"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-RB10-1300": {
            "N": "Polishing and Sanding with RB10-1300",
            "F": "Polishing-and-Sanding-with-RB10-1300.rdk",
            "I": "Polishing-and-Sanding-with-RB10-1300.png",
            "IS": "Polishing-and-Sanding-with-RB10-1300-sm.png",
            "B": [
                "Rainbow Robotics",
                "RobotiQ"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 54.8,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RB10-1300"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-RoboDK-RDK-1100": {
            "N": "Polishing and Sanding with RoboDK RDK-1100",
            "F": "Polishing-and-Sanding-with-RoboDK-RDK-1100.rdk",
            "I": "Polishing-and-Sanding-with-RoboDK-RDK-1100.png",
            "IS": "Polishing-and-Sanding-with-RoboDK-RDK-1100-sm.png",
            "B": [
                "RoboDK",
                "RobotiQ"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 55.8,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-1100"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-RoboDK-RDK-COBOT-1200": {
            "N": "Polishing and Sanding with RoboDK RDK-COBOT-1200",
            "F": "Polishing-and-Sanding-with-RoboDK-RDK-COBOT-1200.rdk",
            "I": "Polishing-and-Sanding-with-RoboDK-RDK-COBOT-1200.png",
            "IS": "Polishing-and-Sanding-with-RoboDK-RDK-COBOT-1200-sm.png",
            "B": [
                "RoboDK",
                "RobotiQ"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 57.2,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-COBOT-1200"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Robostar-RA007": {
            "N": "Polishing and Sanding with Robostar RA007",
            "F": "Polishing-and-Sanding-with-Robostar-RA007.rdk",
            "I": "Polishing-and-Sanding-with-Robostar-RA007.png",
            "IS": "Polishing-and-Sanding-with-Robostar-RA007-sm.png",
            "B": [
                "Robostar",
                "RobotiQ"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 55.5,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Robostar RA007"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Rokae-XB7L": {
            "N": "Polishing and Sanding with Rokae XB7L",
            "F": "Polishing-and-Sanding-with-Rokae-XB7L.rdk",
            "I": "Polishing-and-Sanding-with-Rokae-XB7L.png",
            "IS": "Polishing-and-Sanding-with-Rokae-XB7L-sm.png",
            "B": [
                "RobotiQ",
                "Rokae"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 55.7,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Rokae XB7L"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Schneider-Electric-Lexium-Cobot-LXMRL18S0000": {
            "N": "Polishing and Sanding with Schneider Electric Lexium Cobot LXMRL18S0000",
            "F": "Polishing-and-Sanding-with-Schneider-Electric-Lexium-Cobot-LXMRL18S0000.rdk",
            "I": "Polishing-and-Sanding-with-Schneider-Electric-Lexium-Cobot-LXMRL18S0000.png",
            "IS": "Polishing-and-Sanding-with-Schneider-Electric-Lexium-Cobot-LXMRL18S0000-sm.png",
            "B": [
                "RobotiQ",
                "Schneider Electric"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 51.4,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Schneider Electric Lexium Cobot LXMRL18S0000"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Shibaura-Machine-TV800": {
            "N": "Polishing and Sanding with Shibaura Machine TV800",
            "F": "Polishing-and-Sanding-with-Shibaura-Machine-TV800.rdk",
            "I": "Polishing-and-Sanding-with-Shibaura-Machine-TV800.png",
            "IS": "Polishing-and-Sanding-with-Shibaura-Machine-TV800-sm.png",
            "B": [
                "RobotiQ",
                "Shibaura Machine"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 53.4,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Shibaura Machine TV800"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Siasun-GCR10-1300": {
            "N": "Polishing and Sanding with Siasun GCR10-1300",
            "F": "Polishing-and-Sanding-with-Siasun-GCR10-1300.rdk",
            "I": "Polishing-and-Sanding-with-Siasun-GCR10-1300.png",
            "IS": "Polishing-and-Sanding-with-Siasun-GCR10-1300-sm.png",
            "B": [
                "RobotiQ",
                "Siasun"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 54.5,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Siasun GCR10-1300"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Standard-Bots-RO1": {
            "N": "Polishing and Sanding with Standard Bots RO1",
            "F": "Polishing-and-Sanding-with-Standard-Bots-RO1.rdk",
            "I": "Polishing-and-Sanding-with-Standard-Bots-RO1.png",
            "IS": "Polishing-and-Sanding-with-Standard-Bots-RO1-sm.png",
            "B": [
                "RobotiQ",
                "Standard Bots"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 54.6,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Standard Bots RO1"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Staubli-RX90B": {
            "N": "Polishing and Sanding with Staubli RX90B",
            "F": "Polishing-and-Sanding-with-Staubli-RX90B.rdk",
            "I": "Polishing-and-Sanding-with-Staubli-RX90B.png",
            "IS": "Polishing-and-Sanding-with-Staubli-RX90B-sm.png",
            "B": [
                "RobotiQ",
                "Staubli"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 58.2,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Staubli RX90B"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Staubli-TX2-60L": {
            "N": "Polishing and Sanding with Staubli TX2-60L",
            "F": "Polishing-and-Sanding-with-Staubli-TX2-60L.rdk",
            "I": "Polishing-and-Sanding-with-Staubli-TX2-60L.png",
            "IS": "Polishing-and-Sanding-with-Staubli-TX2-60L-sm.png",
            "B": [
                "RobotiQ",
                "Staubli"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 53.2,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Staubli TX2-60L"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-TM5S": {
            "N": "Polishing and Sanding with TM5S",
            "F": "Polishing-and-Sanding-with-TM5S.rdk",
            "I": "Polishing-and-Sanding-with-TM5S.png",
            "IS": "Polishing-and-Sanding-with-TM5S-sm.png",
            "B": [
                "RobotiQ",
                "Techman Robot"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 53.8,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "TM5S"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-uFactory-850": {
            "N": "Polishing and Sanding with uFactory 850",
            "F": "Polishing-and-Sanding-with-uFactory-850.rdk",
            "I": "Polishing-and-Sanding-with-uFactory-850.png",
            "IS": "Polishing-and-Sanding-with-uFactory-850-sm.png",
            "B": [
                "RobotiQ",
                "uFactory"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 54.0,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "uFactory 850"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-UR10": {
            "N": "Polishing and Sanding with UR10",
            "F": "Polishing-and-Sanding-with-UR10.rdk",
            "I": "Polishing-and-Sanding-with-UR10.png",
            "IS": "Polishing-and-Sanding-with-UR10-sm.png",
            "B": [
                "RobotiQ",
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 55.8,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "UR10"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-UR10e": {
            "N": "Polishing and Sanding with UR10e",
            "F": "Polishing-and-Sanding-with-UR10e.rdk",
            "I": "Polishing-and-Sanding-with-UR10e.png",
            "IS": "Polishing-and-Sanding-with-UR10e-sm.png",
            "B": [
                "RobotiQ",
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 54.5,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "UR10e"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-and-Sanding-with-Yaskawa-GP7": {
            "N": "Polishing and Sanding with Yaskawa GP7",
            "F": "Polishing-and-Sanding-with-Yaskawa-GP7.rdk",
            "I": "Polishing-and-Sanding-with-Yaskawa-GP7.png",
            "IS": "Polishing-and-Sanding-with-Yaskawa-GP7-sm.png",
            "B": [
                "RobotiQ",
                "Yaskawa Motoman"
            ],
            "AP": [
                "Curve Following",
                "Polishing",
                "Sanding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 53.9,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Yaskawa GP7"
            ],
            "TN": [
                "RobotiQ Sanding Kit"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Polishing-with-ABB-IRB-1200-7-0-7": {
            "N": "Polishing with ABB IRB 1200-7/0.7",
            "F": "Polishing-with-ABB-IRB-1200-7-0-7.rdk",
            "I": "Polishing-with-ABB-IRB-1200-7-0-7.png",
            "IS": "Polishing-with-ABB-IRB-1200-7-0-7-sm.png",
            "B": [
                "ABB",
                "DIY Robotics",
                "RoboDK"
            ],
            "AP": [
                "Curve Following",
                "Polishing"
            ],
            "T": [
                "Curve Follow Project",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool",
                "Success Story"
            ],
            "S": 71.8,
            "RC": 1,
            "TC": 1,
            "OC": 9,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "ABB IRB 1200-7/0.7"
            ],
            "ON": [
                "DIY Robotics Comet-44"
            ],
            "link": {
                "blogs": [
                    "https://robodk.com/blog/robodk-diy-ati-robotic-deburring-cell/"
                ]
            }
        },
        "Polishing-with-UR10": {
            "N": "Polishing with UR10",
            "F": "Polishing-with-UR10.rdk",
            "I": "Polishing-with-UR10.png",
            "IS": "Polishing-with-UR10-sm.png",
            "B": [
                "ATI",
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool",
                "Success Story"
            ],
            "S": 63.0,
            "RC": 1,
            "TC": 1,
            "OC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "UR10"
            ],
            "ON": [
                "Floor"
            ],
            "link": {
                "blogs": [
                    "https://robodk.com/blog/robot-orbital-polishing/"
                ]
            }
        },
        "Polishing-with-UR10e": {
            "N": "Polishing with UR10e",
            "F": "Polishing-with-UR10e.rdk",
            "I": "Polishing-with-UR10e.png",
            "IS": "Polishing-with-UR10e-sm.png",
            "B": [
                "FerRobotics",
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Polishing"
            ],
            "T": [
                "Curve Follow Project",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 93.6,
            "RC": 2,
            "TC": 2,
            "OC": 5,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "UR10e"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Sample-Station-with-Kinova-Gen3-6DOF-NoV": {
            "N": "Sample Station with Kinova Gen3 6DOF NoV",
            "F": "Sample-Station-with-Kinova-Gen3-6DOF-NoV.rdk",
            "I": "Sample-Station-with-Kinova-Gen3-6DOF-NoV.png",
            "IS": "Sample-Station-with-Kinova-Gen3-6DOF-NoV-sm.png",
            "B": [
                "Alt-Bionics",
                "Kinova",
                "RoboDK"
            ],
            "AP": [
                "Collaborative"
            ],
            "T": [
                "API",
                "Folder",
                "Mechanism",
                "Notes",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 51.2,
            "RC": 6,
            "TC": 2,
            "OC": 8,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "Kinova Gen3 6DOF NoV"
            ],
            "TN": [
                "Alt-Bionics Robotic Hand (Solid)"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Sample-Station-with-RoboDK-RDK-2200": {
            "N": "Sample Station with RoboDK RDK-2200",
            "F": "Sample-Station-with-RoboDK-RDK-2200.rdk",
            "I": "Sample-Station-with-RoboDK-RDK-2200.png",
            "IS": "Sample-Station-with-RoboDK-RDK-2200-sm.png",
            "B": [
                "RoboDK"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tutorial"
            ],
            "S": 112.3,
            "RC": 1,
            "OC": 7,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "RoboDK RDK-2200"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Synchronization-and-Washing-with-Fanuc-M-710iC-45M": {
            "N": "Synchronization and Washing with Fanuc M-710iC/45M",
            "F": "Synchronization-and-Washing-with-Fanuc-M-710iC-45M.rdk",
            "I": "Synchronization-and-Washing-with-Fanuc-M-710iC-45M.png",
            "IS": "Synchronization-and-Washing-with-Fanuc-M-710iC-45M-sm.png",
            "B": [
                "Fanuc",
                "Gudel"
            ],
            "AP": [
                "Synchronization",
                "Washing"
            ],
            "T": [
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Synchronization",
                "Target",
                "Tool",
                "Success Story"
            ],
            "S": 602.8,
            "RC": 4,
            "TC": 4,
            "OC": 10,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "Fanuc M-710iC/45M"
            ],
            "ON": [
                "Floor"
            ],
            "link": {
                "blogs": [
                    "https://robodk.com/blog/automated-airplane-washing/"
                ]
            }
        },
        "Synchronization-and-Welding": {
            "N": "Synchronization and Welding",
            "F": "Synchronization-and-Welding.rdk",
            "I": "Synchronization-and-Welding.png",
            "IS": "Synchronization-and-Welding-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Curve Following",
                "Synchronization",
                "Welding"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 123.5,
            "RC": 4,
            "TC": 3,
            "OC": 6,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Synchronization-and-Welding-with-ABB": {
            "N": "Synchronization-and-Welding-with-ABB",
            "F": "Synchronization-and-Welding-with-ABB.rdk",
            "I": "Synchronization-and-Welding-with-ABB.png",
            "IS": "Synchronization-and-Welding-with-ABB-sm.png",
            "B": [
                "ABB",
                "Fronius"
            ],
            "AP": [
                "Curve Following",
                "Synchronization",
                "Welding"
            ],
            "T": [
                "API",
                "Add-in",
                "Curve Follow Project",
                "Folder",
                "Mechanism",
                "Notes",
                "Program",
                "Python",
                "Script",
                "Synchronization",
                "Target",
                "Tool",
                "Tutorial"
            ],
            "S": 111.7,
            "RC": 2,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "ABB IRB 2600ID-8/2.00"
            ],
            "AN": [
                "ABB IRBP A250 D1000"
            ],
            "TN": [
                "Fronius MTB500i Welding Gun"
            ],
            "ON": [
                "Floor"
            ],
            "link": {
                "docs": [
                    "https://robodk.com/doc/en/Addin-Welding.html#AddinWelding"
                ]
            }
        },
        "Synchronization-and-Welding-with-ABB-02": {
            "N": "Synchronization and Welding with ABB #02",
            "F": "Synchronization-and-Welding-with-ABB-02.rdk",
            "I": "Synchronization-and-Welding-with-ABB-02.png",
            "IS": "Synchronization-and-Welding-with-ABB-02-sm.png",
            "B": [
                "ABB",
                "Fronius"
            ],
            "AP": [
                "Curve Following",
                "Synchronization",
                "Welding"
            ],
            "T": [
                "Add-in",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Synchronization",
                "Tool",
                "Tutorial"
            ],
            "S": 264.9,
            "RC": 2,
            "TC": 1,
            "OC": 7,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "ABB IRB 2600ID-8/2.00"
            ],
            "AN": [
                "ABB IRBP L2000 L3150"
            ],
            "TN": [
                "Fronius MTB500i Welding Gun"
            ],
            "link": {
                "docs": [
                    "https://robodk.com/doc/en/Addin-Welding.html#AddinWelding"
                ]
            }
        },
        "Synchronization-and-Welding-with-ABB-and-Lucas": {
            "N": "Synchronization and Welding with ABB and Lucas",
            "F": "Synchronization-and-Welding-with-ABB-and-Lucas.rdk",
            "I": "Synchronization-and-Welding-with-ABB-and-Lucas.png",
            "IS": "Synchronization-and-Welding-with-ABB-and-Lucas-sm.png",
            "B": [
                "ABB",
                "Fronius",
                "Lucas"
            ],
            "AP": [
                "Curve Following",
                "Synchronization",
                "Welding"
            ],
            "T": [
                "Add-in",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Synchronization",
                "Target",
                "Tool",
                "Tutorial"
            ],
            "S": 296.4,
            "RC": 3,
            "TC": 1,
            "OC": 5,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "ABB IRB 2600ID-8/2.00"
            ],
            "AN": [
                "ABB IRBP L2000 L3150",
                "Lucas RC2-YZ-1R"
            ],
            "TN": [
                "Fronius MTB500i Welding Gun"
            ],
            "link": {
                "docs": [
                    "https://robodk.com/doc/en/Addin-Welding.html#AddinWelding"
                ]
            }
        },
        "Synchronization-and-Welding-with-ABB-and-Lucas-02": {
            "N": "Synchronization and Welding with ABB and Lucas #02",
            "F": "Synchronization-and-Welding-with-ABB-and-Lucas-02.rdk",
            "I": "Synchronization-and-Welding-with-ABB-and-Lucas-02.png",
            "IS": "Synchronization-and-Welding-with-ABB-and-Lucas-02-sm.png",
            "B": [
                "ABB",
                "Fronius",
                "Lucas"
            ],
            "AP": [
                "Curve Following",
                "Synchronization",
                "Welding"
            ],
            "T": [
                "Add-in",
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Synchronization",
                "Target",
                "Tool",
                "Tutorial"
            ],
            "S": 296.4,
            "RC": 3,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "ABB IRB 2600ID-8/2.00"
            ],
            "AN": [
                "ABB IRBP L2000 L3150",
                "Lucas RC2-YZ-1R"
            ],
            "TN": [
                "Fronius MTB500i Welding Gun"
            ],
            "link": {
                "docs": [
                    "https://robodk.com/doc/en/Addin-Welding.html#AddinWelding"
                ]
            }
        },
        "Synchronization-and-Welding-with-ABB-Fanuc-and-KUKA": {
            "N": "Synchronization and Welding with ABB, Fanuc and KUKA",
            "F": "Synchronization-and-Welding-with-ABB-Fanuc-and-KUKA.rdk",
            "I": "Synchronization-and-Welding-with-ABB-Fanuc-and-KUKA.png",
            "IS": "Synchronization-and-Welding-with-ABB-Fanuc-and-KUKA-sm.png",
            "B": [
                "ABB",
                "Fanuc",
                "KUKA"
            ],
            "AP": [
                "Synchronization",
                "Welding"
            ],
            "T": [
                "API",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 89.6,
            "RC": 3,
            "TC": 3,
            "OC": 1,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "ABB IRB 1600ID-4/1.5",
                "Fanuc LR Mate 200iD/7L",
                "KUKA KR 6 R900 sixx"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Synchronization-and-Welding-with-ABB-IRB-2600ID-8-2-00": {
            "N": "Synchronization and Welding with ABB IRB 2600ID-8/2.00",
            "F": "Synchronization-and-Welding-with-ABB-IRB-2600ID-8-2-00.rdk",
            "I": "Synchronization-and-Welding-with-ABB-IRB-2600ID-8-2-00.png",
            "IS": "Synchronization-and-Welding-with-ABB-IRB-2600ID-8-2-00-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Curve Following",
                "Synchronization",
                "Welding"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Synchronization",
                "Target",
                "Tool"
            ],
            "S": 213.7,
            "RC": 4,
            "TC": 1,
            "OC": 9,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "ABB IRB 2600ID-8/2.00"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Synchronization-and-Welding-with-ABB-IRB-2600ID-8-2-00-02": {
            "N": "Synchronization and Welding with ABB IRB 2600ID-8/2.00 #02",
            "F": "Synchronization-and-Welding-with-ABB-IRB-2600ID-8-2-00-02.rdk",
            "I": "Synchronization-and-Welding-with-ABB-IRB-2600ID-8-2-00-02.png",
            "IS": "Synchronization-and-Welding-with-ABB-IRB-2600ID-8-2-00-02-sm.png",
            "B": [
                "ABB",
                "Fronius"
            ],
            "AP": [
                "Curve Following",
                "Synchronization",
                "Welding"
            ],
            "T": [
                "API",
                "Curve Follow Project",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Synchronization",
                "Target",
                "Tool"
            ],
            "S": 264.9,
            "RC": 4,
            "TC": 1,
            "OC": 6,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "ABB IRB 2600ID-8/2.00"
            ],
            "TN": [
                "Fronius MTB500i Welding Gun"
            ]
        },
        "Synchronization-and-Welding-with-KUKA-02": {
            "N": "Synchronization and Welding with KUKA #02",
            "F": "Synchronization-and-Welding-with-KUKA-02.rdk",
            "I": "Synchronization-and-Welding-with-KUKA-02.png",
            "IS": "Synchronization-and-Welding-with-KUKA-02-sm.png",
            "B": [
                "ABICOR BINZEL",
                "KUKA"
            ],
            "AP": [
                "Curve Following",
                "Synchronization",
                "Welding"
            ],
            "T": [
                "Curve Follow Project",
                "Folder",
                "Mechanism",
                "Notes",
                "Program",
                "Synchronization",
                "Target",
                "Tool"
            ],
            "S": 209.1,
            "RC": 2,
            "TC": 1,
            "OC": 12,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "KUKA KR 20 R3100"
            ],
            "AN": [
                "KUKA KP2-SV2600 HW"
            ],
            "TN": [
                "Abicor Binzel 45deg Welding Gun"
            ],
            "ON": [
                "Floor",
                "Pedestal H24in (Type 1)"
            ]
        },
        "Synchronization-with-ABB-IRB-120-3-0-6": {
            "N": "Synchronization with ABB IRB 120-3/0.6",
            "F": "Synchronization-with-ABB-IRB-120-3-0-6.rdk",
            "I": "Synchronization-with-ABB-IRB-120-3-0-6.png",
            "IS": "Synchronization-with-ABB-IRB-120-3-0-6-sm.png",
            "B": [
                "ABB"
            ],
            "AP": [
                "Synchronization"
            ],
            "T": [
                "API",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Python",
                "Script"
            ],
            "S": 41.2,
            "RC": 1,
            "OC": 7,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "ABB IRB 120-3/0.6"
            ]
        },
        "Synchronization-with-ABB-IRB-1600-8-1-45": {
            "N": "Synchronization with ABB IRB 1600-8/1.45",
            "F": "Synchronization-with-ABB-IRB-1600-8-1-45.rdk",
            "I": "Synchronization-with-ABB-IRB-1600-8-1-45.png",
            "IS": "Synchronization-with-ABB-IRB-1600-8-1-45-sm.png",
            "B": [
                "ABB",
                "Creaform"
            ],
            "AP": [
                "Synchronization"
            ],
            "T": [
                "Mechanism",
                "Notes",
                "Synchronization",
                "Tool"
            ],
            "S": 103.0,
            "RC": 2,
            "TC": 2,
            "OC": 2,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "ABB IRB 1600-8/1.45"
            ],
            "TN": [
                "Creaform MetraSCAN",
                "Creaform MetraSCAN Field-of-view"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Synchronization-with-KUKA-KR-210-2": {
            "N": "Synchronization with KUKA KR 210-2",
            "F": "Synchronization-with-KUKA-KR-210-2.rdk",
            "I": "Synchronization-with-KUKA-KR-210-2.png",
            "IS": "Synchronization-with-KUKA-KR-210-2-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Synchronization"
            ],
            "T": [
                "API",
                "Frame",
                "Mechanism",
                "Notes",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool",
                "Success Story"
            ],
            "S": 195.5,
            "RC": 3,
            "TC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "KUKA KR 210-2"
            ],
            "link": {
                "blogs": [
                    "https://robodk.com/blog/online-programming/"
                ]
            }
        },
        "Synchronization-with-KUKA-KR-210-2-02": {
            "N": "Synchronization with KUKA KR 210-2 #02",
            "F": "Synchronization-with-KUKA-KR-210-2-02.rdk",
            "I": "Synchronization-with-KUKA-KR-210-2-02.png",
            "IS": "Synchronization-with-KUKA-KR-210-2-02-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Synchronization"
            ],
            "T": [
                "API",
                "Frame",
                "Mechanism",
                "Notes",
                "Python",
                "Script",
                "Target",
                "Tool",
                "Success Story"
            ],
            "S": 212.8,
            "RC": 3,
            "TC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "KUKA KR 210-2"
            ],
            "link": {
                "blogs": [
                    "https://robodk.com/blog/online-programming/"
                ]
            }
        },
        "Welding-with-ABB-IRB-1660-4-1-55": {
            "N": "Welding with ABB IRB 1660-4/1.55",
            "F": "Welding-with-ABB-IRB-1660-4-1-55.rdk",
            "I": "Welding-with-ABB-IRB-1660-4-1-55.png",
            "IS": "Welding-with-ABB-IRB-1660-4-1-55-sm.png",
            "B": [
                "ABB",
                "Fronius"
            ],
            "AP": [
                "Welding"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Template",
                "Tool"
            ],
            "S": 110.0,
            "RC": 1,
            "TC": 1,
            "OC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "ABB IRB 1660-4/1.55"
            ],
            "TN": [
                "Fronius MTB500i Welding Gun"
            ],
            "ON": [
                "Floor",
                "Pedestal H500mm (Type 2)",
                "Table 1400x800x800mm"
            ]
        },
        "Welding-with-ABB-IRB-2600ID-8-2-00": {
            "N": "Welding-with-ABB-IRB-2600ID-8-2-00",
            "F": "Welding-with-ABB-IRB-2600ID-8-2-00.rdk",
            "I": "Welding-with-ABB-IRB-2600ID-8-2-00.png",
            "IS": "Welding-with-ABB-IRB-2600ID-8-2-00-sm.png",
            "B": [
                "ABB",
                "Fronius"
            ],
            "AP": [
                "Curve Following",
                "Welding"
            ],
            "T": [
                "Add-in",
                "Curve Follow Project",
                "Folder",
                "Mechanism",
                "Notes",
                "Program",
                "Target",
                "Tool",
                "Tutorial"
            ],
            "S": 142.0,
            "RC": 1,
            "TC": 1,
            "OC": 7,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "ABB IRB 2600ID-8/2.00"
            ],
            "TN": [
                "Fronius MTB500i Welding Gun"
            ],
            "ON": [
                "Floor",
                "Table 1200x1000mm (Welding)"
            ],
            "link": {
                "docs": [
                    "https://robodk.com/doc/en/Addin-Welding.html#AddinWelding"
                ]
            }
        },
        "Welding-with-Comau-Smart5-NJ-130-2-6": {
            "N": "Welding with Comau Smart5 NJ 130-2.6",
            "F": "Welding-with-Comau-Smart5-NJ-130-2-6.rdk",
            "I": "Welding-with-Comau-Smart5-NJ-130-2-6.png",
            "IS": "Welding-with-Comau-Smart5-NJ-130-2-6-sm.png",
            "B": [
                "Comau",
                "OBARA"
            ],
            "AP": [
                "Welding"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool",
                "Success Story",
                "Tutorial"
            ],
            "S": 252.6,
            "RC": 2,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "Comau Smart5 NJ 130-2.6"
            ],
            "TN": [
                "OBARA Spot Welding Gun"
            ],
            "ON": [
                "Floor"
            ],
            "link": {
                "blogs": [
                    "https://robodk.com/blog/robodk-comau-partnership/"
                ],
                "docs": [
                    "https://robodk.com/doc/en/Example-Spot-Welding.html#SpotWeldingPoints",
                    "https://robodk.com/doc/en/RRS.html#RRS"
                ]
            }
        },
        "Welding-with-Dobot-CR10": {
            "N": "Welding with Dobot CR10",
            "F": "Welding-with-Dobot-CR10.rdk",
            "I": "Welding-with-Dobot-CR10.png",
            "IS": "Welding-with-Dobot-CR10-sm.png",
            "B": [
                "ABICOR BINZEL",
                "Dobot"
            ],
            "AP": [
                "Collaborative",
                "Welding"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Template",
                "Tool"
            ],
            "S": 107.5,
            "RC": 1,
            "TC": 1,
            "OC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Dobot CR10"
            ],
            "ON": [
                "Floor",
                "Pedestal H24in (Type 1)",
                "Table 1400x800x800mm"
            ]
        },
        "Welding-with-Estun-ER8-1450-H": {
            "N": "Welding with Estun ER8-1450-H",
            "F": "Welding-with-Estun-ER8-1450-H.rdk",
            "I": "Welding-with-Estun-ER8-1450-H.png",
            "IS": "Welding-with-Estun-ER8-1450-H-sm.png",
            "B": [
                "Estun"
            ],
            "AP": [
                "Welding"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Template",
                "Tool"
            ],
            "S": 108.8,
            "RC": 1,
            "TC": 1,
            "OC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Estun ER8-1450-H"
            ],
            "TN": [
                "Generic Welding Gun (Through-arm)"
            ],
            "ON": [
                "Floor",
                "Pedestal H500mm (Type 2)",
                "Table 1400x800x800mm"
            ]
        },
        "Welding-with-Fanuc": {
            "N": "Welding with Fanuc",
            "F": "Welding-with-Fanuc.rdk",
            "I": "Welding-with-Fanuc.png",
            "IS": "Welding-with-Fanuc-sm.png",
            "B": [
                "Fanuc",
                "Fronius"
            ],
            "AP": [
                "Curve Following",
                "Welding"
            ],
            "T": [
                "Curve Follow Project",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 115.1,
            "RC": 6,
            "TC": 4,
            "OC": 80,
            "RT": [
                "6 DOF",
                "Gripper"
            ],
            "RN": [
                "Fanuc ARC Mate 120iB",
                "Fanuc M-10iD/12"
            ],
            "TN": [
                "Fronius MTB500i Welding Gun"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Welding-with-Fanuc-ARC-Mate-100iD": {
            "N": "Welding with Fanuc ARC Mate 100iD",
            "F": "Welding-with-Fanuc-ARC-Mate-100iD.rdk",
            "I": "Welding-with-Fanuc-ARC-Mate-100iD.png",
            "IS": "Welding-with-Fanuc-ARC-Mate-100iD-sm.png",
            "B": [
                "Fanuc"
            ],
            "AP": [
                "Welding"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Template",
                "Tool"
            ],
            "S": 107.0,
            "RC": 1,
            "TC": 1,
            "OC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Fanuc ARC Mate 100iD"
            ],
            "TN": [
                "Generic Welding Gun (Through-arm)"
            ],
            "ON": [
                "Floor",
                "Pedestal H500mm (Type 2)",
                "Table 1400x800x800mm"
            ]
        },
        "Welding-with-Fanuc-ARC-Mate-120iB-10L": {
            "N": "Welding with Fanuc ARC Mate 120iB/10L",
            "F": "Welding-with-Fanuc-ARC-Mate-120iB-10L.rdk",
            "I": "Welding-with-Fanuc-ARC-Mate-120iB-10L.png",
            "IS": "Welding-with-Fanuc-ARC-Mate-120iB-10L-sm.png",
            "B": [
                "Fanuc",
                "OTC Daihen"
            ],
            "AP": [
                "Curve Following",
                "Welding"
            ],
            "T": [
                "API",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 96.2,
            "RC": 1,
            "TC": 1,
            "OC": 4,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Fanuc ARC Mate 120iB/10L"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Welding-with-Fanuc-ARC-Mate-120iB-10L-02": {
            "N": "Welding with Fanuc ARC Mate 120iB/10L #02",
            "F": "Welding-with-Fanuc-ARC-Mate-120iB-10L-02.rdk",
            "I": "Welding-with-Fanuc-ARC-Mate-120iB-10L-02.png",
            "IS": "Welding-with-Fanuc-ARC-Mate-120iB-10L-02-sm.png",
            "B": [
                "Fanuc",
                "OTC Daihen"
            ],
            "AP": [
                "Curve Following",
                "Welding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Target",
                "Tool",
                "Tutorial"
            ],
            "S": 91.7,
            "RC": 1,
            "TC": 1,
            "OC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Fanuc ARC Mate 120iB/10L"
            ],
            "ON": [
                "Floor"
            ],
            "link": {
                "docs": [
                    "https://robodk.com/doc/en/Robot-Machining.html#RobCutting"
                ]
            }
        },
        "Welding-with-Fanuc-ARC-Mate-120iC": {
            "N": "Welding with Fanuc ARC Mate 120iC",
            "F": "Welding-with-Fanuc-ARC-Mate-120iC.rdk",
            "I": "Welding-with-Fanuc-ARC-Mate-120iC.png",
            "IS": "Welding-with-Fanuc-ARC-Mate-120iC-sm.png",
            "B": [
                "Fanuc"
            ],
            "AP": [
                "Welding"
            ],
            "T": [
                "API",
                "Frame",
                "Mechanism",
                "Notes",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 54.2,
            "RC": 1,
            "TC": 1,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Fanuc ARC Mate 120iC"
            ]
        },
        "Welding-with-KUKA-KR-16-3": {
            "N": "Welding with KUKA KR 16 3",
            "F": "Welding-with-KUKA-KR-16-3.rdk",
            "I": "Welding-with-KUKA-KR-16-3.png",
            "IS": "Welding-with-KUKA-KR-16-3-sm.png",
            "B": [
                "ABICOR BINZEL",
                "KUKA"
            ],
            "AP": [
                "Curve Following",
                "Welding"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Tool"
            ],
            "S": 108.7,
            "RC": 1,
            "TC": 1,
            "OC": 3,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "KUKA KR 16 3"
            ],
            "ON": [
                "Floor",
                "Table 1400x800x800mm"
            ]
        },
        "Welding-with-KUKA-KR-120-R2900-extra": {
            "N": "Welding with KUKA KR 120 R2900 extra",
            "F": "Welding-with-KUKA-KR-120-R2900-extra.rdk",
            "I": "Welding-with-KUKA-KR-120-R2900-extra.png",
            "IS": "Welding-with-KUKA-KR-120-R2900-extra-sm.png",
            "B": [
                "KUKA"
            ],
            "AP": [
                "Curve Following",
                "Welding"
            ],
            "T": [
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Point Follow Project",
                "Program",
                "Target",
                "Tool"
            ],
            "S": 125.5,
            "RC": 2,
            "TC": 2,
            "OC": 3,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "KUKA KR 120 R2900 extra"
            ],
            "ON": [
                "Floor",
                "Pedestal H650mm (Type 2)"
            ]
        },
        "Welding-with-Panasonic-TA-1600": {
            "N": "Welding with Panasonic TA-1600",
            "F": "Welding-with-Panasonic-TA-1600.rdk",
            "I": "Welding-with-Panasonic-TA-1600.png",
            "IS": "Welding-with-Panasonic-TA-1600-sm.png",
            "B": [
                "Panasonic",
                "Rainbow Robotics"
            ],
            "AP": [
                "Welding"
            ],
            "T": [
                "API",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 110.7,
            "RC": 5,
            "TC": 4,
            "OC": 1,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "Panasonic TA-1600"
            ]
        },
        "Welding-with-TM5X-700": {
            "N": "Welding with TM5X-700",
            "F": "Welding-with-TM5X-700.rdk",
            "I": "Welding-with-TM5X-700.png",
            "IS": "Welding-with-TM5X-700-sm.png",
            "B": [
                "ABICOR BINZEL",
                "Techman Robot"
            ],
            "AP": [
                "Collaborative",
                "Curve Following",
                "Welding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 48.2,
            "RC": 1,
            "TC": 1,
            "OC": 2,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "TM5X-700"
            ],
            "ON": [
                "Table 1400x800x800mm"
            ]
        },
        "Welding-with-UR10e": {
            "N": "Welding with UR10e",
            "F": "Welding-with-UR10e.rdk",
            "I": "Welding-with-UR10e.png",
            "IS": "Welding-with-UR10e-sm.png",
            "B": [
                "Lorch",
                "Renishaw",
                "Universal Robots"
            ],
            "AP": [
                "Collaborative",
                "Welding"
            ],
            "T": [
                "API",
                "Ballbar Validation",
                "Folder",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Python",
                "Script",
                "Target",
                "Tool"
            ],
            "S": 111.3,
            "RC": 3,
            "TC": 1,
            "OC": 9,
            "RT": [
                "6 DOF",
                "Mechanism"
            ],
            "RN": [
                "UR10e"
            ],
            "ON": [
                "Floor"
            ]
        },
        "Welding-with-Yaskawa-GP7": {
            "N": "Welding with Yaskawa GP7",
            "F": "Welding-with-Yaskawa-GP7.rdk",
            "I": "Welding-with-Yaskawa-GP7.png",
            "IS": "Welding-with-Yaskawa-GP7-sm.png",
            "B": [
                "Yaskawa Motoman"
            ],
            "AP": [
                "Curve Following",
                "Welding"
            ],
            "T": [
                "Curve Follow Project",
                "Frame",
                "Mechanism",
                "Notes",
                "Object",
                "Program",
                "Tool"
            ],
            "S": 395.7,
            "RC": 9,
            "TC": 9,
            "OC": 10,
            "RT": [
                "6 DOF"
            ],
            "RN": [
                "Yaskawa GP7"
            ],
            "ON": [
                "Floor"
            ]
        }
    }
}